var _style, _rect, _g, _circle, _g2, _g3, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContactQr(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1155 1155",
    style: {
      enableBackground: "new 0 0 1155 1155"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;fill:#FFFFFF;}\n\t.st1{fill:none;}\n\t.st2{fill:#161513;}\n\t.st3{fill:#C1966F;}\n\t.st4{fill-rule:evenodd;clip-rule:evenodd;fill:#C1966F;}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 1155,
    height: 1155
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(70,70)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(315,0) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(350,0) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(385,0) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(420,0) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(490,0) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(525,0) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(595,0) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(630,0) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(665,0) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(420,35) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(455,35) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(525,35) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(630,35) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(315,70) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(350,70) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(420,70) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(490,70) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(560,70) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(595,70) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(700,70) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(350,105) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(385,105) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(490,105) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(525,105) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(630,105) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(665,105) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(700,105) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(455,140) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(525,140) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(560,140) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(280,175) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(315,175) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(385,175) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(420,175) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(455,175) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(525,175) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(630,175) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(665,175) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(700,175) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(280,210) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(350,210) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(420,210) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(490,210) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(560,210) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(630,210) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(700,210) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(315,245) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(350,245) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(385,245) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(525,245) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(595,245) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(630,245) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(665,245) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(700,245) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,280) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(105,280) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(175,280) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(210,280) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(280,280) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(315,280) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(420,280) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(665,280) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(735,280) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(805,280) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,315) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(35,315) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(70,315) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(175,315) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(245,315) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(280,315) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(315,315) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(350,315) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(560,315) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(595,315) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(630,315) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(700,315) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(735,315) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(770,315) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(875,315) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(980,315) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,350) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(140,350) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(175,350) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(210,350) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(245,350) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(280,350) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(385,350) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(420,350) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(595,350) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(630,350) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(665,350) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(840,350) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(875,350) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(910,350) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(945,350) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,385) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(70,385) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(175,385) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(245,385) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(280,385) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(385,385) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(490,385) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(560,385) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(735,385) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(770,385) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(805,385) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(840,385) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(910,385) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(945,385) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(70,420) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(140,420) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(210,420) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(420,420) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(525,420) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(560,420) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(595,420) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(665,420) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(700,420) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(735,420) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(770,420) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(875,420) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(945,420) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(980,420) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(35,455) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(105,455) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(140,455) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(245,455) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(315,455) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(385,455) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(595,455) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(630,455) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(665,455) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(700,455) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,490) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(105,490) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(210,490) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(280,490) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(315,490) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(350,490) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(420,490) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(630,490) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(840,490) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(875,490) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(910,490) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(945,490) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(980,490) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,525) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(35,525) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(105,525) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(140,525) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(315,525) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(385,525) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(420,525) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(455,525) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(490,525) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(560,525) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(595,525) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(630,525) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(875,525) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(945,525) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(105,560) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(210,560) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(315,560) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(350,560) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(420,560) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(455,560) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(490,560) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(525,560) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(595,560) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(630,560) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(665,560) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(700,560) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(735,560) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(945,560) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(105,595) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(140,595) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(280,595) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(350,595) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(385,595) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(560,595) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(595,595) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(735,595) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(770,595) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(805,595) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(875,595) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(980,595) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,630) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(70,630) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(105,630) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(210,630) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(245,630) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(280,630) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(315,630) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(385,630) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(455,630) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(595,630) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(700,630) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(770,630) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(840,630) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(945,630) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(980,630) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(140,665) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(245,665) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(315,665) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(455,665) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(560,665) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(595,665) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(665,665) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(735,665) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(805,665) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(840,665) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(945,665) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(980,665) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,700) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(70,700) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(105,700) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(140,700) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(175,700) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(210,700) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(315,700) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(420,700) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(490,700) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(560,700) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(700,700) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(735,700) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(770,700) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(805,700) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(840,700) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(910,700) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(280,735) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(315,735) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(350,735) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(420,735) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(455,735) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(560,735) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(595,735) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(700,735) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(840,735) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(910,735) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(945,735) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(980,735) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(350,770) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(385,770) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(420,770) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(455,770) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(490,770) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(560,770) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(595,770) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(630,770) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(700,770) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(770,770) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(840,770) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(945,770) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(280,805) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(315,805) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(350,805) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(420,805) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(455,805) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(560,805) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(630,805) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(700,805) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(840,805) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(875,805) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(910,805) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(945,805) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(980,805) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(315,840) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(385,840) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(420,840) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(490,840) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(525,840) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(560,840) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(595,840) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(700,840) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(735,840) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(770,840) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(805,840) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(840,840) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(945,840) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(980,840) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(280,875) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(315,875) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(350,875) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(490,875) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(560,875) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(665,875) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(770,875) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(805,875) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(840,875) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(875,875) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(910,875) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(945,875) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(350,910) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(420,910) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(455,910) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(490,910) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(665,910) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(840,910) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(875,910) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(910,910) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(980,910) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(315,945) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(350,945) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(385,945) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(455,945) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(490,945) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(525,945) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(560,945) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(595,945) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(630,945) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(700,945) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(770,945) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(840,945) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(945,945) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(280,980) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(315,980) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(385,980) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(420,980) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(455,980) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(490,980) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(525,980) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(595,980) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(700,980) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(735,980) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(770,980) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(840,980) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(945,980) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,0) scale(2.45, 2.45)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 15,
    className: "st1",
    width: 70,
    height: 70
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85,0H15H0v15v70v15h15h70h15V85V15V0H85z M85,85H15V15h70V85z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(770,0) scale(2.45, 2.45)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 15,
    className: "st1",
    width: 70,
    height: 70
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85,0H15H0v15v70v15h15h70h15V85V15V0H85z M85,85H15V15h70V85z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,770) scale(2.45, 2.45)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 15,
    className: "st1",
    width: 70,
    height: 70
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85,0H15H0v15v70v15h15h70h15V85V15V0H85z M85,85H15V15h70V85z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(70,70) scale(1.05, 1.05)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(840,70) scale(1.05, 1.05)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(70,840) scale(1.05, 1.05)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 588,
    cy: 577.5,
    r: 133
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M527,510.6l-0.1,0l0,0c0-0.7-0.1-1.4-0.4-2c0.6-1.9,0.5-4.1-0.4-5.9l-0.2-0.3l-0.1-3.1l-2.4,0.1l-2.4,0.1 l0.1,3.1l-0.1,0.3c-0.7,1.9-0.7,4.1,0.1,5.9c-0.3,0.6-0.3,1.4-0.2,2.1l0,0l-0.1,0c-2.2,0.6-3.7,3-3.6,5.7l0.9,19.7 c0,0.7,0.5,1.2,1.1,1.1l5.9-0.3l5.9-0.3c0.6,0,1-0.6,1-1.2l-0.9-19.7C530.9,513.3,529.2,511,527,510.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M526.9,511.1l-0.2,0c-0.2,0-0.3-0.2-0.3-0.4l0-0.2c0-0.6-0.1-1.2-0.3-1.8l0,0c-0.1-0.1-0.1-0.2,0-0.4l0,0 c0.6-1.8,0.4-3.8-0.4-5.6l-0.2-0.4l-0.1-2.7l-3.8,0.2l0.1,2.7l-0.2,0.4c-0.7,1.8-0.6,3.8,0.1,5.6l0,0c0.1,0.1,0,0.3,0,0.4 c-0.2,0.6-0.3,1.2-0.2,1.8l0,0.2c0,0.2-0.1,0.3-0.3,0.4l-0.2,0.1c-0.9,0.3-1.8,0.9-2.4,1.9c-0.6,0.9-0.9,2.1-0.8,3.3l0.9,19.7 c0,0.4,0.3,0.7,0.5,0.7l11.9-0.5c0.3,0,0.5-0.3,0.5-0.7l-0.9-19.7c-0.1-1.2-0.5-2.3-1.1-3.2C528.8,511.8,527.9,511.3,526.9,511.1z "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 517.5,
    y: 518.2,
    transform: "matrix(0.9991 -4.343156e-02 4.343156e-02 0.9991 -22.2525 23.2715)",
    className: "st3",
    width: 13.9,
    height: 11
  }), /*#__PURE__*/React.createElement("rect", {
    x: 518,
    y: 518.2,
    transform: "matrix(0.9991 -4.343156e-02 4.343156e-02 0.9991 -22.2525 23.2715)",
    className: "st3",
    width: 12.9,
    height: 11
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M527.4,519.3l-6,0.3c0,1.2-0.9,2.3-2.1,2.3l0.2,4.2c1.2,0,2.3,0.9,2.3,2.1l6-0.3c0-1.2,0.8-2.1,1.9-2.3 l-0.2-4.2C528.4,521.4,527.4,520.4,527.4,519.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M527,519.8l-5.1,0.2c-0.2,1.1-1,2-2.1,2.3l0.1,3.3c1.1,0.2,2,1,2.3,2.1l5.1-0.2c0.2-1,0.9-1.9,1.9-2.2 l-0.1-3.4C528,521.6,527.2,520.8,527,519.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M525.9,502.2l-0.1-3.1l-2.4,0.1l-2.4,0.1l0.1,3.1l-0.1,0.3c-0.4,1.2-0.6,2.5-0.4,3.8l6.3-0.3 c0-1.3-0.2-2.6-0.8-3.7L525.9,502.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M525.9,502.2l-0.1-3.1l-2.4,0.1l-2.4,0.1l0.1,3.1l-0.1,0.3c-0.4,1.2-0.6,2.5-0.4,3.8l0.5,0 c-0.1-1.1,0.1-2.6,0.4-3.6l0.2-0.4l-0.1-2.7l3.8-0.2l0.1,2.7l0.2,0.4c0.4,0.9,0.7,2.5,0.7,3.5l0.5,0c0-1.3-0.2-2.6-0.8-3.7 L525.9,502.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M525.3,496.7l-4.1,0.2c-0.3,0-0.6,0.3-0.6,0.6l0.1,1.9c0,0.1,0.1,0.2,0.2,0.2l4.9-0.2c0.1,0,0.2-0.1,0.2-0.2 l-0.1-1.9C525.9,497,525.6,496.7,525.3,496.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M525,497.3l-0.8,0c-0.1,0-0.2,0.1-0.2,0.2l0.1,1.2c0,0.1,0.1,0.2,0.2,0.2l0.8,0c0.1,0,0.2-0.1,0.2-0.2 l-0.1-1.2C525.2,497.4,525.1,497.3,525,497.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M523.7,497.4l-0.2,0c-0.1,0-0.2,0.1-0.2,0.2l0.1,1.2c0,0.1,0.1,0.2,0.2,0.2l0.2,0c0.1,0,0.2-0.1,0.2-0.2 l-0.1-1.2C523.9,497.4,523.8,497.4,523.7,497.4z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 517.7,
    y: 517.8,
    transform: "matrix(0.9991 -4.343156e-02 4.343156e-02 0.9991 -22.0031 23.2552)",
    className: "st2",
    width: 12.9,
    height: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 517.2,
    y: 518,
    transform: "matrix(0.9991 -4.343156e-02 4.343156e-02 0.9991 -22.022 22.9649)",
    className: "st3",
    width: 0.5,
    height: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 530.6,
    y: 517.5,
    transform: "matrix(0.9991 -4.343156e-02 4.343156e-02 0.9991 -21.9841 23.5456)",
    className: "st3",
    width: 0.5,
    height: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 518.2,
    y: 529.2,
    transform: "matrix(0.9991 -4.343156e-02 4.343156e-02 0.9991 -22.5019 23.2879)",
    className: "st2",
    width: 12.9,
    height: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 517.7,
    y: 529.5,
    transform: "matrix(0.9991 -4.343156e-02 4.343156e-02 0.9991 -22.5209 22.9975)",
    className: "st3",
    width: 0.5,
    height: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 531.1,
    y: 529,
    transform: "matrix(0.9991 -4.343156e-02 4.343156e-02 0.9991 -22.483 23.5782)",
    className: "st3",
    width: 0.5,
    height: 0.5
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_1_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M606.6,537.6c0-0.1,0-0.1-0.1-0.1c0,0,0-0.1,0-0.1c-0.3-0.5-0.4-1.1-0.6-1.6c-0.1-0.4-0.2-0.7-0.2-1.1 c0,0,0-0.1,0-0.1c-0.2-0.5-0.1-0.9-0.1-1.4c0-0.1,0.1-0.3,0.1-0.4c0-0.3,0.1-0.6,0.2-0.9c0.2-0.6,0.5-1.1,0.9-1.6c0,0,0.1,0,0.1,0 s0.1,0,0.1,0.1c0,0,0,0,0,0.1c-0.1,0.1-0.2,0.3-0.3,0.4c-0.5,0.7-0.8,1.4-0.9,2.2c0,0.1,0,0.1,0,0.2c-0.1,0.1-0.1,0.3-0.1,0.5 c0,0.3,0,0.6,0.1,0.9c0,0.1,0,0.1,0,0.2c0,0.2,0,0.3,0.1,0.5c0.1,0.2,0.1,0.3,0.1,0.5c0.1,0.3,0.3,0.6,0.4,0.8 c0,0.1,0.1,0.1,0.1,0.1c0,0,0,0,0,0c0,0,0-0.1,0-0.1c0-0.1-0.1-0.2-0.1-0.3c0-0.4-0.1-0.8,0-1.1c0-0.2,0-0.3,0.1-0.5 c0.1-0.5,0.3-1,0.5-1.5c0.3-0.8,0.8-1.4,1.4-2c0.5-0.4,1-0.8,1.6-0.9c0.2,0,0.3-0.1,0.5-0.1c0.3,0,0.7,0.1,1,0.2 c0.7,0.3,1.3,0.7,1.7,1.3c0.1,0.1,0.2,0.3,0.3,0.4c0,0,0.1,0.1,0.1,0.1h0c0,0,0,0,0-0.1c0-0.2-0.1-0.3-0.1-0.5 c-0.1-0.4-0.3-0.8-0.6-1.1c-0.1-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.2-0.3-0.4-0.4c-0.3-0.3-0.7-0.4-1.1-0.6c-0.4-0.1-0.8-0.2-1.2-0.3 c-0.1,0-0.1,0-0.2,0c-0.5,0-1,0-1.5,0.1c-0.2,0.1-0.4,0.1-0.7,0.2c-0.1,0-0.2,0.1-0.3,0.1c-0.1,0-0.1,0-0.2,0 c-0.1,0-0.1-0.1-0.1-0.2c0.1-0.1,0.2-0.2,0.3-0.2c0.5-0.2,1-0.4,1.5-0.5c0.4-0.1,0.7-0.1,1.1-0.1c0.4,0,0.8,0.1,1.1,0.2 c0,0,0.1,0,0.1,0c0.2,0.1,0.4,0.1,0.6,0.2c0.6,0.3,1.1,0.7,1.5,1.2c0.2,0.3,0.4,0.6,0.5,1c0.1,0.4,0.3,0.8,0.3,1.2 c0,0.2,0,0.3,0.1,0.5c0,0.2,0,0.4,0,0.6c-0.1,0.3-0.1,0.7-0.2,1c0,0.1,0,0.2,0,0.3c0,0-0.1,0-0.1,0.1c0,0,0,0.1,0,0.1 c0,0,0,0,0-0.1c0,0,0-0.1,0-0.1c0,0,0.1,0,0.1,0c0.1-0.1,0.2-0.3,0.3-0.5c0.2-0.3,0.3-0.7,0.3-1.1c0-0.5,0-1,0-1.6 c0-0.3-0.1-0.6-0.1-0.9c0-0.1,0-0.1-0.1-0.2c-0.2-0.3-0.3-0.7-0.5-1c-0.1-0.2-0.3-0.4-0.4-0.6c-0.1-0.1-0.2-0.2-0.3-0.3 c-0.4-0.5-0.9-0.9-1.5-1.2c-0.4-0.2-0.8-0.3-1.2-0.5c-0.3-0.1-0.5-0.2-0.8,0c0,0,0,0,0,0c0,0,0-0.1,0-0.1c0.1-0.1,0.3-0.2,0.4-0.2 c0.2,0,0.3,0,0.5,0c0.4,0.1,0.7,0.2,1.1,0.3c0.3,0.1,0.5,0.2,0.7,0.4c0.5,0.3,0.9,0.6,1.3,1c0.2,0.2,0.4,0.4,0.5,0.5 c0.1,0.1,0.2,0.2,0.2,0.3c0.2,0.4,0.4,0.7,0.6,1.1c0,0.1,0.1,0.2,0.1,0.3c0.1,0.4,0.2,0.8,0.1,1.2c0,0.4,0,0.9,0,1.3 c0,0.3-0.1,0.6-0.2,0.9c-0.2,0.5-0.4,1-0.7,1.4c-0.2,0.3-0.4,0.5-0.6,0.8c0,0,0,0,0,0c0,0,0.1,0,0.1,0c0.1,0,0.1,0,0.2-0.1 c0.2-0.1,0.3-0.2,0.5-0.3c0.2-0.1,0.4-0.3,0.6-0.6c0.3-0.4,0.5-0.9,0.7-1.3c0,0,0,0,0-0.1c0.2-0.6,0.3-1.2,0.3-1.9 c0-0.1,0-0.2,0-0.3c0-0.3-0.1-0.6-0.2-0.9c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.4-0.4-0.7-0.5-1c-0.2-0.4-0.4-0.7-0.6-1 c-0.1-0.2-0.3-0.3-0.4-0.5c-0.3-0.3-0.6-0.6-0.8-1c0.1-0.1,0.1-0.1,0.2,0c0.1,0.1,0.2,0.2,0.3,0.3c0.7,0.8,1.5,1.5,2,2.5 c0,0,0,0,0,0c0,0,0,0,0,0c0-0.2-0.1-0.3-0.1-0.5c-0.1-0.6-0.4-1.1-0.8-1.6c-0.1-0.1-0.2-0.3-0.3-0.4c-0.3-0.3-0.5-0.7-0.8-1 c-0.4-0.6-0.7-1.2-0.9-1.9c0-0.1,0-0.2,0-0.3c0-0.2,0-0.4,0.1-0.6c0,0-0.1-0.1-0.1-0.1c-0.5,0-1,0-1.4,0.3c0,0-0.1,0-0.1,0 c0,0-0.1,0-0.1-0.1c0,0,0-0.1,0-0.1c0,0,0-0.1,0.1-0.1c0.2-0.2,0.4-0.3,0.6-0.4c0.6-0.2,1.2-0.3,1.9-0.3c0.2,0,0.3,0,0.5,0.1 c0.1,0,0.2,0.1,0.3,0c0,0.1,0,0.1,0.1,0.1c0,0,0.1,0,0.2,0c0,0,0,0,0,0c0,0,0,0,0.1,0c0,0,0,0,0,0c0,0,0,0,0,0 c0-0.1-0.1-0.1-0.2-0.1c0-0.1,0-0.1-0.1-0.1c-0.5-0.4-1.1-0.7-1.7-0.9c-0.7-0.2-1.4-0.4-2.1-0.5c-0.1,0-0.1-0.1-0.1-0.1 c0,0,0-0.1,0.1-0.1c0.4,0,0.7,0,1.1,0.1c0.5,0.1,1,0.2,1.5,0.4c0.2,0.1,0.4,0.1,0.5,0.2c0.3,0.2,0.6,0.4,0.9,0.6 c0.1,0.1,0.2,0.1,0.2,0.2c0,0,0.1,0,0.1,0c0,0,0,0.1,0,0.1c0,0,0,0,0,0c0,0,0-0.1-0.1,0c0-0.1,0-0.1,0-0.2c-0.2-0.4-0.5-0.7-0.9-1 c-0.5-0.4-0.9-0.8-1.5-1.1c-0.1-0.1-0.2-0.1-0.2-0.2c-0.6-0.4-1.1-0.9-1.6-1.4c-0.3-0.4-0.6-0.8-0.9-1.1c0,0,0,0,0-0.1 c0,0,0,0,0-0.1c0,0,0.1,0,0.1,0c0.3,0.4,0.7,0.7,1,1.1c0.1,0.1,0.1,0.2,0.2,0.2c0.5,0.4,1,0.9,1.6,1.2c0.6,0.3,1.1,0.7,1.6,1.1 c0.2,0.1,0.4,0.3,0.5,0.5c0.1,0.2,0.3,0.4,0.4,0.6c0.2,0.3,0.4,0.6,0.6,0.9c0,0,0,0,0.1,0.1c0,0,0-0.1,0-0.1 c-0.2-0.5-0.4-0.9-0.6-1.4c-0.2-0.4-0.4-0.7-0.8-0.9c-0.3-0.3-0.6-0.6-1-0.8c-0.5-0.4-1-0.9-1.5-1.5c-0.6-0.7-1-1.4-1.2-2.3 c0,0,0-0.1,0-0.1c0,0,0,0,0,0c0.1,0.1,0.1,0.2,0.2,0.2c0.3,0.6,0.6,1.1,1.1,1.6c0.2,0.2,0.3,0.4,0.5,0.5c0.1,0.1,0.2,0.2,0.3,0.3 c0.2,0.2,0.3,0.3,0.5,0.5c0,0,0.1,0,0.2,0c0,0.1,0,0.1,0.1,0.1c0,0.1,0,0.1,0.1,0.1c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0-0.1,0 c0-0.1,0-0.1-0.1-0.1c0-0.1,0-0.1-0.1-0.1c0,0,0-0.1,0-0.1c0-0.1-0.1-0.2-0.2-0.2c-0.3-0.4-0.5-0.9-0.7-1.3c-0.1-0.3-0.2-0.6-0.2-1 c0-0.2,0.1-0.3,0.2-0.5c0-0.1,0.1-0.1,0.2-0.1c0.2,0.2,0.5,0.4,0.7,0.5c0.4,0.3,0.8,0.4,1.3,0.5c0,0,0.1,0,0.1,0 c0.2,0,0.4-0.1,0.6-0.1c0.1,0,0.1,0,0.2-0.1c0,0,0,0,0,0c-0.1,0-0.1,0-0.2,0c-0.5-0.1-1-0.2-1.4-0.4c-0.5-0.3-1-0.6-1.4-1 c0,0,0-0.1,0-0.1l0,0c0.1,0,0.1,0,0.2,0c0.2,0.1,0.5,0.3,0.7,0.4c0.4,0.3,0.9,0.4,1.4,0.6c0.1,0,0.1,0,0.2,0c0,0,0.1,0,0.1,0 c-0.1,0-0.1-0.1-0.2-0.1c-0.4-0.2-0.8-0.5-1.2-0.8c-0.2-0.1-0.3-0.2-0.4-0.4c0,0,0-0.1,0-0.1c0.2,0.1,0.3,0.2,0.5,0.3 c0.2,0.1,0.5,0.3,0.7,0.4c0.4,0.2,0.9,0.4,1.4,0.5c0,0,0.1,0,0.1,0c0,0,0-0.1-0.1-0.1c-0.1-0.1-0.2-0.1-0.3-0.2 c-0.7-0.3-1.4-0.8-1.9-1.4c-0.1-0.1-0.3-0.3-0.4-0.4c-0.3-0.3-0.6-0.7-0.9-1.1c-0.2-0.3-0.4-0.7-0.5-1.1c-0.1-0.4-0.2-0.9-0.3-1.3 c0-0.2-0.1-0.5-0.1-0.7c0-0.4,0-0.7-0.1-1.1c-0.1-0.4,0-0.7,0-1.1c0,0,0,0,0-0.1c0-0.6,0-1.2,0-1.8c0-0.1,0-0.2,0-0.3 c-0.1-0.3-0.1-0.6-0.1-0.9s-0.2-1.1-0.3-1.5c-0.1-0.3-0.3-0.6-0.6-0.8c-0.2-0.1-0.4-0.2-0.6-0.3c0,0-0.1-0.1,0-0.1 c0,0,0-0.1,0.1-0.1c0,0,0,0,0.1,0c0.1,0,0.3,0,0.4,0c0.2,0.1,0.4,0.2,0.5,0.3c0.3,0.3,0.6,0.7,0.7,1.1c0.2,0.6,0.5,1.7,0.5,2.3 c0,0.9,0,1.7,0,2.5c0,0.3,0,0.7,0,1c0,0,0,0,0,0c0,0,0.1,0,0.1,0c0.2-0.1,0.3-0.2,0.5-0.4c0.3-0.2,0.5-0.3,0.9-0.3 c0.2,0,0.3,0,0.4,0.1c0.1,0.1,0.2,0.1,0.3,0.2c0,0,0,0,0,0c0,0,0.1-0.1,0-0.1c-0.1-0.2-0.1-0.3-0.2-0.5c-0.1-0.2-0.3-0.5-0.5-0.7 c-0.1-0.1-0.2-0.2-0.3-0.2c0,0,0-0.1-0.1-0.1c0,0,0-0.1,0.1-0.1c0,0,0.1,0,0.1,0c0.1,0,0.2,0,0.3,0.1c0.4,0.3,0.7,0.6,0.9,1.1 c0,0.1,0.1,0.2,0.2,0.3c0.2,0.4,0.3,0.7,0.3,1.1c0,0.3,0,0.5,0,0.8c0,0.1,0,0.1,0,0.2c0.3-0.4,0.4-0.8,0.4-1.1c0.1-0.7,0-1.3-0.3-2 c-0.1-0.1-0.1-0.3-0.2-0.4c-0.2-0.6-0.6-1.1-1-1.6c-0.1-0.1-0.1-0.1-0.2-0.2c0,0,0-0.1-0.1-0.1c0,0,0,0,0,0c0,0,0.1-0.1,0.1,0 c0.3,0.2,0.8,0.7,1,1c0.1,0.2,0.2,0.3,0.3,0.5c0,0.1,0.1,0.2,0.1,0.3c0.2,0.6,0.4,1.1,0.4,1.7c0,0.2,0.1,0.4,0.1,0.6c0,0,0,0,0.1,0 c0-0.5,0.1-1,0-1.6c0-0.1,0-0.2,0-0.2c-0.2-0.6-0.3-1.2-0.6-1.7c-0.1-0.1-0.1-0.2-0.2-0.3c-0.5-0.7-1-1.3-1.6-1.8 c-0.1-0.1-0.2-0.2-0.3-0.3c0,0,0-0.1-0.1-0.1c0,0,0-0.1,0.1-0.1c0.1,0,0.1,0,0.2,0c0.3,0.2,0.5,0.4,0.8,0.6 c0.3,0.3,0.5,0.6,0.8,0.8c0.2,0.2,0.4,0.4,0.5,0.7c0.2,0.3,0.4,0.6,0.6,1c0,0,0.1,0,0.1,0c0,0.1,0,0.2,0,0.3l0,0c0,0,0,0,0,0 c0-0.1,0-0.2-0.1-0.2c0-0.1,0-0.2,0-0.3c0-0.1-0.1-0.2-0.1-0.3c-0.3-0.6-0.6-1.1-1-1.6c-0.2-0.3-0.4-0.6-0.7-1 c-0.3-0.4-0.4-0.8-0.5-1.2c0-0.1,0-0.3,0-0.4c0.1-0.4,0.3-0.6,0.6-0.8c0.1,0,0.1-0.1,0.2-0.1c0.1,0,0.1,0,0.2,0c0,0,0,0,0,0 c0,0,0-0.1-0.1-0.1c-0.9-0.6-1.8-0.9-2.8-1.1c-0.2,0-0.5-0.1-0.7-0.2c0,0,0-0.1-0.1-0.1c0,0,0-0.1,0-0.1c0.1,0,0.2-0.1,0.3-0.1 c0.2,0,0.4,0,0.6,0c0.2,0.1,0.3,0.1,0.5,0.1c0.1,0,0.2,0,0.2,0c0.6,0.2,1.3,0.4,1.8,0.8c0.1,0.1,0.2,0.2,0.4,0.2c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0-0.1,0c0,0,0-0.1,0-0.1c0,0,0,0,0-0.1c-0.2-0.3-0.4-0.5-0.6-0.7c-0.6-0.5-1.2-0.9-1.9-1.1 c-0.3-0.1-0.6-0.2-0.9-0.3c-0.3-0.1-0.7-0.1-1-0.2c0,0-0.1,0-0.1-0.1c0,0,0-0.1,0.1-0.1c0.1-0.1,0.2-0.1,0.3-0.1 c0.2,0,0.4,0.1,0.6,0.1c0.4,0.1,0.8,0.1,1.1,0.3c0.5,0.2,1,0.4,1.5,0.7c0.6,0.3,1.1,0.8,1.5,1.3c0,0,0.1,0,0.1,0 c0,0.1,0,0.2,0.1,0.2c0,0,0,0.1,0.1,0.1c0,0-0.1,0-0.1,0c0,0,0-0.1,0-0.1c0-0.1,0-0.1-0.1-0.1c0-0.1,0-0.2,0-0.2 c-0.1-0.3-0.3-0.5-0.5-0.8c-0.1-0.2-0.2-0.3-0.4-0.4c-0.4-0.3-0.8-0.7-1.3-1c-0.1-0.1-0.3-0.2-0.4-0.3c-0.4-0.2-0.7-0.4-1.1-0.6 c-0.4-0.2-0.9-0.3-1.4-0.4c-0.2,0-0.4-0.1-0.6-0.1c0,0,0-0.1-0.1-0.1c0,0,0-0.1,0.1-0.1c0,0,0.1,0,0.1,0c0.1,0,0.3,0,0.4,0 c0.4,0.1,0.9,0.2,1.3,0.3c0,0,0.1,0,0.1-0.1c-0.3-0.2-0.6-0.4-1-0.5c-0.4-0.2-0.7-0.4-1-0.8c-0.4-0.4-0.6-0.8-0.6-1.4 c0-0.1-0.1-0.1-0.1-0.1c-0.3,0.1-0.7,0.2-1,0.3c-0.3,0.1-0.6,0.2-0.9,0.5c-0.1,0.1-0.2,0.2-0.3,0.2c0,0,0,0-0.1,0 c0,0-0.1-0.1,0-0.1c0.1-0.3,0.3-0.5,0.6-0.7c0.3-0.2,0.7-0.4,1.1-0.5c0.1,0,0.2-0.1,0.3-0.1c0,0,0.1,0,0.1,0c0,0,0,0,0,0 c0,0,0-0.1-0.1-0.1c-0.5-0.1-1-0.1-1.6,0c-0.1,0-0.1,0-0.2,0c-0.5,0.1-0.9,0.2-1.4,0.3c0,0-0.1-0.1-0.1-0.1c0,0,0-0.1,0-0.1 c0,0,0.1-0.1,0.1-0.1c0.4-0.1,0.8-0.3,1.2-0.4c0.1,0,0.1,0,0.2,0c0.2,0,0.3-0.1,0.5-0.1c0.5,0,0.9-0.1,1.4,0 c0.2,0.1,0.5,0.1,0.7,0.1c0,0,0.1,0,0.1,0c-0.4-0.3-0.8-0.4-1.2-0.5c-0.3-0.1-0.6-0.1-0.9-0.1c-0.2,0-0.3,0-0.5-0.1 c-0.3,0-0.6-0.1-0.9,0c-0.3,0.1-0.7,0.1-1,0.2c-0.1,0.1-0.3,0.1-0.4,0.2c0,0-0.1,0-0.1,0c0,0-0.1,0-0.1-0.1c0,0,0-0.1,0-0.2 c0.1,0,0.1-0.1,0.2-0.1c0.3-0.1,0.6-0.2,0.8-0.3c0.2-0.1,0.5-0.1,0.7-0.1c0.4,0,0.9,0,1.3,0c0.4,0,0.7,0.1,1.1,0.2 c0.3,0.1,0.5,0.2,0.7,0.3c0.1,0,0.1,0.1,0.2,0c0,0.1,0,0.1,0.1,0.1c0,0,0.1,0,0.1,0c0,0,0,0,0,0c0,0,0.1,0.1,0,0c0,0,0,0,0,0 c0-0.1-0.1-0.1-0.2-0.1c0,0,0-0.1,0-0.1c-0.3-0.3-0.6-0.5-1-0.6c-0.1,0-0.2-0.1-0.3-0.1c-0.7-0.3-1.4-0.5-2.2-0.5c0,0-0.1,0-0.1,0 c-0.5,0-1,0-1.5,0.1c-0.1,0-0.2,0-0.2,0c-0.2,0-0.5,0-0.7,0.1c-0.1,0-0.2,0-0.3,0l0,0c0,0,0-0.1,0.1-0.1c0.5-0.2,0.9-0.4,1.4-0.4 c0.2,0,0.3,0,0.5-0.1c0.4-0.1,0.9-0.1,1.3,0c0.2,0.1,0.5,0.1,0.7,0.1c0.1,0,0.2,0,0.3,0c0,0,0,0.1,0.1,0.1s0.1,0,0.1,0 c0,0,0,0-0.1,0c0,0-0.1,0-0.1,0c0,0,0,0,0-0.1c-0.3-0.1-0.6-0.2-0.9-0.3c-0.3-0.1-0.7-0.1-1-0.2c-0.3,0-0.5-0.1-0.8,0 c-0.4,0.1-0.8,0-1.2,0.1c0,0-0.1,0-0.1,0c-0.5,0-1-0.1-1.4-0.4c-0.2-0.1-0.3-0.2-0.4-0.4c-0.1-0.2-0.2-0.3-0.2-0.5 c0-0.3,0-0.6,0.1-0.9c0-0.1,0-0.1,0-0.2c0,0,0,0,0-0.1c0-0.1,0-0.1-0.1,0c-0.3,0.2-0.6,0.4-0.8,0.6c-0.3,0.3-0.6,0.5-0.8,0.8 c0,0,0,0,0,0c-0.1,0-0.1,0-0.2,0c0,0-0.1-0.1,0-0.2c0.1-0.2,0.3-0.4,0.4-0.6c0.4-0.5,0.9-0.9,1.4-1.2c0,0,0-0.1,0.1-0.1 c0,0,0,0,0.1,0c0,0,0,0,0,0c0,0,0,0,0,0c-0.2,0-0.3,0-0.5,0c-0.7,0.2-1.4,0.4-2,0.7c-0.2,0.1-0.3,0.1-0.5,0.2c0,0-0.1,0-0.1,0 c0,0,0,0,0,0c0.2-0.2,0.4-0.3,0.6-0.4c0.3-0.1,0.6-0.2,0.8-0.4c0.2-0.1,0.5-0.2,0.8-0.3c0.2-0.1,0.4-0.1,0.6-0.2 c0.4-0.1,0.7-0.2,1.1-0.2c0.1,0,0.2,0,0.3,0c0,0,0.1,0,0.1-0.1c0,0,0,0,0-0.1c0,0,0,0,0,0c-0.2-0.1-0.4,0.1-0.6,0 c-0.3,0-0.6,0-0.9,0c-0.5,0-1,0.1-1.5,0.3c-0.1,0-0.2,0.1-0.3,0.1c-0.4,0.1-0.8,0.3-1.2,0.5c-0.2,0.1-0.4,0.2-0.6,0.3 c0,0-0.1,0-0.2,0l0,0c0,0,0-0.1,0-0.1c0.2-0.2,0.5-0.4,0.8-0.5c0.5-0.2,1-0.5,1.5-0.6c0.1,0,0.2-0.1,0.3-0.1c0.1,0,0.3-0.1,0.4-0.1 c-0.1,0-0.1-0.1-0.2-0.1c-0.5,0-1,0.1-1.5,0.2c-0.9,0.3-1.7,0.6-2.4,1.1c-0.3,0.2-0.5,0.4-0.8,0.6c-0.1,0.1-0.1,0.2,0,0.3 c0.2,0.1,0.4,0.2,0.6,0.2c0.6,0.1,1.2,0.4,1.7,0.7c0.5,0.3,1,0.6,1.4,1.1c0.2,0.2,0.4,0.5,0.6,0.7c0.4,0.6,0.7,1.3,1,1.9 c0,0.1,0,0.1,0.1,0.2c0,0,0,0.1-0.1,0.1c0,0,0,0-0.1,0c-0.1-0.1-0.1-0.1-0.2-0.2c-0.3-0.5-0.6-0.9-0.9-1.3 c-0.2-0.2-0.3-0.4-0.5-0.6c-0.6-0.7-1.2-1.2-2-1.7c-0.4-0.2-0.7-0.4-1.1-0.4c-0.1,0-0.1,0-0.2,0c-0.5-0.1-1-0.3-1.5-0.5 c-0.2-0.1-0.4-0.2-0.6-0.3c-0.4-0.2-0.7-0.4-1-0.8c-0.1-0.1-0.1-0.2-0.2-0.3c0,0,0,0,0,0c0,0,0,0.1,0,0.1c0,0.3,0.1,0.5,0.2,0.7 c0.1,0.1,0.1,0.3,0.2,0.4c0,0.1,0,0.1,0,0.2c0,0,0,0.1,0,0.1c0,0-0.1,0-0.1,0c-0.2-0.2-0.4-0.5-0.5-0.8c-0.1-0.2-0.1-0.3-0.1-0.5 c0-0.1,0-0.2,0-0.2c-0.1-0.3-0.1-0.6,0-1c0.1-0.4,0.2-0.7,0.3-1c0-0.1,0.1-0.1,0.1-0.2c0,0,0.1,0,0.1,0c0,0,0,0,0,0c0,0,0,0,0,0.1 c-0.1,0-0.1,0-0.2,0c-0.2,0.2-0.4,0.4-0.6,0.6c-0.2,0.3-0.4,0.7-0.5,1.1c-0.1,0.3-0.1,0.6-0.1,0.9c0.1,0.4,0.1,0.7,0.3,1.1 c0,0,0,0.1-0.1,0.1c0,0,0,0,0,0c-0.1-0.1-0.2-0.3-0.3-0.5c-0.2-0.5-0.2-1.1-0.1-1.7c0-0.1,0-0.1,0-0.2c0.1-0.4,0.3-0.8,0.5-1.1 c0,0,0.1-0.1,0.1-0.1c0,0,0-0.1,0-0.1c0,0,0,0,0.1,0c0,0,0,0,0,0c0,0,0,0-0.1,0.1c0,0,0,0-0.1,0c-0.5,0.4-0.9,0.9-1,1.6 c0,0.1,0,0.2,0,0.2c-0.1,0.6-0.1,1.1,0.2,1.8c0.1,0.3,0.3,0.6,0.5,0.9c0,0,0,0.1,0,0.1c-0.2,0-0.3,0-0.5-0.2 c-0.2-0.2-0.3-0.4-0.4-0.7c-0.1-0.1-0.1-0.2-0.2-0.4c0-0.1-0.1-0.1-0.2-0.1c-0.3,0.1-0.5,0.1-0.8,0c0,0-0.1,0-0.1,0 c-0.2,0-0.4-0.1-0.5-0.2c-0.3-0.2-0.5-0.5-0.7-0.8c-0.2-0.3-0.3-0.6-0.4-0.9c-0.1-0.4-0.1-0.9,0.1-1.3c0-0.1,0.1-0.3,0.1-0.4 c0,0,0,0,0,0c0,0-0.1,0.1-0.1,0.1c-0.4,0.5-0.6,1.1-0.7,1.7c0,0.1,0,0.2,0,0.2c0,0.2,0.1,0.5,0.1,0.7c0.1,0.5,0.4,0.9,0.7,1.3 c0.1,0.1,0.2,0.2,0.3,0.3c0,0,0.1,0.1,0.1,0.1c0,0,0,0.1,0,0.1c0,0-0.1,0-0.1,0c-0.2-0.1-0.3-0.2-0.5-0.4c-0.6-0.6-0.9-1.4-1-2.3 c0-0.1,0-0.2,0-0.3c0.1-0.4,0.1-0.7,0.2-1.1c0.1-0.2,0.1-0.5,0.3-0.7c0.1-0.1,0.2-0.3,0.3-0.4c0,0,0-0.1,0-0.1c0,0,0,0,0,0 c-0.3,0.2-0.4,0.4-0.6,0.7c-0.2,0.2-0.3,0.5-0.4,0.8c-0.1,0.2-0.1,0.4-0.2,0.6c-0.1,0.3-0.1,0.6,0,0.9c0,0.2,0.1,0.4,0.1,0.6 c0,0.2,0.1,0.5,0.3,0.7c0,0.1,0.1,0.1,0.1,0.2c0,0,0,0.1,0,0.1c-0.1,0.1-0.2,0.1-0.2,0c-0.1-0.1-0.1-0.1-0.1-0.2 c-0.1-0.1-0.1-0.3-0.2-0.4c-0.1-0.3-0.2-0.7-0.2-1c0-0.1,0-0.1,0-0.2c0,0,0,0,0,0c-0.1,0.5-0.1,0.9,0.1,1.4 c0.1,0.3,0.2,0.5,0.4,0.7c0.1,0.1,0.2,0.3,0.3,0.4c0,0,0,0.1-0.1,0.2c0,0,0,0-0.1,0c-0.2,0.1-0.5,0.2-0.7,0.2c-0.2,0-0.5,0-0.8,0 c0,0,0,0,0,0c0,0,0,0.1,0,0.1c0.2,0.2,0.4,0.4,0.6,0.4c0.1,0,0.1,0,0.1,0.1c0,0,0,0.1,0,0.1c0,0-0.1,0.1-0.1,0.1 c-0.1,0-0.2,0-0.2,0c-0.3-0.1-0.6-0.3-0.9-0.5c-0.2-0.2-0.3-0.4-0.5-0.6c0,0,0,0,0,0c0,0,0,0,0,0.1c0,0.1,0,0.2,0.1,0.3 c0.2,0.6,0.4,1.1,0.9,1.5c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0-0.1,0c-0.2-0.1-0.5-0.3-0.6-0.5c-0.4-0.6-0.7-1.2-0.8-1.9 c0,0,0-0.1,0-0.1c0,0,0-0.1-0.1-0.1c0,0-0.1,0-0.1,0.1c-0.1,0.5-0.1,1,0,1.4c0,0.1,0,0.1,0,0.2c0.1,0.2,0.1,0.4,0.2,0.5 c0.1,0.1,0.1,0.3,0.2,0.4c0.1,0.3,0.3,0.5,0.6,0.6c0.1,0.1,0.3,0.2,0.4,0.3c0,0,0,0,0,0c0,0-0.1,0-0.1,0c-0.3-0.1-0.5-0.2-0.7-0.4 c0,0-0.1-0.1-0.1-0.1c-0.5-0.4-0.8-1-0.9-1.6c0-0.2-0.1-0.3-0.1-0.5c0-0.4,0-0.9,0.1-1.3c0-0.2,0.1-0.3,0.1-0.5c0,0,0,0,0,0 c0,0,0,0,0,0c-0.3,0.4-0.4,0.8-0.5,1.2c-0.1,0.4-0.1,0.8,0,1.2c0,0.1,0,0.2,0,0.3c0.1,0.4,0.2,0.7,0.4,1c0.2,0.4,0.5,0.7,0.9,0.9 c0.3,0.2,0.7,0.3,1,0.4c0.1,0,0.2,0,0.3-0.1c0,0,0.1-0.1,0.2-0.1c0-0.1-0.1-0.2-0.1-0.3c0.1,0,0.1-0.1,0.2-0.1c0.1,0,0.2,0,0.3,0 c0.1,0,0.3-0.1,0.4-0.1c0.1,0,0.2-0.1,0.2-0.2c-0.3-0.1-0.5-0.2-0.8-0.3c0,0-0.1-0.1-0.1-0.1c0,0,0-0.1,0-0.1 c0-0.1,0.1-0.1,0.1-0.1c0.1,0,0.1,0,0.2,0.1c0.3,0.2,0.6,0.3,0.9,0.3c0.1,0,0.3,0,0.4-0.1c0,0,0,0,0,0s0,0,0,0 c-0.3-0.1-0.6-0.2-0.9-0.4c-0.1,0-0.1-0.1-0.2-0.2c0,0,0,0,0-0.1c0,0,0.1-0.1,0.1-0.1c0.3,0.1,0.6,0.2,0.8,0.3 c0.2,0.1,0.4,0.1,0.6,0.2c0.1,0,0.2,0,0.3-0.1c0,0,0-0.1,0-0.1c-0.2-0.1-0.5-0.2-0.7-0.3c-0.1,0-0.1-0.1-0.2-0.1c0,0,0-0.1,0-0.2 c0,0,0.1-0.1,0.1,0c0.5,0.2,1,0.3,1.4,0.4c0,0,0,0,0.1,0c0,0,0.1,0.1,0.1,0.1c0,0.1,0,0.1-0.1,0.2c-0.1,0.1-0.1,0.1-0.2,0.2 c-0.3,0.3-0.5,0.5-0.8,0.8c-0.2,0.1-0.4,0.3-0.6,0.4c-0.4,0.3-0.7,0.6-1.2,0.8c-0.2,0.1-0.3,0.1-0.5,0.2c-0.4,0.2-0.8,0.3-1.2,0.4 c-0.3,0.1-0.5,0.2-0.8,0.2c-0.4,0-0.9,0.1-1.3,0.1c-0.1,0-0.2,0-0.2,0c-0.1,0-0.2,0-0.3,0c-0.5,0-1.1,0-1.6,0 c-0.5-0.1-1-0.1-1.4-0.1c-0.3,0-0.6,0-0.9,0.1c-0.7,0.2-1.3,0.6-1.7,1.2c0,0,0,0,0,0c-0.2,0.3-0.5,0.6-0.7,0.8 c-0.1,0.1-0.1,0.1-0.2,0.1c-0.3,0.1-0.7,0.3-1,0.4c-0.5,0.1-1.1,0.2-1.6,0.2c-0.7,0.1-1.5,0-2.2,0.1c-0.3,0-0.6,0-0.9,0 c-0.8,0-1.6,0-2.4,0.1c-0.2,0-0.5,0-0.7,0.1c-0.6,0.1-1.2,0.3-1.8,0.5c-0.6,0.2-1.2,0.6-1.6,1.1c-0.1,0.2-0.2,0.4-0.3,0.6 c-0.1,0.3-0.1,0.7-0.1,1c0,0.2,0.1,0.5,0.2,0.7c0,0,0.1,0.1,0.1,0c0.1,0,0.1,0,0.2,0c0.5-0.2,1.1-0.3,1.6-0.3c0.1,0,0.3,0,0.4,0 c0.3,0,0.6,0,0.9,0c0.1,0,0.3-0.1,0.4-0.1c0.2-0.1,0.4-0.4,0.3-0.8c-0.1-0.2-0.2-0.4-0.4-0.5c-0.2-0.1-0.5-0.2-0.7-0.2 c-0.1,0-0.2,0-0.3-0.1c0,0,0-0.1,0-0.1c0.1-0.1,0.1-0.1,0.2-0.1c0.4-0.1,0.8,0,1.1,0.2c0.3,0.1,0.5,0.3,0.6,0.6 c0.1,0.3,0.1,0.5,0,0.8c-0.2,0.5-0.6,0.8-1.1,1c-0.3,0.1-0.6,0.1-0.9,0.1c-0.2,0-0.5,0-0.7,0c-0.4,0-0.7,0.1-1,0.2 c-0.2,0.1-0.4,0.2-0.6,0.4c-0.1,0.1-0.2,0.2-0.2,0.4c-0.1,0.2-0.1,0.4-0.1,0.6c0,0.5,0,0.9,0,1.4c0.1,0.3,0.1,0.6,0.1,0.9 c0,0.1,0,0.2,0,0.2c0.1,0.3,0.2,0.6,0.4,0.8c0.1,0.1,0.2,0.2,0.3,0.2c0.4,0.1,0.8,0.2,1.2,0.2c0.9,0,1.8,0,2.7,0 c0.5,0,1,0.1,1.5,0.1c0.3,0.1,0.5,0.1,0.8,0.1c0.1,0,0.2,0,0.2,0c0.3,0.1,0.6,0.1,0.9,0.2c0,0,0.1,0,0.1,0s0.1,0,0.1-0.1 c0,0,0,0,0-0.1c-0.2-0.3-0.3-0.6-0.4-0.9c-0.1-0.4-0.2-0.7-0.3-1.1c-0.1-0.3-0.1-0.5-0.1-0.8c0-0.3-0.1-0.5-0.1-0.8 c0-0.2,0-0.4,0-0.6c0-0.2-0.1-0.4-0.1-0.6c0-0.2-0.1-0.4-0.3-0.6c-0.1-0.1-0.2-0.2-0.4-0.3c-0.1,0-0.1,0-0.2,0 c-0.1,0-0.1-0.1-0.1-0.2c0-0.1,0.1-0.1,0.2-0.1c0.1,0,0.2,0,0.3,0c0.2,0,0.4,0.1,0.5,0.2c0.3,0.2,0.5,0.5,0.6,0.8 c0.1,0.4,0.3,0.9,0.3,1.3c0,0.2,0,0.4,0,0.6c0,0.2,0.1,0.4,0.1,0.6c0,0.3,0.1,0.5,0.1,0.8c0.1,0.4,0.2,0.8,0.4,1.2 c0.1,0.2,0.3,0.5,0.4,0.7c0.2,0.3,0.4,0.4,0.7,0.6c0.6,0.2,1.1,0.5,1.6,0.9c0.3,0.2,0.6,0.5,0.9,0.8c0.3,0.3,0.5,0.6,0.8,0.9 c0.4,0.6,0.7,1.2,0.8,1.9c0.1,0.5,0.1,1,0.1,1.5c-0.2,0.8-0.4,1.5-0.9,2.2c-0.1,0.2-0.3,0.4-0.5,0.5c-0.3,0.3-0.7,0.5-1,0.6 c-0.4,0.2-0.8,0.2-1.3,0.1c-0.5-0.1-0.9-0.2-1.4-0.5c-0.2-0.1-0.4-0.3-0.7-0.4c-0.4-0.2-0.8-0.4-1.2-0.6c-0.8-0.3-1.6-0.5-2.4-0.6 c-0.2,0-0.4-0.1-0.6-0.1c-0.2,0-0.4,0.1-0.6,0.1c-0.4,0.1-0.7,0.2-1.1,0.4c-0.1,0.1-0.1,0.1-0.1,0.2c0,0.4,0,0.9,0,1.3 c0,0.3,0.1,0.5,0.2,0.8c0.2,0.4,0.5,0.7,0.9,0.8c0.1,0,0.1,0.1,0.2,0.1c0.3,0,0.6,0.1,0.9,0.1c0.5,0,0.9,0.2,1.2,0.5c0,0,0,0,0,0 c0,0,0.1,0.1,0.1,0c0,0,0-0.1,0-0.1c0-0.3-0.1-0.5-0.2-0.8c-0.1-0.3-0.2-0.5-0.4-0.7c0,0,0,0,0,0c0,0,0,0,0-0.1c0,0,0-0.1,0-0.1 c0,0,0.1,0,0.1,0c0.2,0.1,0.4,0.3,0.5,0.4c0.3,0.4,0.5,0.9,0.6,1.4c0.1,0.5,0.1,1-0.1,1.5c-0.1,0.3-0.1,0.6-0.2,0.9 c0,0.2,0,0.3-0.1,0.5c0,0.1,0,0.2,0,0.2c-0.1,0.3-0.1,0.6,0,0.9c0.1,0.3,0.2,0.6,0.5,0.8c0.1,0.1,0.2,0.1,0.3,0.2c0,0,0,0,0,0 c0,0,0,0,0,0c0-0.1-0.1-0.2-0.2-0.2c-0.2-0.2-0.3-0.5-0.4-0.8c0-0.1,0-0.2,0-0.3c0,0,0-0.1,0.1-0.1s0.1,0,0.1,0 c0.1,0.1,0.1,0.3,0.2,0.4c0.1,0.2,0.2,0.4,0.3,0.6c0.2,0.2,0.3,0.4,0.6,0.6c0,0,0,0,0,0c0,0,0,0,0,0c-0.3-0.4-0.5-0.8-0.7-1.3 c0-0.1-0.1-0.3-0.1-0.4c-0.1-0.4-0.1-0.7-0.2-1.1c0-0.1,0-0.2,0.1-0.3c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0.1c0,0.1,0,0.2,0,0.2 c0,0.2,0,0.5,0,0.7c0,0.2,0.1,0.3,0.2,0.4c0-0.2,0-0.3,0-0.5c0-0.2,0-0.5,0.1-0.7c0.1-0.2,0.2-0.4,0.3-0.6c0.1-0.1,0.1-0.2,0.2-0.3 c0.1-0.1,0.3-0.3,0.4-0.4c0.1-0.3,0.2-0.6,0.4-0.9c0,0,0.1-0.1,0.1-0.1c0,0,0,0,0.1,0c0,0,0.1,0,0.1,0.1c0,0.1,0,0.1,0,0.2 c0,0.1-0.1,0.3-0.2,0.4c-0.2,0.6-0.2,1.2,0,1.8c0,0.1,0.1,0.2,0.1,0.3c0,0,0.1,0,0.1,0.1c0,0,0,0.1,0,0.1c0,0,0,0,0,0 c0,0,0,0-0.1,0c0-0.1,0-0.3,0-0.4c0-0.3,0-0.7,0-1c0,0,0,0,0.1-0.1c0,0,0,0,0,0.1c0,0.2,0,0.5,0,0.7c0,0.1,0,0.1,0,0.2c0,0,0,0,0,0 c0,0,0.1,0,0.1,0c0.1-0.5,0.2-0.9,0.5-1.3c0.1-0.1,0.1-0.2,0.2-0.3c0-0.2,0-0.4,0-0.6c0-0.1,0-0.2,0-0.3c0.1-0.2,0.1-0.4,0.3-0.6 c0,0,0.1,0,0.2,0c0,0,0.1,0.1,0,0.1c0,0.1,0,0.1-0.1,0.2c0,0.2-0.1,0.5-0.1,0.7c0,0.2,0.1,0.3,0.1,0.5c0,0.2,0.1,0.3,0.2,0.5 c0.1,0.2,0.2,0.4,0.3,0.6c0,0,0.1,0.1,0.1,0.1c0,0,0,0,0,0c0,0,0.1-0.1,0-0.1c-0.1-0.2-0.1-0.4-0.2-0.6c0,0,0-0.1,0-0.2 c0.1,0.1,0.1,0.2,0.1,0.2c0.1,0.3,0.3,0.5,0.4,0.7c0,0,0.1,0,0.1,0c0,0,0,0,0-0.1c0-0.2,0-0.5,0-0.7c0-0.2,0.2-0.4,0.2-0.7 c0.1-0.2,0.2-0.3,0.4-0.4c0.2-0.1,0.4-0.2,0.5-0.3c0.4-0.3,0.4-0.2,0.4-0.7c0-0.1,0-0.2,0-0.2c0-0.2,0.1-0.3,0.2-0.4 c0,0,0.1,0,0.1,0c0,0,0,0,0,0c0.1,0.2,0.1,0.4,0.1,0.6c0,0.1,0,0.1,0,0.2c0,0,0,0,0,0c0,0,0.1,0,0.1-0.1c0-0.3,0-0.5,0.1-0.8 c0,0,0,0,0-0.1c0,0,0.1-0.1,0.1,0c0,0,0.1,0,0.1,0.1c0,0.2,0,0.4,0.1,0.6c0,0.1,0.1,0.1,0.2,0.1c0.1,0,0.1-0.1,0.1-0.2 c0,0,0,0,0-0.1c-0.1-0.2-0.1-0.4,0-0.6c0,0,0-0.1,0-0.1c0,0,0.1-0.1,0.1-0.1s0.1,0,0.1,0.1c0.1,0.2,0.1,0.5,0.1,0.7c0,0,0,0,0,0 c0,0,0.1,0,0.1,0c0.1,0,0.1-0.1,0.1-0.2c0-0.1,0-0.1-0.1-0.2c-0.1-0.2-0.1-0.5,0.1-0.7c0,0,0-0.1,0.1-0.1c0,0,0,0,0.1,0 c0,0,0.1,0,0.1,0.1c0,0.1,0,0.1,0,0.2c0,0.2,0.1,0.3,0.1,0.5c0,0,0,0,0.1,0.1c0.2-0.2,0.4-0.4,0.5-0.6c0.1-0.2,0.2-0.3,0.3-0.5 c0-0.1-0.1-0.1-0.1-0.2c-0.2-0.1-0.3-0.3-0.5-0.4c-0.1-0.1-0.2-0.3-0.3-0.4c0,0,0-0.1,0-0.1c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0.1 c0.2,0.2,0.4,0.4,0.6,0.6c0.4,0.4,0.9,0.6,1.4,0.7c0,0,0.1,0,0.1,0c-0.1-0.1-0.2-0.1-0.2-0.2c-0.4-0.2-0.7-0.5-1-0.8 c-0.1-0.1-0.2-0.3-0.3-0.4c0,0,0,0,0-0.1c0,0,0.1-0.1,0.1-0.1c0,0,0,0,0,0c0.2,0.2,0.3,0.5,0.5,0.7c0.3,0.3,0.6,0.5,1,0.6 c0,0,0.1,0,0.2,0c0,0,0,0.1,0.1,0.1c0,0,0.1,0,0.1,0c0,0,0,0-0.1,0c0,0-0.1,0-0.1,0c0,0,0-0.1,0-0.1c-0.1-0.1-0.2-0.2-0.3-0.3 c-0.3-0.3-0.6-0.6-0.8-1c-0.1-0.2-0.2-0.4-0.3-0.6c0,0,0-0.1,0-0.1c0,0,0.1,0,0.1,0c0.1,0.1,0.1,0.2,0.2,0.3 c0.1,0.2,0.3,0.4,0.4,0.6c0,0,0.1,0.1,0.1,0.1c0,0.1,0,0.2,0.1,0.2c0,0,0.1,0.1,0.1,0.1c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0-0.1,0 c0-0.1,0-0.1-0.1-0.1c0-0.1,0-0.2-0.1-0.2c0-0.1,0-0.1,0-0.2c-0.1-0.2-0.2-0.5-0.3-0.7c-0.1-0.3-0.1-0.6-0.1-0.9 c0-0.1,0-0.1,0.1-0.1c0,0,0.1,0,0.1,0.1c0.1,0.1,0.1,0.2,0.1,0.4c0,0.1,0,0.1,0.1,0.2c0,0,0.1,0.1,0.1,0c0.1-0.2,0.4-0.3,0.6-0.3 c0.1,0,0.2,0,0.2,0c0.2,0,0.4,0,0.6,0c0.1,0,0.3,0,0.4-0.1c0.3-0.1,0.5-0.3,0.7-0.5c0,0,0-0.1,0-0.1c-0.2-0.1-0.4-0.2-0.5-0.3 c-0.4-0.4-0.6-0.9-0.7-1.5c0-0.3,0.1-1,0.2-1.3c0.1-0.3,0.2-0.6,0.3-0.9c0.1-0.3,0.1-0.6-0.1-0.9c-0.1-0.1-0.1-0.2-0.2-0.2 c0-0.1,0.1-0.1,0.1-0.1c0.1-0.1,0.1,0,0.2,0c0.1,0,0.3,0.1,0.3,0.2c0.2,0.2,0.3,0.4,0.3,0.7c0,0.2,0,0.5-0.1,0.7 c-0.1,0.3-0.2,0.7-0.3,1c0,0.1-0.1,0.2-0.1,0.3c0,0.3,0,0.6,0,0.9c0,0.1,0,0.2,0.1,0.3c0.1,0.4,0.4,0.7,0.9,0.8 c0.1,0,0.2,0.1,0.3,0.1c0.1,0.1,0.2,0.3,0.2,0.4c-0.1,0.1-0.2,0.3-0.2,0.4c-0.3,0.5-0.8,0.9-1.4,1c-0.2,0-0.3,0.1-0.5,0.1 c-0.2,0-0.4,0-0.6,0c0,0-0.1,0-0.1,0.1c0.1,0.2,0.1,0.4,0.2,0.7c0.1,0.4,0.3,0.7,0.7,0.9c0.1,0.1,0.2,0.1,0.2,0.2 c0,0,0.1,0.1,0.1,0.1c0.1,0.1,0.1,0.4-0.1,0.5c-0.3,0.2-0.6,0.3-1,0.3c-0.5,0-1.1,0-1.6-0.2c0,0,0,0-0.1,0c-0.1,0-0.2,0-0.2,0.1 c-0.3,0.5-0.7,0.8-1.2,1c-0.1,0.1-0.2,0.1-0.3,0.1c-0.3,0.1-0.6,0.2-0.9,0.4c-0.2,0.1-0.4,0.2-0.5,0.2c-0.3,0.1-0.6,0.2-0.9,0.4 c-0.3,0.1-0.5,0.4-0.6,0.7c-0.1,0.2-0.1,0.4-0.1,0.7c0,0.3,0.1,0.7,0.2,1c0,0.1,0,0.2,0,0.3c0,0.1-0.1,0.2-0.2,0.2 c-0.4,0-0.8-0.1-1.2-0.4c-0.4-0.3-0.7-0.6-0.8-1c0,0,0,0,0,0c-0.1,0-0.1,0.1-0.1,0.2c0,0.1-0.1,0.2-0.1,0.3c0,0.3,0,0.6,0,0.9 c0,0.1,0,0.3,0,0.4c0,0.2-0.2,0.3-0.4,0.2c-0.1,0-0.2-0.1-0.3-0.1c-0.4-0.2-0.7-0.5-0.8-0.9c-0.1-0.1-0.1-0.3-0.2-0.4c0,0,0,0,0,0 c0,0-0.1,0-0.1,0c-0.1,0.4-0.2,0.8-0.1,1.1c0,0.6,0.2,1.1,0.6,1.5c0,0.1,0.1,0.1,0.1,0.2c0,0,0,0.1,0,0.2c0,0-0.1,0.1-0.1,0.1 c-0.2,0.1-0.4,0.2-0.6,0.2c-0.1,0-0.2,0-0.2,0.1c0,0.1-0.1,0.1-0.1,0.2c-0.1,0.1-0.2,0.3-0.3,0.3c-0.1,0.1-0.2,0.1-0.3,0.2 c0,0-0.1,0-0.1,0c0,0,0-0.1,0-0.1s0-0.1,0-0.1c0.1-0.1,0.2-0.2,0.3-0.3c0.2-0.2,0.1-0.3-0.1-0.3c-0.1,0-0.1,0-0.2-0.1 c0,0,0,0-0.1,0c0,0-0.1,0.1-0.1,0.1c-0.1,0.1-0.2,0.3-0.4,0.4c-0.1,0.1-0.2,0.1-0.3,0.1c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0.1-0.1,0.1-0.1c0.2-0.1,0.3-0.3,0.5-0.4c0.1-0.1,0.1-0.2,0-0.3c-0.1-0.1-0.1-0.1-0.2-0.2c-0.2,0-0.2,0.2-0.3,0.3 c-0.2,0.2-0.4,0.3-0.6,0.4c-0.1,0-0.2,0-0.2,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0-0.1,0.1-0.1c0.3-0.2,0.5-0.4,0.7-0.6 c0,0,0.1-0.1,0.1-0.1c0,0,0-0.1,0-0.1c-0.1-0.1-0.1-0.3-0.3-0.3c-0.1,0.1-0.3,0.2-0.4,0.4c-0.1,0.1-0.3,0.2-0.5,0.3 c-0.1,0-0.2,0-0.2,0c0,0,0,0,0,0c0,0,0,0,0,0c0.1-0.1,0.2-0.2,0.4-0.3c0.2-0.1,0.4-0.3,0.7-0.5c0.1,0,0.1-0.1,0.1-0.2 c0-0.1,0-0.1,0-0.2c0-0.1-0.1-0.1-0.1-0.1c-0.1,0.1-0.2,0.1-0.3,0.2c-0.4,0.4-1,0.6-1.5,0.7c-0.4,0.1-0.8,0.1-1.2-0.1 c-0.3,0-0.5-0.1-0.7-0.2c0,0-0.1,0-0.1,0c0,0,0,0,0,0.1c0,0.1,0.1,0.1,0.1,0.2l0,0c-0.1,0-0.1,0-0.2,0c-0.1,0-0.1-0.1-0.2-0.1 c0,0-0.1,0-0.1,0s0,0.1,0,0.1c0.1,0.3,0.4,0.4,0.6,0.6c0.2,0.2,0.4,0.3,0.7,0.5c0.1,0.1,0.1,0.1,0.2,0.2c0,0,0,0.1,0,0.1 c0,0-0.1,0.1-0.1,0.1c0,0-0.1,0-0.1,0c-0.4-0.1-0.7-0.3-1-0.6c-0.2-0.1-0.3-0.3-0.5-0.4c-0.1-0.1-0.2-0.2-0.3-0.4 c-0.1-0.2-0.2-0.4-0.3-0.6c0,0-0.1,0.1-0.1,0.1c0,0.2,0,0.3,0.1,0.5c0.1,0.2,0.3,0.4,0.4,0.6c0.1,0.2,0.3,0.4,0.4,0.6 c0,0.1,0,0.2,0,0.2c-0.1,0.1-0.3,0.2-0.4,0.2c-0.5,0-1,0.1-1.5,0.2c-0.3,0.1-0.6,0.2-0.9,0.3c-0.7,0.3-1.4,0.8-1.9,1.4 c0,0,0,0,0,0.1c0,0-0.1,0-0.1,0c0,0,0,0,0,0c0,0,0-0.1,0-0.1c0.1,0,0.2,0,0.3-0.1c0.5-0.5,1.1-0.8,1.7-1c0.3-0.1,0.6-0.2,0.8-0.2 c0.5,0,0.9,0,1.4-0.1c0.3,0,0.6,0,0.9,0c0.4,0,0.8,0,1.2,0c0.1,0,0.2,0,0.3-0.1c0.3-0.1,0.5-0.2,0.7-0.5c0,0,0.1-0.1,0.1-0.1 c0,0,0.1,0,0.1,0c0,0,0,0.1,0,0.2c-0.1,0.2-0.3,0.4-0.5,0.5c-0.1,0.1-0.3,0.2-0.4,0.2c-0.3,0.1-0.6,0.3-1,0.3c-0.1,0-0.1,0-0.2,0 c-0.3,0.1-0.7,0.1-1,0c-0.2,0-0.3,0-0.5,0c-0.2,0-0.3,0-0.5,0.1c-0.4,0-0.8,0.1-1.2,0.1c0,0-0.1,0-0.1,0c-0.5,0.1-1,0.3-1.5,0.6 c-0.3,0.2-0.5,0.4-0.8,0.5c-0.1,0.1-0.2,0.2-0.3,0.3c-0.3,0.3-0.4,0.6-0.5,1c-0.1,0.5-0.1,0.5-0.1,1c0,0,0.1,0,0.1,0 c0.1-0.1,0.1-0.3,0.2-0.4c0.4-0.8,1-1.4,1.8-1.9c0.2-0.1,0.4-0.2,0.6-0.2c0.6-0.1,1.2-0.2,1.8-0.2c0.2,0,0.4,0,0.6,0c0,0,0,0,0,0 c0,0,0,0.1-0.1,0.1c-0.2,0-0.3,0-0.5,0c-0.4,0.1-0.8,0.1-1.2,0.2c-0.4,0.1-0.8,0.2-1.1,0.4c-0.3,0.2-0.6,0.4-0.9,0.6 c0,0,0,0.1,0,0.1c0,0,0.1,0,0.1,0c0,0,0,0,0.1,0c0.3-0.1,0.7-0.2,1-0.2c0.2,0,0.3,0,0.5,0.1c0.3-0.1,0.6-0.2,0.9-0.3 c0.2,0,0.3-0.1,0.5-0.1c0.2,0,0.4,0,0.6,0c0,0,0,0.1-0.1,0.1c-0.1,0.1-0.2,0.1-0.4,0.1c-0.3,0-0.6,0.1-0.9,0.3c0,0-0.1,0.1-0.1,0.1 c0,0.1,0,0.1,0.1,0.1c0.4,0.2,0.7,0.4,1,0.8c0.1,0.1,0.1,0.1,0.2,0c0.3-0.1,0.6-0.2,0.9-0.2c0.3,0,0.6-0.1,0.9-0.1 c0.1,0,0.2,0,0.3,0c0.1,0,0.2,0,0.3-0.1c0.5-0.1,1.1-0.2,1.6-0.3c0.3-0.1,0.5-0.2,0.6-0.4c0.1-0.1,0.2-0.2,0.3-0.3c0,0,0,0,0.1,0 c0,0,0.1,0.1,0.1,0.1c0,0.1,0,0.1,0,0.2c-0.1,0.2-0.2,0.3-0.4,0.4c-0.2,0.2-0.4,0.3-0.6,0.4c-0.1,0-0.3,0.1-0.4,0.1 c-0.7,0.2-1.4,0.3-2,0.5c-0.8,0.2-1.5,0.5-2.2,0.8c-0.1,0-0.2,0.1-0.3,0.1c-0.4,0.3-0.8,0.6-1.2,1c-0.5,0.6-0.9,1.3-1.2,2 c0,0.1-0.1,0.2,0,0.3c0,0-0.1,0-0.1,0c0,0,0,0.1,0,0.1c0,0,0,0,0-0.1c0,0,0-0.1,0-0.1c0.1,0,0.1-0.1,0.1-0.1c0.4-0.5,0.7-1,1.2-1.5 c0.2-0.2,0.4-0.3,0.6-0.5c0.5-0.4,1.1-0.7,1.6-0.9c0.4-0.2,0.9-0.3,1.3-0.5c0.3-0.1,0.7-0.2,1.1-0.3c0.2,0,0.4-0.1,0.6,0 c0,0,0.1,0,0.1,0.1c0,0,0,0,0,0c0,0,0,0.1,0,0.1c-0.8,0.2-1.7,0.5-2.5,0.8c-0.6,0.3-1.2,0.6-1.8,1c-0.7,0.5-1.3,1-1.7,1.7 c-0.3,0.4-0.5,0.7-0.6,1.1c-0.2,0.4-0.2,0.9-0.2,1.3c0,0,0,0.1,0,0.1c0,0,0,0,0,0s0,0,0,0c0.1-0.1,0-0.2,0-0.3c0-0.2,0-0.3,0.1-0.5 c0.2-0.5,0.4-1,0.7-1.4c0.1-0.1,0.1-0.2,0.2-0.2c0,0,0.1,0,0.1,0c0,0,0.1,0.1,0.1,0.1c-0.1,0.1-0.1,0.2-0.2,0.3 c-0.2,0.4-0.4,0.8-0.6,1.2c0,0.1,0,0.2,0,0.3c0,0-0.1,0-0.1,0c0,0,0,0,0,0c0,0,0-0.1,0-0.1c0,0,0.1,0,0.1-0.1 c0.3-0.6,0.7-1.2,1.1-1.8c0.4-0.5,0.9-0.9,1.4-1.3c0.5-0.3,1-0.5,1.5-0.7c0.2,0,0.3-0.1,0.5-0.1c0.5-0.1,0.9-0.2,1.4-0.2 c0,0,0,0,0.1,0c0,0,0.1,0.1,0.1,0.1c0,0,0,0.1-0.1,0.1c-0.6,0.2-1.2,0.4-1.8,0.6c-0.1,0-0.3,0.1-0.4,0.2c0.1,0,0.1,0,0.2,0 c0.2,0,0.3,0,0.5,0c0.4,0,0.8,0.1,1.2,0.3c0.1,0.1,0.3,0.1,0.4,0.2c0.1,0,0.2,0.1,0.2,0.2c0.1,0.1,0.1,0.3,0,0.4 c0,0-0.1,0.1-0.1,0.1c-0.2,0.2-0.5,0.4-0.7,0.5c-0.2,0.1-0.4,0.3-0.5,0.5c-0.1,0.1-0.2,0.3-0.3,0.4c-0.3,0.5-0.6,1.1-0.7,1.6 c0,0.1,0,0.2,0,0.2c0.1-0.2,0.2-0.5,0.3-0.7c0.4-0.6,0.8-1.2,1.3-1.7c0.4-0.4,0.9-0.8,1.4-1.2c0.4-0.3,0.8-0.5,1.3-0.6 c0.1,0,0.2,0,0.2,0.1c0.1,0.1,0,0.2,0,0.3c-0.1,0-0.1,0.1-0.2,0.1c-0.5,0.1-0.9,0.3-1.3,0.6c-0.5,0.3-0.9,0.7-1.3,1.1 c-0.4,0.5-0.7,1-1.1,1.5c-0.1,0.1-0.1,0.2-0.1,0.3c-0.1,0.3-0.2,0.5-0.3,0.8c0,0,0,0.1,0,0.1c0,0,0.1,0,0.1-0.1 c0.2-0.3,0.5-0.6,0.8-0.9c0.3-0.3,0.5-0.6,0.8-0.9c0.2-0.2,0.4-0.4,0.7-0.6c0.3-0.2,0.6-0.4,1-0.6c0.2-0.2,0.5-0.3,0.8-0.4 c0.1,0,0.2,0,0.3-0.1c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0.1c0,0,0,0,0,0c-0.2,0.1-0.4,0.2-0.6,0.3c-0.4,0.2-0.7,0.5-1.1,0.7 c-0.4,0.3-0.8,0.6-1.1,1c0,0,0,0.1,0,0.1c0,0,0.1,0,0.1,0c0.4-0.3,0.8-0.4,1.2-0.5c0.6-0.2,1.3-0.2,1.9,0c0,0,0.1,0.1,0.1,0.1 c0,0.1,0,0.1,0,0.2c-0.1,0.1-0.1,0.2-0.2,0.3c-0.1,0.2-0.3,0.3-0.4,0.5c-0.3,0.5-0.5,0.9-0.7,1.5c0,0.1,0,0.2,0,0.3 c-0.1,0-0.1,0.1-0.1,0.1c0,0.1,0,0.2,0,0.3c0,0-0.1,0-0.1,0.1c0,0.3,0,0.5-0.1,0.8c0,0,0,0.1,0,0.1c0,0.1,0,0.3,0,0.4 c0,0.1,0,0.1,0,0.2c0,0.2,0.1,0.3,0.1,0.5c0.1-0.2,0-0.4,0-0.5c-0.1-0.2-0.1-0.4,0-0.6c0.1-0.3,0.1-0.6,0.1-0.9 c0.1,0,0.1,0,0.1-0.1c0-0.1,0-0.2,0-0.4c0,0,0.1,0,0.1,0c0.1-0.2,0.1-0.4,0.2-0.5c0.3-0.5,0.6-1,1-1.4c0.1-0.1,0.1-0.1,0.2-0.2 c0.4-0.4,0.8-0.7,1.4-0.8c0.1,0,0.2,0,0.2,0c-0.1,0.1-0.2,0.2-0.4,0.3c-0.2,0.1-0.3,0.2-0.5,0.3c-0.1,0.1-0.2,0.2-0.3,0.3 c-0.2,0.3-0.5,0.6-0.7,0.9c-0.4,0.5-0.6,1.1-0.8,1.7c-0.1,0.4-0.2,0.8-0.2,1.3c0,0.4,0,0.8,0,1.1c0,0.1,0,0.1,0.1,0.1 c0.1-0.2,0.1-0.4,0.1-0.6c0-0.1,0-0.3,0-0.4c0.2-0.8,0.5-1.5,0.9-2.2c0.4-0.7,0.9-1.2,1.5-1.6c0,0,0.1-0.1,0.1-0.1 c0.1-0.1,0.3-0.1,0.4-0.1c0,0,0,0,0,0c0,0,0,0.1,0,0.1c-0.1,0.2-0.3,0.3-0.5,0.5c-0.4,0.3-0.8,0.7-1.2,1.2 c-0.3,0.4-0.5,0.9-0.7,1.4c0,0.1,0,0.1,0,0.2c0,0-0.1,0-0.1,0.1c0,0,0,0.1,0,0.1c0,0,0,0,0.1-0.1c0,0,0-0.1,0-0.1c0,0,0,0,0.1,0 c0.1-0.1,0.2-0.2,0.2-0.3c0.4-0.6,0.9-1.1,1.5-1.5c0.3-0.2,0.7-0.4,1.1-0.6c0.1,0,0.1,0,0.2,0.1c0,0,0,0.1,0,0.2 c-0.1,0.1-0.1,0.1-0.2,0.2c-0.3,0.2-0.6,0.5-0.9,0.7c-0.1,0.1-0.2,0.2-0.3,0.3c0,0,0,0,0,0c0,0,0.1,0,0.1,0c0.9-0.5,1.8-0.7,2.7-1 c0,0,0.1-0.1,0.1-0.2c0.3-0.3,0.6-0.6,0.9-0.9c0.2-0.2,0.4-0.2,0.6-0.2c0,0,0.1,0,0.1,0.1c-0.1,0.2-0.2,0.3-0.3,0.5 c-0.2,0.2-0.4,0.4-0.7,0.7c-0.3,0.3-0.5,0.6-0.6,1c-0.1,0.2-0.2,0.5-0.3,0.7c-0.1,0.3-0.2,0.6-0.2,0.9c0,0.1,0,0.2,0,0.3 c-0.1,0.3,0,0.6,0,0.9c0,0.2,0.1,0.3,0.1,0.5c0,0.4,0.1,0.8,0.3,1.2c0.1-0.1,0-0.2,0-0.3c0-0.2-0.1-0.4-0.1-0.6 c0-0.2,0-0.4,0.1-0.6c0-0.1,0-0.1,0-0.2c0-0.4,0.1-0.8,0.3-1.2c0.1-0.4,0.3-0.8,0.5-1.2c0-0.1,0.1-0.1,0.1-0.2 c0.3-0.5,0.7-1,1.1-1.4c0.1-0.1,0.2-0.1,0.3-0.2c0.1,0,0.1,0,0.1,0.1c0,0,0,0.1,0,0.2c-0.1,0.1-0.1,0.1-0.2,0.2 c-0.2,0.2-0.4,0.5-0.6,0.8c-0.1,0.1-0.1,0.2-0.2,0.3c-0.2,0.3-0.4,0.7-0.5,1.1c-0.1,0.2-0.1,0.3-0.2,0.5c-0.1,0.4-0.2,0.7-0.2,1.1 c0,0.1,0,0.2,0,0.3c-0.1,0.3,0,0.6,0,0.9c0,0.1,0.1,0.1,0.1,0.1c0,0,0.1-0.1,0.1-0.1c0-0.4,0.2-0.9,0.3-1.3c0-0.1,0.1-0.2,0.1-0.3 c0.2-0.8,0.7-1.5,1.1-2.2c0.2-0.4,0.6-0.7,0.9-0.9c0,0,0,0,0.1,0c0,0,0,0,0.1,0c0,0,0.1,0,0.2,0c0,0,0,0.1,0,0.1 c-0.2,0.4-0.4,0.8-0.7,1.2c-0.1,0.1-0.1,0.2-0.2,0.3c0,0,0,0.1,0,0.1c0,0,0,0,0,0c0.2-0.2,0.5-0.4,0.8-0.6c0.4-0.3,0.8-0.4,1.3-0.4 c0.3,0,0.5,0.1,0.8,0.1c0.1,0,0.1,0,0.2,0.1c0.3,0.1,0.6,0.3,0.8,0.5c0.1,0.1,0.2,0.3,0.3,0.4c0-0.2,0-0.5,0-0.7 c0-0.2-0.1-0.4-0.2-0.6c0-0.1,0-0.1,0-0.2c0,0,0.1,0,0.1,0c0.1,0.2,0.2,0.3,0.2,0.5c0.1,0.3,0.1,0.6,0.1,0.9c0,0.2,0,0.3,0,0.5 c0.1-0.3,0.2-0.5,0.2-0.8c0-0.2,0-0.4,0-0.6c0-0.3,0-0.7-0.1-1c0-0.1-0.1-0.3-0.1-0.4c0,0,0.1-0.1,0.1-0.1c0.1,0,0.1,0,0.1,0.1 c0.1,0.2,0.1,0.3,0.2,0.5c0,0.2,0,0.4,0.1,0.5c0.1,0.4,0.1,0.8,0,1.1c-0.1,0.5-0.1,0.9-0.3,1.3c0,0.1,0,0.2,0,0.2c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0-0.1c0.3-0.3,0.4-0.5,0.5-0.8c0.1-0.3,0.2-0.7,0.3-1c0,0,0.1-0.1,0.1-0.1c0,0,0.1,0,0.1,0.1c0,0,0,0,0,0.1 c0,0.3,0,0.5-0.1,0.7c-0.1,0.2-0.1,0.3-0.1,0.5c0,0,0,0.1,0,0.1c0,0,0,0,0,0c0,0,0,0,0,0c0.2-0.3,0.3-0.6,0.5-0.9 c0-0.1,0.1-0.2,0.1-0.3c0-0.4,0.1-0.7,0.1-1.1c0-0.1,0-0.2,0-0.2c0,0,0.1-0.1,0.1-0.1c0,0,0.1,0,0.1,0s0.1,0.1,0.1,0.1 c0.1,0.4,0.2,0.7,0.1,1.1c0,0.1-0.1,0.3-0.1,0.4c-0.1,0.3-0.2,0.6-0.3,0.9c-0.3,0.7-0.7,1.3-1.3,1.8c-0.1,0.1-0.2,0.2-0.3,0.3 c0,0,0,0.1,0,0.1c0,0-0.1,0-0.1,0c0,0,0,0,0,0c0,0,0-0.1,0-0.1c0.1,0,0.2,0,0.2,0c0.3-0.2,0.6-0.4,0.9-0.7c0.1-0.1,0.2-0.2,0.4-0.3 c0,0,0.1,0,0.1,0c0,0,0.1,0,0,0.1c-0.4,0.6-0.9,1-1.5,1.3c0,0-0.1,0-0.1,0c-0.3,0.1-0.6,0.3-0.9,0.4c0,0,0.1,0.1,0.1,0.1 c0.1,0,0.3,0,0.4,0c0.2,0,0.5-0.1,0.7-0.2c0.5-0.2,0.9-0.5,1.2-0.9c0.3-0.3,0.5-0.6,0.7-0.9c0.2-0.4,0.3-0.8,0.5-1.2 c0.1-0.3,0.2-0.7,0.2-1.1c0-0.2,0-0.3,0-0.5c0-0.1,0-0.1,0-0.2c0-0.1,0.1-0.1,0.2-0.2c0.1,0,0.2,0,0.2,0.1c0,0.1,0.1,0.1,0.1,0.2 c0,0.3,0,0.5,0,0.8c0,0.2-0.1,0.3-0.1,0.5c0,0.1,0,0.2,0.1,0.3c0.3,0.3,0.5,0.7,0.6,1c0,0.1,0,0.1,0,0.2c0,0.3,0.1,0.7,0.1,1 c0,0.1,0,0.2,0.1,0.4c0.2-0.4,0.2-0.8,0.3-1.2c0-0.6-0.1-1.2-0.1-1.8c0-0.1,0-0.1-0.1-0.2c-0.1-0.3-0.2-0.6-0.2-0.9 c0-0.1,0-0.2,0-0.2c-0.1-0.4-0.2-0.8-0.2-1.3c0-0.4,0-0.7,0.1-1.1c0.1-0.3,0.2-0.6,0.4-0.9c0.1-0.1,0.1-0.1,0.2-0.2c0,0,0,0,0,0 c-0.1,0.1-0.1,0.3-0.2,0.4c-0.3,0.5-0.3,1.1-0.2,1.7c0.1,0.6,0.3,1.2,0.4,1.7c0.1,0.5,0.2,0.9,0.2,1.4c0,0.4,0,0.9,0,1.3 c0,0.2,0,0.4,0,0.6c0,0-0.1,0-0.1,0.1s0,0.1,0,0.1c0,0,0,0,0-0.1c0,0,0-0.1,0-0.1c0,0,0.1,0,0.1-0.1c0.1-0.2,0.2-0.4,0.2-0.5 c0.2-0.4,0.3-0.7,0.3-1.1c0-0.6,0-1.1,0-1.7c0-0.2,0-0.5,0-0.7c0-0.2,0.1-0.3,0.1-0.4c0,0,0,0,0,0c0,0,0,0,0,0.1c0,0.1,0,0.1,0,0.2 c0,0.3,0,0.7,0.1,1c0.1,0.4,0,0.9,0,1.3c0,0.4,0,0.7-0.1,1.1c-0.2,0.6-0.3,1.2-0.6,1.8c0,0,0,0.1,0,0.2c0,0-0.1,0-0.1,0 c0,0,0,0,0,0c0,0,0-0.1,0-0.1c0.1,0,0.1,0,0.1-0.1c0.4-0.6,0.7-1.1,1-1.7c0.2-0.5,0.4-1.1,0.4-1.6c0-0.1,0-0.2,0-0.3 c0-0.1,0-0.2,0.1-0.3c0,0,0.1,0,0.1-0.1c0,0,0.1,0.1,0.1,0.1c0,0.1,0,0.2,0,0.3c0,0.2,0,0.4,0,0.5c0.1,0.3,0,0.7-0.1,1 c-0.2,0.7-0.5,1.3-0.9,1.9c-0.1,0.2-0.2,0.3-0.4,0.5c0,0,0,0,0,0c0,0,0.1,0,0.1,0c0.5-0.4,0.9-0.8,1.1-1.4c0-0.1,0.1-0.2,0.1-0.3 c0.1-0.3,0.2-0.6,0.3-0.9c0-0.1,0.1-0.1,0.1-0.2c0,0,0.1-0.1,0.1,0c0.1,0.1,0.2,0.2,0.2,0.3c0.1,0.2,0.2,0.4,0.3,0.6 c0.1,0.2,0.1,0.4,0.1,0.7c0,0.3,0,0.5,0,0.8c0,0.1,0,0.2,0,0.3c0.1-0.1,0.1-0.2,0.2-0.3c0.2-0.7,0.3-1.3,0.3-2c0-0.2,0-0.5-0.1-0.7 c0,0,0,0,0-0.1c0,0,0.1-0.1,0.1-0.1c0,0,0.1,0,0.1,0c0,0,0.1,0.1,0.1,0.1c0,0.1,0,0.2,0,0.2c0,0.2,0,0.5,0.1,0.7 c0,0.3-0.1,0.5-0.1,0.7c0,0.2,0,0.4,0,0.5c-0.1,0.4-0.1,0.9-0.3,1.3c0,0.1,0,0.2,0,0.2c0,0-0.1,0-0.1,0.1c0,0,0,0.1,0,0.1 c0,0,0,0,0.1-0.1c0,0,0-0.1,0-0.1c0,0,0.1,0,0.1,0c0.1-0.1,0.1-0.1,0.2-0.2c0.3-0.6,0.7-1.3,0.9-2c0.1-0.3,0.2-0.7,0.3-1 c0-0.2,0.1-0.5,0-0.7c0,0,0,0,0.1-0.1c0,0,0,0,0.1,0c0,0,0.1,0.1,0.1,0.1c0,0.1,0.1,0.2,0.1,0.3c0,0.1,0,0.3,0,0.4 c-0.1,0.3-0.2,0.6-0.3,0.9c-0.1,0.3-0.2,0.6-0.3,0.8c-0.1,0.3-0.3,0.7-0.4,1c-0.1,0.3-0.2,0.5-0.4,0.8c-0.1,0.1-0.2,0.3-0.2,0.4 c0,0,0,0.1,0,0.2c0,0-0.1,0-0.1,0.1c0,0,0-0.1,0-0.1c0,0,0.1,0,0.1,0c0.3-0.3,0.6-0.6,0.9-0.9c0.2-0.3,0.4-0.6,0.7-1 c0.1-0.2,0.3-0.4,0.3-0.7c0.1-0.2,0.2-0.5,0.2-0.7c0-0.2,0.1-0.3,0.2-0.5c0.1-0.2,0.2-0.4,0.2-0.7c0-0.1,0.1-0.1,0.1-0.1 c0,0,0.1,0,0.2,0c0,0,0.1,0.1,0.1,0.1c0,0.2,0,0.4,0,0.6c-0.1,0.4-0.3,0.9-0.4,1.3c-0.2,0.5-0.4,0.9-0.7,1.4 c-0.3,0.5-0.6,0.9-1,1.2c-0.2,0.2-0.4,0.3-0.5,0.5c0,0,0,0.1,0,0.1c-0.1,0-0.1,0-0.2,0.1c0,0,0,0,0,0c0,0,0,0.1,0.1,0 c0.1,0,0.1-0.1,0.1-0.2c0.1,0,0.1,0,0.2,0c0.7-0.4,1.2-1,1.7-1.6c0.3-0.4,0.6-0.8,0.7-1.3c0-0.1,0.1-0.3,0.1-0.4 c0-0.1,0.1-0.2,0.2-0.3c0,0,0.1,0,0.1,0c0.1,0.2,0.3,0.4,0.4,0.6c0.2,0.4,0.3,0.9,0.4,1.4c0,0.1,0.1,0.3,0.1,0.4 c0,0.1,0,0.1,0.1,0.2c0,0,0-0.1,0-0.1c0-0.3,0-0.6,0.1-0.9c0-0.4,0-0.8,0-1.1c0-0.2-0.1-0.5-0.1-0.7c0,0,0-0.1,0.1-0.1 s0.1,0,0.1,0.1s0,0.1,0.1,0.1c0.1,0.3,0.1,0.6,0.1,0.9c0,0.1,0,0.2,0,0.3c0.1,0.2,0.1,0.4,0,0.6c0,0.1,0,0.2,0,0.3 c0,0.1,0,0.2,0,0.3c-0.1,0.4-0.2,0.9-0.3,1.3c-0.1,0.2-0.1,0.4-0.2,0.5c-0.2,0.4-0.3,0.7-0.6,1.1c0,0.1-0.1,0.1-0.1,0.2 c-0.1,0-0.1,0-0.1,0.1c0,0,0,0,0,0s0,0,0,0c0,0,0,0,0-0.1c0.1,0,0.1,0,0.1-0.1c0.1,0,0.1,0,0.1-0.1c0.6-0.6,1.2-1.7,1.4-2.6 c0.1-0.4,0.2-0.8,0.3-1.2c0.1-0.3,0.1-0.6,0.1-0.9c0-0.4,0-0.8,0-1.1c0-0.2-0.1-0.4-0.1-0.6c0,0,0,0,0-0.1c0,0,0-0.1,0.1-0.1 c0,0,0,0,0.1,0c0.1,0.1,0.2,0.2,0.2,0.3c0,0.3,0.1,0.5,0.1,0.8c0,0.2,0,0.3,0,0.5c0,0.4,0,0.7,0,1.1c0,0.2,0,0.3,0,0.5 c0,0.3-0.1,0.6-0.2,0.8c-0.3,0.7-0.6,1.3-0.9,1.9c-0.2,0.3-0.4,0.6-0.6,0.8c-0.1,0.1-0.2,0.2-0.3,0.3c0,0,0,0,0.1,0 c0,0,0.1,0,0.1,0c0.2,0,0.3-0.1,0.5-0.2c0.1-0.1,0.3-0.2,0.4-0.4c0.2-0.2,0.5-0.5,0.6-0.8c0.3-0.6,0.6-1.1,0.9-1.8 c0.1-0.3,0.2-0.7,0.2-1c0-0.1,0-0.2,0-0.3c0.1-0.2,0.1-0.5,0.1-0.7c0-0.1,0-0.1,0-0.2c0,0,0.1-0.1,0.1-0.1c0,0,0.1,0,0.1,0 c0,0,0,0,0,0c0.1,0.3,0.1,0.6,0.1,1c0,0.3,0,0.6-0.1,0.9c0,0.1,0,0.2,0.1,0.2c0.2,0.1,0.2,0.2,0.2,0.4c0,0.2,0.1,0.3,0.1,0.4 c0,0.1,0.1,0.2,0.1,0.3c0.1,0.4,0.1,0.8,0.1,1.1c0,0,0,0.1,0,0.1c0,0,0,0,0,0c0,0,0,0,0,0c0.1-0.2,0.1-0.4,0.2-0.7 c0.2-0.5,0.3-1,0.3-1.6c0-0.1,0-0.1,0-0.2c0,0,0-0.1,0.1-0.1c0,0,0.1,0,0.1,0.1c0,0.2,0.1,0.3,0.1,0.5c-0.1,0.4-0.1,0.8-0.2,1.2 c-0.1,0.4-0.2,0.7-0.4,1c0,0.1-0.1,0.2,0,0.3c-0.1,0-0.1,0-0.1,0.1c0,0,0,0.1,0,0.1c0,0,0,0,0,0c0,0,0,0,0,0c0.1,0,0.1-0.1,0.1-0.2 c0,0,0.1,0,0.1,0c0.2-0.2,0.4-0.5,0.6-0.7c0.2-0.3,0.4-0.6,0.6-0.9c0.1-0.3,0.2-0.6,0.4-0.9c0.1-0.3,0.2-0.5,0.2-0.8 c0,0,0-0.1,0-0.1c0,0,0.1-0.1,0.1-0.1c0,0,0.1,0,0.1,0.1c0,0.2,0,0.4-0.1,0.6c-0.1,0.4-0.3,0.8-0.4,1.1c-0.2,0.7-0.5,1.4-0.9,2 c-0.2,0.4-0.5,0.7-0.7,1c-0.2,0.2-0.4,0.4-0.6,0.6c0,0-0.1,0.1-0.1,0.1c0,0,0,0-0.1,0s0,0,0,0c0,0,0,0,0.1-0.1c0.1,0,0.2,0,0.3-0.1 c0.7-0.5,1.4-1.1,2-1.8c0.1-0.1,0.1-0.1,0.1-0.2c0.1-0.1,0.1-0.2,0.2-0.2c0.3-0.3,0.5-0.7,0.7-1c0.1-0.1,0.2-0.3,0.3-0.4 c0,0,0.1,0,0.1,0c0,0.1,0,0.1,0,0.2c-0.1,0.1-0.1,0.3-0.2,0.4c-0.5,1-1.2,1.8-2.1,2.5c-0.1,0.1-0.3,0.2-0.3,0.3c0,0,0,0,0,0 c0,0,0,0,0,0c0.5-0.2,1-0.5,1.5-0.8c0.3-0.2,0.5-0.4,0.7-0.6c0.1-0.1,0.3-0.2,0.4-0.4c0,0,0.1-0.1,0.2-0.1c0,0,0.1,0,0.1,0 c0,0,0.1,0.1,0,0.1c-0.1,0.3-0.3,0.6-0.5,0.8c-0.2,0.2-0.4,0.4-0.6,0.5c-0.1,0.1-0.3,0.2-0.4,0.3c0,0,0,0.1,0,0.1c0,0-0.1,0-0.1,0 c-0.1,0-0.1,0,0,0.1c0,0,0.1,0,0.1,0c0,0,0.1,0,0-0.1c0.2,0,0.4,0.1,0.6,0.1c0.4,0.1,0.8,0.3,1.2,0.5c0.6,0.4,1.2,0.8,1.7,1.3 c0.1,0.1,0.1,0.2,0.2,0.2c0,0,0,0,0.1,0.1c0,0,0,0,0,0c0,0,0,0-0.1,0c0-0.1,0-0.2,0-0.3c-0.2-0.5-0.4-1-0.6-1.4 c-0.2-0.4-0.5-0.8-0.8-1.1c-0.1-0.1-0.1-0.1-0.2-0.2c0,0,0-0.1,0-0.2s0.1-0.1,0.2-0.1c0,0,0.1,0,0.1,0c0.5,0.3,1,0.7,1.3,1.2 c0.2,0.3,0.4,0.6,0.5,0.9c0.1,0.3,0.2,0.5,0.3,0.8c0,0.1,0.1,0.2,0.1,0.3c0,0.1,0,0.2,0.1,0.3c0-0.1,0-0.1,0-0.2 c0-0.5-0.1-1-0.2-1.5c-0.1-0.5-0.2-0.9-0.4-1.4c0-0.1-0.1-0.3-0.1-0.4c-0.2-0.5-0.5-1-0.8-1.4c-0.1-0.1-0.2-0.2-0.3-0.3 c-0.1,0-0.1-0.1-0.2-0.1c0,0,0,0,0-0.1c0,0,0-0.1,0.1-0.1c0.1,0,0.1,0,0.2,0c0.1,0,0.2,0.1,0.3,0.2c0.6,0.5,1,1.1,1.3,1.9 c0.2,0.6,0.4,1.2,0.6,1.8c0.1,0.2,0.1,0.4,0.1,0.6c0,0.3,0,0.7,0.1,1c0,0.1,0,0.2,0,0.2c0,0.1,0,0.2,0,0.1s0.1,0,0.1-0.1 c0.3-0.5,0.4-1,0.5-1.5c0.1-0.3,0.1-0.6,0.1-0.9c0.1-0.3,0.1-0.7,0.1-1c0-0.3-0.1-0.5-0.2-0.7c-0.1-0.2-0.2-0.4-0.3-0.6 c-0.2-0.5-0.5-0.9-0.8-1.3c-0.1-0.1-0.2-0.2-0.2-0.3c-0.1-0.2-0.3-0.4-0.5-0.5c-0.3-0.2-0.6-0.4-1-0.6c-0.1,0-0.1-0.1-0.1-0.1 c-0.1-0.1-0.1-0.2,0-0.3c0,0,0.1,0,0.1,0c0.3,0,0.5,0,0.7,0.1c0.5,0.2,0.9,0.5,1.2,0.9c0.1,0.1,0.2,0.1,0.3,0.2 c0.9,0.1,1.6,0.4,2.3,1c0,0,0,0,0.1,0c0,0,0,0.1,0,0.1c0,0,0,0,0,0c0,0,0,0-0.1,0c0-0.1,0-0.1,0-0.2c-0.1-0.2-0.2-0.3-0.3-0.4 c-0.3-0.4-0.6-0.7-1-1c-0.1-0.1-0.2-0.2-0.2-0.3c0,0,0-0.1,0-0.1c0,0,0.1-0.1,0.1-0.1c0.1,0,0.1,0,0.2,0.1c0.3,0.2,0.6,0.4,0.9,0.8 c0.1,0.1,0.2,0.2,0.3,0.3c0.4,0.4,0.7,0.9,0.9,1.4c0.1,0.2,0.1,0.3,0.2,0.5c0.1,0.3,0.1,0.6,0.2,0.9c0,0,0,0,0.1,0.1 c0-0.1,0-0.1,0-0.2c0-0.5,0-0.9,0-1.4c0-0.3-0.1-0.6-0.2-0.9c-0.1-0.3-0.2-0.5-0.4-0.8c-0.3-0.6-0.7-1-1.2-1.4 c-0.1-0.1-0.2-0.1-0.2-0.2c0,0-0.1-0.1-0.1-0.1c0,0,0,0,0-0.1c0,0,0,0,0,0c0.1,0,0.2,0,0.3,0c0.4,0.2,0.7,0.4,1,0.8 c0.4,0.5,0.7,1,1,1.6c0.1,0.1,0.1,0.3,0.1,0.4c0.1,0.4,0.1,0.8,0.1,1.1c0,0.2,0,0.4,0,0.6c0,0,0,0,0,0c0,0,0,0,0.1,0 c0.3-0.4,0.4-0.8,0.5-1.2c0-0.2,0-0.4,0-0.6c0-0.5-0.2-1-0.4-1.5c-0.4-0.7-1-1.3-1.6-1.8c-0.5-0.5-1.1-0.9-1.7-1.3 c-0.2-0.1-0.4-0.3-0.6-0.4c-0.2-0.2-0.4-0.3-0.6-0.5c-0.3-0.3-0.5-0.7-0.5-1.1c0-0.1,0-0.3,0-0.4c0-0.2,0-0.3,0.1-0.4 c0.1-0.2,0.2-0.3,0.3-0.5c0-0.1,0.1-0.1,0.2,0c0.1,0.1,0.1,0.1,0.2,0.2c0.1,0.2,0.2,0.4,0.3,0.6c0.3,0.5,0.6,0.9,1.1,1.2 c0.3,0.3,0.7,0.4,1.1,0.4c0.4,0.1,0.8,0,1.2,0c0.2,0,0.4-0.1,0.6-0.1c0.1,0,0.2,0,0.3,0c0.7-0.1,1.4-0.4,2-0.8c0,0,0,0,0,0 c0,0,0,0,0,0c-0.2,0-0.5,0.1-0.7,0.2c-0.4,0.1-0.9,0.2-1.4,0.3c-0.6,0.1-1.2,0-1.7-0.1c0,0,0-0.1-0.1-0.1l0,0c0.3,0,0.6,0,0.9,0.1 c0.3,0.1,0.6,0.1,0.9,0c0.1,0,0.2,0,0.2,0c0.4-0.1,0.8-0.2,1.2-0.4c0.3-0.1,0.6-0.3,0.9-0.5c0.1,0,0.1-0.1,0.2-0.1 c0,0,0-0.1,0.1-0.1c0,0,0.1,0,0.1,0c0,0,0,0,0,0c0,0-0.1,0,0,0.1c-0.1,0-0.2,0-0.2,0c-0.5,0.2-1,0.2-1.5,0.3c-0.4,0.1-0.9,0-1.3,0 c-0.4,0-0.7-0.1-1-0.1c-0.7-0.2-1.4-0.4-2-0.8c-0.3-0.2-0.7-0.5-0.9-0.8c-0.1-0.1-0.1-0.1-0.1-0.2c0,0,0-0.1,0-0.1s0-0.1,0-0.1 c0,0,0.1,0,0.1,0c0.2,0.1,0.3,0.2,0.4,0.4c0.5,0.5,1.1,0.8,1.8,1c0.2,0.1,0.4,0.1,0.7,0.2c0.3,0.1,0.6,0.1,0.9,0.2 c0.6,0.1,1.3,0,1.9-0.1c0,0,0,0,0,0c-0.1-0.1-0.2,0-0.3,0c-0.4,0-0.7-0.1-1.1-0.2c-0.1,0-0.3-0.1-0.4-0.1c-0.6-0.2-1.1-0.4-1.6-0.7 c-0.3-0.2-0.5-0.4-0.9-0.6c0,0-0.1,0-0.1-0.1c-0.3-0.2-0.5-0.4-0.8-0.5c-0.1-0.1-0.2-0.1-0.3-0.2c-0.4-0.3-0.7-0.7-1-1.1 c-0.3-0.4-0.5-0.8-0.6-1.2c-0.1-0.4-0.2-0.8-0.2-1.2c0-0.5-0.1-1,0.1-1.5c0-0.1,0-0.3,0-0.5c0-0.1,0.1-0.3,0.1-0.4 c0,0,0.1-0.1,0.1,0c0,0,0.1,0,0.1,0.1c0,0.1,0,0.1,0,0.2c-0.1,0.5-0.1,1-0.1,1.5c0,0.5,0.1,1,0.2,1.5c0,0.2,0.1,0.3,0.2,0.5 c0.3,0.7,0.7,1.2,1.2,1.7c0,0,0.1,0,0.1,0C606.4,537.6,606.4,537.6,606.6,537.6c-0.1,0.1-0.1,0.1-0.1,0.1 C606.6,537.7,606.6,537.7,606.6,537.6C606.7,537.6,606.7,537.6,606.6,537.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M578.4,496.9c-0.5,0.2-1,0.4-1.3,0.7c-0.3,0.3-0.4,0.6-0.4,1c0,0.4,0.2,0.6,0.5,0.8c0,0,0.1,0,0.1,0l0,0 c0,0,0,0,0,0c0,0,0.1,0,0.1,0.1c0.1,0.1,0.1,0.2,0.1,0.3l0,0.3c0,0.3,0,0.5,0,0.8c0,0.4,0.1,0.8,0.4,1.2c0.2,0.4,0.6,0.6,1.1,0.6 c0.3,0,0.5-0.1,0.8-0.2c0.2-0.1,0.3-0.2,0.4-0.2c0.6-0.4,1.1-0.7,1.5-1.1c0.3-0.3,0.6-0.5,0.9-0.9l0.1-0.1c0.2-0.2,0.5-0.5,0.8-0.7 c0.2-0.1,0.3-0.3,0.5-0.5c0.1-0.1,0.2-0.3,0.4-0.4l0.1-0.1c0.1-0.1,0.2-0.1,0.3-0.1l0.2,0c0.2,0,0.4,0.1,0.7,0.1 c0.1,0,0.2,0,0.3,0.1c-0.5-0.3-1-0.5-1.5-0.7c-0.2-0.1-0.4-0.1-0.5-0.1c-0.7,0-1.3,0-1.9,0.1c-0.6,0.1-1.2,0.3-1.6,0.5 c-0.6,0.2-1,0.4-1.4,0.7c-0.4,0.2-0.7,0.3-1,0.4c-0.2,0-0.4,0-0.5-0.1c-0.3-0.1-0.5-0.4-0.5-0.7c0-0.2,0.2-0.6,0.3-0.8 c0.2-0.3,0.6-0.5,1-0.6c0.1,0,0.1,0,0.2,0c0.1,0,0.1,0.1,0.1,0.1s0,0.1,0,0.2c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.1c0,0,0,0,0.1,0 c0.1-0.1,0.2-0.2,0.3-0.3l0,0c0.2-0.3,0.4-0.5,0.6-0.6c0.2-0.2,0.4-0.4,0.7-0.6c0.1-0.1,0.3-0.2,0.4-0.3c0.1,0,0.2,0,0.2,0 c0,0,0.1,0.1,0.1,0.2s0,0.2-0.1,0.3c0,0.1-0.1,0.3,0,0.4c0,0,0,0,0,0l0,0c0,0,0.1,0,0.1-0.1l0,0c0.1-0.1,0.3-0.2,0.4-0.3 c0.4-0.3,0.9-0.5,1.5-0.7c0,0,0.1,0,0.2,0s0.1,0,0.1,0.1s0.1,0.1,0.1,0.1c0,0.1,0,0.1,0,0.2c0,0-0.1,0.1-0.1,0.1 c-0.1,0.1-0.2,0.2-0.2,0.4c0,0.1,0,0.1,0,0.2c0,0,0,0,0,0c0.1,0,0.1,0,0.2-0.1c0.4-0.2,0.9-0.4,1.3-0.5c0.1,0,0.1,0,0.2,0h0 c-0.2,0-0.4,0.1-0.5,0.1c0,0-0.1,0-0.1,0c-0.1,0-0.1,0.1-0.2,0.1c0,0,0,0-0.1,0c0,0-0.1,0-0.1,0.1c-0.1,0-0.1,0-0.2,0 c0,0-0.1-0.1-0.1-0.1c0-0.1,0-0.1,0-0.2c0,0,0,0,0.1,0c0,0,0-0.1,0-0.1c0.1-0.1,0.2-0.2,0.2-0.3c0.1-0.1,0.1-0.1,0.2-0.2v0 c-0.1,0-0.1,0-0.2,0c0,0-0.1,0-0.1,0c-0.4,0-0.8,0-1.2,0.2c-0.1,0.1-0.3,0.1-0.4,0.2c-0.1,0-0.2,0.1-0.3,0.1c-0.1,0-0.1,0-0.2,0 c-0.1,0-0.1-0.1-0.1-0.1c0-0.1,0-0.2,0.1-0.2l0,0c0.1-0.1,0.1-0.1,0.1-0.2c-0.1,0-0.1,0-0.2,0c-0.1,0-0.2,0-0.4,0.1 c-0.3,0.1-0.5,0.1-0.7,0.2c-0.3,0.1-0.7,0.3-0.9,0.6c-0.1,0.1-0.2,0.2-0.2,0.2c-0.1,0.1-0.2,0.2-0.4,0.2 C578.5,496.9,578.4,496.9,578.4,496.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M558,551.7c0-0.1,0-0.1-0.1-0.1c0-0.1,0-0.2-0.1-0.2c-0.3-0.5-0.6-1-0.8-1.5c-0.2-0.4-0.3-0.7-0.5-1.1 c-0.1-0.3-0.2-0.6-0.3-0.9c0-0.1,0-0.2,0-0.2c0,0,0-0.1,0-0.1s0-0.1,0.1-0.1c0,0,0.1,0,0.1,0c0,0,0,0,0,0c0.1,0.5,0.3,0.9,0.5,1.4 c0,0,0,0.1,0,0.1c0,0.1,0.1,0.2,0.1,0.3c0.2,0.3,0.4,0.6,0.5,1c0.5,1,1.2,1.8,2,2.5c0.3,0.3,0.6,0.5,1,0.7c0,0,0,0,0,0c0,0,0,0,0,0 c-0.1-0.2-0.3-0.3-0.4-0.5c-0.3-0.4-0.6-0.7-0.9-1.1c-0.3-0.4-0.6-0.9-0.8-1.4c-0.1-0.2-0.1-0.4-0.2-0.5c-0.1-0.2-0.1-0.3-0.1-0.5 c0,0,0-0.1,0-0.1c0,0,0.1-0.1,0.1-0.1c0,0,0.1,0,0.1,0c0.1,0.2,0.2,0.5,0.3,0.7c0.3,0.7,0.7,1.3,1.1,1.8c0,0,0,0,0,0 c0.4,0.4,0.7,0.8,1.1,1.1c0,0,0,0,0,0c0,0,0-0.1,0-0.1c-0.3-0.4-0.5-0.9-0.6-1.4c0-0.2-0.1-0.4-0.1-0.6c0-0.2-0.1-0.5,0-0.7 c0,0,0,0,0.1-0.1c0,0,0,0,0,0c0.1,0.3,0.2,0.7,0.4,1c0.1,0.2,0.2,0.4,0.2,0.6c0,0,0.1,0.1,0.1,0c0,0,0,0,0,0 c0.1-0.2,0.2-0.5,0.4-0.7c0.1-0.1,0.1-0.2,0.2-0.2c0.3-0.4,0.6-0.7,1.1-0.8c0.4-0.1,0.8-0.2,1.2-0.2c0.2,0,0.5,0,0.7,0 c0.2,0,0.4,0,0.6,0c0.3,0,0.5,0,0.8,0c0.2,0,0.4,0,0.6,0c0.3,0,0.7,0,1,0c0.1,0,0.2,0,0.3,0c0.2,0.1,0.5,0.1,0.7,0.1 c0.3,0,0.5,0.1,0.7,0.1c0.4,0,0.8,0.1,1.2,0.2c0,0,0.1,0,0.1,0c0.3,0.1,0.7,0.1,1,0.2c0.3,0.1,0.7,0.1,1,0.2 c0.6,0.1,1.1,0.2,1.7,0.4c0.3,0.1,0.6,0.2,0.9,0.2c0.3,0,0.6,0.1,0.9,0.1c0.1,0,0.1,0,0.2,0c0.2,0.1,0.5,0.1,0.7,0.1 c0.1,0,0.2,0,0.3,0c0.3,0.1,0.5,0.1,0.8,0.1c0.8,0,1.5,0,2.3,0c0.4,0,0.8-0.1,1.3-0.1c0.3,0,0.6-0.1,0.8-0.2 c0.4-0.1,0.8-0.3,1.1-0.5c0.1-0.1,0.2-0.2,0.3-0.2c0.1-0.1,0.2-0.1,0.3-0.1c0.1,0,0.1,0,0.2,0.1c0,0.1,0,0.2,0,0.2 c-0.2,0.2-0.4,0.3-0.6,0.5c-0.2,0.2-0.4,0.3-0.7,0.4c-0.6,0.3-1.2,0.5-1.9,0.6c-0.3,0.1-0.6,0.1-0.9,0.1c-0.3,0.1-0.7,0.1-1,0.1 c-0.9,0-1.8,0-2.8-0.1c-0.4-0.1-0.7-0.1-1.1-0.1c-0.4-0.1-0.8-0.1-1.3-0.2c-0.2-0.1-0.5-0.1-0.7-0.1c-0.6-0.1-1.1-0.2-1.6-0.3 c-0.4-0.1-0.8-0.1-1.2-0.2c-0.3-0.1-0.7-0.1-1-0.1c-0.2,0-0.4-0.1-0.6-0.1c-0.2,0-0.4-0.1-0.6-0.1c-0.3,0-0.5,0-0.8-0.1 c-0.5,0-1-0.1-1.5-0.1c-0.6,0-1.3,0-1.9,0c-0.2,0-0.4,0-0.6,0c-0.4,0-0.7,0.1-1,0.2c-0.1,0-0.1,0.1-0.2,0.1 c-0.3,0.2-0.5,0.5-0.7,0.9c-0.1,0.2-0.1,0.4,0,0.6c0.1,0.2,0.2,0.5,0.4,0.6c0.3,0.2,0.5,0.5,0.8,0.7c0.1,0.1,0.2,0.2,0.3,0.2 c0.1,0.1,0.1,0.1,0.1,0.2c0,0.1,0,0.2-0.1,0.2c-0.7,0.2-0.7,0.2-1.5,0.2c-0.1,0-0.3,0-0.4,0c-0.1,0-0.2,0-0.2,0 c-0.7-0.1-1.4-0.4-2-0.8c-0.1-0.1-0.2-0.1-0.3-0.2c-0.5-0.4-0.9-0.8-1.3-1.2c-0.4-0.5-0.7-0.9-1-1.4c0,0-0.1-0.1-0.1-0.1 c0,0-0.1-0.1-0.1,0c0,0-0.1,0-0.1,0.1c-0.1,0.4,0,0.9,0,1.3c0,0.1,0,0.2,0.1,0.2c0.1,0.4,0.3,0.7,0.5,1c0.1,0.1,0.2,0.3,0.2,0.4 c0,0.1,0,0.1,0,0.2c0,0.2-0.1,0.3-0.3,0.3c-0.2,0-0.3,0-0.5-0.1c-0.3-0.1-0.6-0.3-0.9-0.4c-0.4-0.2-0.9-0.4-1.2-0.8 c-0.1-0.1-0.2,0-0.2,0c0,0.3-0.1,0.6-0.2,1c-0.1,0.3-0.1,0.7-0.2,1c0,0.5-0.2,1-0.2,1.4c0,0.3,0,0.5-0.1,0.8c0,0.4-0.1,0.7,0,1.1 c0,0.1,0,0.2,0,0.3c0,0.4,0.1,0.8,0.2,1.3c0.1,0.5,0.2,1.1,0.4,1.6c0.1,0.6,0.4,1.1,0.7,1.6c0.2,0.3,0.2,0.3,0.4,0 c0.2-0.2,0.4-0.4,0.6-0.7c0.3-0.4,0.7-0.6,1.2-0.8c0.1,0,0.2,0,0.3,0c0.1,0.1,0.2,0.1,0.2,0.2c0.1,0.1,0.1,0.3,0.1,0.4 c0,0.2,0,0.4,0,0.6c0,0.6,0,1.1,0,1.7c0,0.2,0,0.3,0.1,0.5c0,0.1,0,0.3,0.1,0.4c0,0.2,0,0.3,0.1,0.5c0.1,0.6,0.3,1.1,0.5,1.7 c0.1,0.5,0.3,0.9,0.6,1.3c0.4,0.6,0.8,1.2,1.3,1.9c0.1,0.2,0.2,0.3,0.4,0.4c0,0,0.1,0,0.2,0c0.3-0.4,0.6-0.8,0.9-1.1 c0.2-0.3,0.5-0.5,0.8-0.7c0.1-0.1,0.2-0.1,0.3-0.2c0.2-0.1,0.5,0,0.6,0.2c0.1,0.2,0.2,0.3,0.2,0.5c0,0.1,0,0.3,0,0.4 c0,0.5,0,1,0.1,1.5c0,0.1,0,0.1,0,0.2c0.1,0.6,0.2,1.1,0.3,1.6c0.1,0.3,0.2,0.7,0.3,1c0.2,0.7,0.6,1.4,0.9,2.1c0,0,0.1,0.1,0.1,0.1 c0-0.1,0.1-0.1,0.1-0.2c0.3-0.7,0.8-1.3,1.3-2c0.1-0.1,0.2-0.3,0.4-0.3c0.2-0.1,0.3-0.1,0.5,0c0.1,0.1,0.2,0.2,0.3,0.3 c0.1,0.2,0.2,0.4,0.3,0.6c0.1,0.4,0.2,0.9,0.4,1.3c0.1,0.4,0.2,0.7,0.4,1c0.3,0.7,0.6,1.3,1,1.9c0.3,0.5,0.7,1,1.1,1.5 c0.6,0.7,1.4,1.3,2.1,1.9c0,0,0.1,0.1,0.1,0.1c0.7,0.5,1.4,1,2.1,1.5c0.1,0,0.1,0.1,0.2,0.1c0.9,0.5,1.7,1.1,2.6,1.5 c0.3,0.2,0.6,0.4,1,0.6c0.5,0.3,1,0.7,1.5,1c0.2,0.1,0.3,0.2,0.5,0.4c0.7,0.4,1.2,0.9,1.8,1.5c0.1,0.1,0.2,0.2,0.2,0.3 c0.2,0.2,0.4,0.4,0.5,0.6c0.1,0.1,0.2,0.2,0.4,0.3c0.4,0.3,0.7,0.6,1.1,0.9c0.2,0.2,0.5,0.4,0.7,0.7c0.1,0.1,0.3,0.3,0.4,0.4 c0.5,0.7,1,1.4,1.4,2.1c0.5,0.9,0.9,1.7,1.4,2.6c0.3,0.5,0.5,1,0.7,1.5c0.3,0.8,0.5,1.5,0.7,2.3c0.2,0.7,0.4,1.4,0.5,2.2 c0,0.2,0.1,0.4,0.1,0.6c0.1,0.8,0.3,1.5,0.4,2.3c0,0,0,0,0,0.1c0.1,0.2,0.1,0.4,0.1,0.6c0,0.1,0,0.2,0,0.3c0.1,0.2,0.1,0.4,0.1,0.6 c0,0.1,0,0.2,0,0.3c0,0.2,0.1,0.4,0.1,0.6c0,0.1,0,0.2,0,0.3c0.1,0.3,0.1,0.7,0.1,1c0,0.1,0,0.2,0,0.3c0,0.2,0.1,0.3,0.1,0.5 c0,0.5,0.1,1,0.1,1.5c0,0.1,0,0.2,0,0.2c0,0.1,0,0.2,0,0.3c0,0.3,0,0.6,0.1,0.9c0.1,0.3,0,0.6,0.1,0.9c0,0.5,0.2,1,0.3,1.5 c0.2,0.7,0.4,1.4,0.6,2c0.5,1.4,1.1,2.8,1.7,4.2c0.3,0.7,0.7,1.3,1.1,1.9c0.2,0.4,0.4,0.8,0.7,1.1c0.4,0.6,0.9,1.2,1.3,1.8 c0.5,0.7,1.1,1.4,1.8,2c0.5,0.4,0.9,0.8,1.4,1.3c0.1,0.1,0.2,0.2,0.4,0.3c0.1,0,0.1,0.1,0.2,0.1c0.1,0,0.1,0,0.1-0.1 c0-0.2,0.1-0.5,0.1-0.7c0.1-0.3,0.2-0.6,0.4-0.9c0.2-0.4,0.6-0.7,0.9-1c0.1-0.1,0.2-0.1,0.3,0c0,0,0.1,0.1,0.1,0.1 c0.1,0.1,0.1,0.2,0.1,0.4c0,0.2,0,0.4,0,0.6c0.1,0.4,0.1,0.8,0.2,1.2c0.3,1.1,0.7,2.1,1.2,3.1c0.2,0.4,0.5,0.8,0.8,1.1 c0.1,0.2,0.2,0.2,0.3,0c0-0.1,0.1-0.2,0.1-0.3c0.2-0.4,0.5-0.8,0.7-1.2c0.1-0.1,0.1-0.1,0.2-0.2c0.1-0.1,0.4-0.1,0.5,0.1 c0.1,0.1,0.2,0.3,0.2,0.4c0,0.2,0,0.3,0,0.5c0,0.1,0,0.2,0,0.3c0.1,0.2,0.1,0.4,0.2,0.6c0.2,0.7,0.5,1.3,0.8,1.9 c0,0.1,0.1,0.1,0.1,0.2c0,0,0.1,0,0.2,0c0.2-0.3,0.3-0.5,0.5-0.8c0.2-0.4,0.4-0.9,0.6-1.3c0,0,0-0.1,0.1-0.1s0.1,0,0.1-0.1 c0.1-0.1,0.3,0,0.4,0.1c0.1,0.1,0.1,0.3,0.1,0.4c0,0.2,0,0.3,0,0.5c0,0.2,0,0.5,0.1,0.7c0.1,0.4,0.3,0.8,0.5,1.2 c0.1,0.2,0.3,0.4,0.4,0.6c0.1,0.1,0.3,0.2,0.4,0.3c0.3,0.2,0.6,0.4,0.8,0.6c0.5,0.3,1,0.6,1.5,1c0.7,0.5,1.4,1,1.9,1.7 c0,0,0.1,0.1,0.1,0.1c0.5,0.5,0.9,1.1,1.3,1.7c0.2,0.4,0.4,0.7,0.6,1.1c0.2,0.4,0.3,0.7,0.4,1.1c0,0.2,0.1,0.3,0.1,0.5 c0,0.1,0,0.1,0,0.2c0,0.1-0.1,0.1-0.2,0.1c-0.1,0-0.2,0-0.2-0.1c-0.1-0.1-0.1-0.2-0.2-0.4c-0.2-0.3-0.3-0.7-0.5-1 c-0.5-0.9-1.2-1.7-1.8-2.5c0,0-0.1-0.1-0.1-0.1c0,0-0.1,0-0.1,0c0,0,0,0.1,0,0.2c0,0.1,0,0.1,0.1,0.2c0.1,0.4,0.3,0.7,0.4,1.1 c0.2,0.5,0.3,1,0.4,1.6c0.2,0.9,0.4,1.7,0.4,2.6c0,0,0,0.1,0,0.1c0.1,0.2,0.1,0.5,0.1,0.8c0,0.2,0,0.4,0,0.6 c0.1,0.3,0.1,0.6,0.1,0.9c0,1.1,0,2.2,0,3.2c0,0.3,0,0.6-0.1,0.9s0,0.6-0.1,0.9c0,0,0,0,0,0.1c-0.1,0.4-0.1,0.8-0.2,1.1 c-0.1,0.6-0.2,1.2-0.4,1.8c-0.1,0.4-0.2,0.8-0.4,1.1c-0.2,0.3-0.4,0.6-0.7,0.9c-0.5,0.4-1.1,0.7-1.6,0.9c-0.1,0-0.2,0.1-0.3,0.1 c-0.5,0.1-1,0.3-1.6,0.3c-0.2,0-0.5,0-0.7,0c-0.4-0.1-0.8-0.1-1.2,0c-0.1,0-0.2,0-0.3,0.1c-0.5,0.2-0.9,0.3-1.4,0.5c0,0,0,0-0.1,0 c0,0-0.1,0.1-0.1,0.2c0,0.1,0,0.2,0,0.2c0.1,0.3,0.2,0.7,0.4,1c0,0,0,0.1-0.1,0.1c-0.1,0-0.2,0-0.3,0c-0.1-0.1-0.2-0.2-0.3-0.3 c-0.1-0.1-0.1-0.2-0.2-0.2c-0.3,0.1-0.7,0.2-1,0.3c-0.3,0.1-0.5,0.2-0.8,0.3c-0.4,0.2-0.8,0.4-1.2,0.7c-0.3,0.2-0.7,0.5-1,0.8 c-0.3,0.4-0.7,0.9-0.9,1.4c0,0,0,0,0,0.1c0,0,0,0.1,0.1,0c0.4-0.2,0.7-0.3,1.1-0.5c0.1,0,0.1-0.1,0.1-0.1c0-0.1-0.1-0.2-0.1-0.3 c0-0.1,0-0.2,0.1-0.2c0.1-0.1,0.1-0.1,0.2,0c0.1,0.1,0.2,0.2,0.3,0.3c0.1,0.1,0.2,0.1,0.3,0c0.1,0,0.1-0.1,0.1-0.1 c-0.1-0.1-0.1-0.2-0.2-0.4c0-0.1,0-0.1,0-0.2c0,0,0-0.1,0.1-0.1c0.1,0,0.1,0,0.2,0c0,0,0.1,0.1,0.1,0.1c0.1,0.2,0.2,0.3,0.3,0.5 c0,0,0.1,0.1,0.1,0.1c0.1,0,0.1,0,0.2,0c0,0,0.1-0.1,0.1-0.1c0-0.1-0.1-0.2-0.1-0.3c-0.1-0.1-0.1-0.3-0.1-0.4 c0-0.1,0.1-0.2,0.2-0.2c0.1,0,0.1,0.1,0.2,0.1c0.1,0.1,0.1,0.2,0.2,0.2c0.1,0.2,0.1,0.3,0.2,0.5c0,0,0.1,0,0.1,0.1 c0,0,0.1,0,0.1-0.1c0,0,0-0.1,0-0.1c-0.2-0.2-0.2-0.5-0.2-0.8c0,0,0.1-0.1,0.1-0.1c0,0,0.1,0,0.2,0s0.1,0.1,0.1,0.1 c0.2,0.2,0.3,0.5,0.4,0.8c0,0.1,0.2,0.2,0.3,0.1c0,0,0.1-0.1,0.1-0.1c-0.1-0.3-0.2-0.6-0.3-0.9c0-0.1,0-0.2,0-0.3 c0-0.1,0-0.1,0.1-0.1s0.1,0,0.2,0c0.2,0.2,0.3,0.4,0.4,0.6c0,0.1,0.1,0.2,0.1,0.3c0,0.1,0.1,0.1,0.1,0.2c0,0,0.1,0.1,0.1,0 c0.2-0.2,0.5-0.4,0.7-0.6c0.4-0.2,0.7-0.4,1.1-0.6c0.3-0.1,0.6-0.1,0.9-0.2c0.1,0,0.3,0,0.4,0.1c0.1,0.1,0.1,0.3,0,0.3 c-0.2,0.1-0.4,0.2-0.7,0.3c-0.3,0.2-0.7,0.4-1,0.6c-0.4,0.3-0.8,0.6-1.2,0.9c-0.2,0.1-0.3,0.3-0.4,0.5c-0.1,0.1-0.1,0.2-0.2,0.3 c-0.5,0.6-0.9,1.3-1.1,2c0,0,0,0.1,0,0.2c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1-0.1c0.2-0.2,0.5-0.4,0.7-0.6c0,0,0-0.1,0.1-0.1 c-0.1-0.1-0.1-0.2-0.2-0.3c0,0-0.1-0.1-0.1-0.2c0,0,0-0.1,0.1-0.1s0.1,0,0.1,0c0,0,0.1,0,0.1,0c0.1,0.1,0.2,0.2,0.3,0.2 c0.1,0,0.1,0.1,0.2,0c0.1,0,0.1-0.1,0.2-0.1c0,0,0.1-0.1,0-0.1c0-0.1-0.1-0.2-0.2-0.2c0,0,0-0.1,0-0.2c0,0,0-0.1,0-0.1 c0,0,0.1,0,0.1,0c0.1,0.1,0.2,0.1,0.2,0.2c0.1,0,0.1,0.1,0.2,0.1c0,0,0.1,0,0.1,0c0,0,0,0,0,0c0-0.1,0-0.1,0-0.2 c0-0.1-0.1-0.2-0.1-0.3c0-0.1,0-0.1,0.1-0.2c0.1,0,0.2,0,0.2,0c0,0,0.1,0.1,0.1,0.1c0.1,0.1,0.1,0.1,0.2,0.2c0,0,0.1,0,0.2,0 c0,0,0.1-0.1,0.1-0.1c0-0.1-0.1-0.2-0.2-0.4c0-0.1,0-0.2,0.1-0.2c0.1,0,0.1,0,0.2,0c0,0,0.1,0.1,0.1,0.1c0.1,0.1,0.2,0.2,0.2,0.2 c0,0,0.1,0,0.2,0c0.1-0.1,0.1-0.1,0.1-0.2c0-0.1-0.1-0.1-0.1-0.2c0,0,0-0.1,0-0.1c0-0.1,0-0.1,0.1-0.2c0,0,0.1,0,0.2,0 c0,0,0.1,0,0.1,0.1c0.1,0.1,0.2,0.2,0.3,0.3c0,0,0.1,0.1,0.2,0c0,0,0.1-0.1,0.1-0.1c-0.1-0.1-0.1-0.2-0.1-0.3c0,0,0-0.1-0.1-0.1 c0-0.1,0-0.2,0.1-0.2c0.1,0,0.1,0,0.2,0c0.1,0.1,0.2,0.1,0.3,0.3c0.1,0.1,0.1,0.2,0.3,0.3c0.4-0.1,0.8-0.2,1.3-0.2 c0.1,0,0.2-0.1,0.3-0.1c0.1-0.1,0.1-0.1,0.2-0.2c0.4-0.3,0.8-0.6,1.3-0.8c0.2-0.1,0.4-0.1,0.6-0.1c0.1,0,0.1,0,0.2,0.1 c0.1,0.1,0.1,0.2,0,0.3c-0.1,0.1-0.2,0.2-0.3,0.2c-0.2,0.2-0.5,0.3-0.7,0.5c-0.1,0.1-0.3,0.2-0.4,0.4c-0.1,0.1-0.3,0.3-0.4,0.4 c-0.5,0.5-0.9,1.1-1.1,1.7c-0.3,0.7-0.5,1.4-0.3,2.2c0,0,0,0.1,0.1,0.1c0,0,0,0,0,0c0.2-0.3,0.4-0.5,0.6-0.7 c0.1-0.1,0.2-0.3,0.3-0.4c-0.1-0.1-0.2-0.2-0.3-0.4c0,0-0.1-0.1-0.1-0.2c0-0.1,0-0.2,0.1-0.2c0.1,0,0.2,0,0.3,0.1 c0.1,0.1,0.3,0.2,0.4,0.3c0.1-0.1,0.2-0.1,0.3-0.2c0,0,0-0.1,0-0.1c-0.1-0.1-0.2-0.2-0.3-0.3c-0.1-0.1-0.1-0.1-0.1-0.2 c0-0.1,0-0.1,0-0.2c0-0.1,0.1-0.1,0.2-0.1c0.1,0,0.2,0,0.3,0.1c0.1,0.1,0.2,0.2,0.4,0.3c0,0,0,0,0.1,0c0.1-0.1,0.2-0.1,0.3-0.2 c0,0,0-0.1,0-0.1c-0.1-0.1-0.3-0.3-0.4-0.5c0,0,0-0.1,0-0.1c0.1-0.1,0.2-0.1,0.3-0.1c0.1,0,0.1,0.1,0.2,0.1 c0.1,0.1,0.2,0.2,0.3,0.3c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1-0.1c0.1-0.1,0.1-0.1,0-0.2c-0.1-0.1-0.1-0.2-0.2-0.3c0,0,0-0.1,0-0.1 c0,0,0-0.1,0.1-0.1c0.1,0,0.2,0,0.3,0c0.1,0.1,0.2,0.1,0.3,0.2c0.1,0.1,0.2,0,0.3,0c0.2-0.1,0.2-0.2,0.1-0.4c0-0.1,0-0.1-0.1-0.2 c0,0,0-0.1,0-0.1c0-0.1,0.1-0.1,0.1-0.1c0.2,0,0.3,0.2,0.5,0.3c0.1-0.1,0.3-0.1,0.5-0.2c0.4-0.2,0.9-0.2,1.3-0.3 c0.1,0,0.1,0,0.2,0.1c0,0,0,0.1,0,0.2s-0.1,0.1-0.1,0.1c-0.3,0.2-0.6,0.3-0.9,0.5c-0.3,0.1-0.6,0.3-0.9,0.5 c-0.2,0.1-0.2,0.2-0.2,0.4c0,0.2,0,0.4,0.2,0.6c0.1,0.1,0.1,0.1,0.2,0.2c0.1,0.2,0.3,0.3,0.6,0.3c0.3,0,0.7,0,1-0.1 c0.2-0.1,0.5-0.1,0.7-0.2c0.5-0.1,1-0.2,1.5-0.3c0.5-0.1,0.9-0.2,1.4-0.3c0.2,0,0.4-0.1,0.6-0.1c0.3-0.1,0.5-0.1,0.8-0.2 c0.1,0,0.2-0.1,0.3-0.2c0.3-0.2,0.6-0.4,0.9-0.6c0.4-0.2,0.7-0.5,1-0.8c0,0,0-0.1,0-0.1c0,0,0.1,0,0.1,0l0,0c0,0-0.1,0,0,0.1 c-0.1,0-0.1,0-0.2,0c-1,0.5-2,0.8-3.1,1.1c-0.4,0.1-0.7,0.2-1.1,0.3c-0.5,0.2-1.3,0.3-1.8,0.5c-0.4,0.1-0.8,0.2-1.2,0.3 c-0.1,0-0.2,0-0.3,0c0,0-0.1,0-0.1,0c0,0,0,0,0,0c0,0,0-0.1,0-0.1c0.2-0.1,0.3-0.1,0.5-0.2c0.4-0.1,0.8-0.2,1.2-0.3 c0.6-0.1,1.1-0.3,1.6-0.5c0.8-0.3,1.5-0.5,2.3-0.8c0.3-0.1,0.6-0.2,0.9-0.4c0.7-0.3,1.4-0.6,2.1-1c0.1-0.1,0.2-0.2,0.3-0.3 c0-0.1,0.1-0.2,0.1-0.3c0,0-0.1-0.1-0.1-0.1c-0.4,0.2-0.8,0.4-1.2,0.5c-1.1,0.5-2.3,1-3.5,1.4c-0.6,0.2-1.2,0.4-1.9,0.6 c-0.2,0-0.4,0.1-0.6,0.1c0,0,0,0,0,0c0,0,0-0.1,0-0.1c0.2-0.1,0.4-0.2,0.6-0.3c0.8-0.3,1.7-0.7,2.5-1c0.6-0.2,1.2-0.4,1.7-0.7 c0.9-0.3,1.7-0.7,2.5-1.1c0.1,0,0.1-0.1,0.2-0.1c0.1,0,0.1-0.1,0.1-0.2c0-0.1,0-0.2,0-0.3c0,0,0-0.1-0.1-0.1c-0.1,0-0.1,0-0.2,0.1 c-0.5,0.3-1,0.5-1.6,0.7c-1.1,0.4-2.1,0.8-3.2,1.3c-0.1,0.1-0.3,0.1-0.4,0.1c-0.1,0-0.2,0-0.2,0c0,0-0.1-0.1-0.1-0.1 c0-0.1,0.1-0.2,0.2-0.2c0.4-0.2,0.7-0.5,1.1-0.6c0.9-0.4,1.7-0.8,2.6-1.2c0.2-0.1,0.4-0.2,0.6-0.3c0.4-0.2,0.7-0.3,1.1-0.5 c0.1,0,0.1-0.1,0.1-0.1c0-0.1,0-0.2,0-0.3c0-0.1-0.1-0.1-0.2-0.1c-0.4,0.3-0.9,0.5-1.3,0.7c-0.8,0.4-1.6,0.7-2.5,1 c0,0-0.1,0-0.1-0.1s0-0.1,0-0.2c0,0,0.1-0.1,0.1-0.1c0.8-0.5,1.6-0.9,2.5-1.4c0.4-0.2,0.8-0.5,1.2-0.6c0.1,0,0.2-0.1,0.1-0.2 c0-0.1-0.1-0.3-0.2-0.4c0-0.1-0.1-0.1-0.2,0c-0.1,0.1-0.3,0.2-0.4,0.3c-0.5,0.3-1,0.5-1.5,0.7c-0.1,0-0.2,0.1-0.3,0 c0,0-0.1,0-0.1-0.1c0,0,0-0.1,0-0.1c0.1-0.1,0.3-0.2,0.4-0.3c0.5-0.3,1-0.6,1.5-0.8c0.1-0.1,0.2-0.1,0.3-0.1c0,0,0.1-0.1,0.1-0.2 c-0.1-0.2-0.1-0.4-0.2-0.5c0,0-0.1-0.1-0.1,0c-0.1,0-0.1,0-0.2,0.1c-0.4,0.3-0.9,0.4-1.4,0.5c-0.1,0-0.1,0-0.2,0 c-0.1,0-0.1,0-0.1-0.1c0,0,0-0.1,0-0.2c0.1-0.2,0.3-0.3,0.5-0.4c0.3-0.2,0.7-0.4,1-0.5c0.1,0,0.1-0.1,0.1-0.2 c-0.1-0.1-0.1-0.3-0.2-0.4c0,0-0.1,0-0.1,0c-0.1,0-0.1,0-0.2,0.1c-0.3,0.2-0.6,0.3-0.9,0.4c0,0-0.1,0-0.2-0.1c0-0.1,0-0.2,0-0.2 c0,0,0.1,0,0.1-0.1c0.2-0.1,0.5-0.2,0.7-0.3c0.1,0,0.1-0.1,0.2-0.1c0,0,0.1-0.1,0.1-0.2c0-0.1-0.1-0.1-0.1-0.2 c-0.1-0.2-0.1-0.2-0.4-0.2c-0.2,0-0.3,0.1-0.5,0.1c-0.1,0-0.3-0.1-0.3-0.2c-0.1-0.1,0-0.2,0-0.3c0.1-0.1,0.2-0.1,0.3-0.2 c0.2-0.1,0.4-0.1,0.5-0.3c0,0,0-0.1-0.1-0.6c-0.1-0.3-0.2-0.6-0.3-0.9c-0.2-0.6-0.3-1.2-0.4-1.8c-0.1-0.5-0.2-1-0.2-1.4 c0-0.1,0-0.2,0-0.3c0-0.3-0.1-0.6,0-0.9c0-0.3,0-0.5,0.1-0.8c0-0.2,0-0.3,0-0.5c0.1-0.4,0.1-0.8,0.2-1.1c0.1-0.4,0.2-0.9,0.3-1.3 c0.4-1.3,1-2.5,1.7-3.6c0.2-0.2,0.3-0.5,0.5-0.7c0.1-0.2,0.2-0.4,0.4-0.6c0.1-0.2,0.2-0.4,0.3-0.6c0.2-0.5,0.4-1,0.4-1.5 c0-0.2,0-0.3,0-0.5c0-0.7-0.2-1.2-0.6-1.8c-0.2-0.4-0.5-0.7-0.8-1.1c-0.1-0.1-0.2-0.1-0.3,0c-0.3,0.2-0.7,0.4-1,0.6 c-0.1,0.1-0.3,0.1-0.4,0.2c-0.1,0-0.2,0-0.3-0.1c-0.1,0,0-0.2,0-0.2c0.2-0.1,0.3-0.1,0.5-0.2c0.2-0.1,0.5-0.3,0.7-0.4 c0.1-0.1,0.2-0.1,0.3-0.2c0,0,0.1-0.1,0-0.2c-0.1-0.1-0.2-0.3-0.4-0.3c0,0-0.1,0.1-0.1,0.1c-0.4,0.3-0.8,0.5-1.2,0.6 c-0.1,0.1-0.3,0.1-0.5,0c0,0-0.1,0,0-0.1c0,0,0-0.1,0.1-0.1c0.4-0.3,0.9-0.5,1.3-0.7c0.1,0,0.1-0.1,0.1-0.1c0,0,0,0,0-0.1 c0,0,0,0,0,0c-0.1-0.1-0.2-0.1-0.3-0.2c-0.1-0.1-0.2-0.2-0.3-0.2c-0.1,0-0.2,0.1-0.2,0.1c-0.4,0.3-0.8,0.4-1.2,0.6 c-0.1,0.1-0.3,0.1-0.5,0.1c0,0-0.1,0-0.1,0c0,0-0.1-0.1-0.1-0.1c0,0,0-0.1,0-0.1c0.2-0.1,0.3-0.2,0.5-0.3c0.3-0.2,0.6-0.3,1-0.4 c0.1,0,0.1-0.1,0.2-0.2c0,0-0.1-0.1-0.1-0.1c-0.1-0.1-0.3-0.2-0.4-0.3c-0.1-0.1-0.1,0-0.2,0c-0.1,0.1-0.2,0.1-0.4,0.2 c-0.4,0.2-0.9,0.3-1.3,0.4c-0.1,0-0.2,0-0.2,0c0,0-0.1,0-0.1,0c-0.1,0-0.1-0.2,0-0.2c0,0,0.1-0.1,0.1-0.1c0.1-0.1,0.3-0.1,0.4-0.2 c0.2-0.1,0.5-0.2,0.7-0.2c0.1,0,0.2-0.1,0.3-0.1c0,0,0-0.1,0-0.2c-0.1-0.1-0.2-0.2-0.4-0.3c-0.2,0.1-0.3,0.2-0.5,0.3 c-0.2,0.1-0.5,0.2-0.7,0.3c-0.1,0-0.3,0-0.4,0c0,0-0.1,0-0.1-0.1c0,0,0-0.1,0-0.1s0-0.1,0.1-0.1c0.1-0.1,0.2-0.1,0.3-0.2 c0.3-0.1,0.5-0.2,0.8-0.4c0,0,0-0.1,0-0.1c-0.1-0.1-0.1-0.1-0.2-0.2c-0.1,0-0.2,0.1-0.2,0.1c-0.2,0.1-0.5,0.2-0.8,0.3 c-0.1,0-0.2,0-0.3,0c0,0,0.1-0.1,0.1-0.1c0.1-0.1,0.3-0.2,0.4-0.2c0.1-0.1,0.3-0.1,0.4-0.2c0,0,0.1-0.1,0-0.1 c-0.1-0.1-0.3-0.2-0.4-0.3c0,0-0.1,0-0.2,0s-0.1,0-0.2,0.1c-0.3,0.1-0.5,0.2-0.8,0.3c-0.1,0-0.2,0-0.3,0c0,0-0.1-0.1-0.1-0.1 c0,0,0-0.1,0-0.2c0.1-0.1,0.2-0.1,0.4-0.2c0.2-0.1,0.3-0.1,0.5-0.2c0,0,0.1-0.1,0-0.2c-0.1-0.1-0.1-0.1-0.2-0.2 c-0.1-0.1-0.2-0.1-0.4-0.1c-0.2,0.1-0.4,0.2-0.6,0.2c0,0-0.1,0-0.1,0c-0.1,0-0.1,0-0.2-0.1c0-0.1,0-0.2,0-0.2 c0.1-0.1,0.2-0.1,0.3-0.2c0.1-0.1,0.2-0.1,0.3-0.2c0,0,0-0.1,0-0.1c-0.1-0.1-0.2-0.2-0.3-0.3c-0.1,0-0.2,0.1-0.3,0.1 c-0.2,0.1-0.4,0.1-0.6,0.1c-0.1,0-0.1-0.2-0.1-0.2c0,0,0.1-0.1,0.1-0.1c0.1-0.1,0.3-0.2,0.4-0.2c0,0,0.1-0.1,0-0.2 s-0.1-0.1-0.1-0.1c-0.5-0.6-0.9-1.3-1.1-2c0-0.1-0.1-0.1-0.1-0.2c0,0-0.1,0-0.1,0.1c-0.1,0.1-0.1,0.3-0.1,0.4c0,0.5,0,1.1,0.1,1.6 c0.1,0.5,0.3,0.9,0.5,1.4c0.3,0.7,0.7,1.3,1.2,1.9c0.1,0.2,0.3,0.3,0.4,0.5c0.2,0.3,0.4,0.6,0.7,1c0.5,0.7,0.8,1.4,1,2.2 c0.1,0.2,0.1,0.5,0.1,0.7c0,0.5,0.1,0.9,0.1,1.4c0,0.1,0,0.2,0.1,0.3c0,0.2,0,0.5,0,0.8c0,0.1-0.1,0.2-0.1,0.3 c-0.1,0.1-0.2,0.1-0.4,0c-0.1-0.1-0.2-0.2-0.2-0.3c-0.1-0.6-0.2-1.1-0.4-1.7c-0.1-0.4-0.2-0.9-0.3-1.3c-0.2-0.6-0.4-1.1-0.7-1.6 c-0.3-0.5-0.7-1-1-1.4c-0.3-0.4-0.6-0.8-0.9-1.2c-0.5-0.7-0.8-1.4-1.1-2.2c-0.1-0.3-0.1-0.5-0.2-0.8c0-0.1,0-0.2,0-0.3 c0-0.1,0-0.2,0-0.3c0-0.3-0.1-0.5,0-0.8c0-0.2,0.1-0.4,0.1-0.6c0-0.2,0-0.3,0.1-0.5c0.1-0.4,0.2-0.8,0.3-1.2 c0.1-0.5,0.3-0.9,0.5-1.3c0.1-0.2,0.2-0.3,0.3-0.4c0.1-0.1,0.2-0.1,0.3-0.1c0.3,0,0.7-0.1,1-0.1c0.5,0,0.9-0.2,1.4-0.3 c0,0,0.1-0.1,0.1-0.1c-0.1-0.2-0.3-0.2-0.5-0.3c-0.2-0.1-0.4-0.3-0.5-0.5c-0.2-0.2-0.3-0.5-0.4-0.8c-0.2-0.4-0.3-0.8-0.2-1.2 c0-0.1,0-0.2,0-0.2c0-0.1,0.1-0.3,0.2-0.4c0.1-0.1,0.2-0.2,0.4-0.3c0.3-0.1,0.6-0.1,0.8-0.2c0.1,0,0.3-0.1,0.4-0.1 c0,0,0.1,0,0.1-0.1c0,0,0-0.1-0.1-0.1c-0.3-0.2-0.5-0.4-0.8-0.7c-0.3-0.3-0.5-0.6-0.6-1c-0.1-0.3-0.3-0.7-0.4-1 c-0.1-0.5-0.2-0.9-0.3-1.4c0-0.6,0-1.1,0-1.7c0-0.1,0-0.2,0-0.3c0-0.2,0-0.3,0.1-0.5c0-0.2,0-0.3,0-0.5c0.1-0.3,0.1-0.5,0.1-0.8 c0-0.1,0-0.3,0-0.4c0-0.2,0.1-0.4,0.1-0.6c0-0.9,0-1.7,0-2.6c0-0.1,0-0.2,0-0.3c-0.1-0.3-0.1-0.5-0.1-0.8c0-0.3-0.1-0.6-0.1-0.9 c-0.1-0.4-0.1-0.9-0.1-1.3c-0.1-0.3-0.1-0.5-0.1-0.8c-0.1-0.3-0.1-0.6-0.2-0.9c-0.1-0.6-0.3-1.2-0.5-1.8c-0.1-0.2-0.2-0.5-0.3-0.7 c-0.1-0.3-0.2-0.6-0.4-0.9c-0.2-0.4-0.3-0.9-0.6-1.3c-0.2-0.4-0.4-0.8-0.6-1.2c-0.2-0.3-0.3-0.7-0.5-1c-0.2-0.4-0.4-0.7-0.6-1.1 c-0.3-0.6-0.7-1.2-1-1.7c-0.3-0.5-0.7-0.9-1.1-1.2c-0.3-0.2-0.6-0.5-0.9-0.8c-0.1-0.2-0.2-0.2-0.4-0.3c-0.1-0.1-0.2-0.1-0.3-0.2 c-0.1-0.1-0.2-0.2-0.2-0.3c0-0.1,0-0.2,0.1-0.3c0.1-0.1,0.2-0.1,0.3,0c0.2,0.1,0.3,0.2,0.5,0.3c0.2,0.1,0.4,0.2,0.5,0.4 c0.2,0.2,0.4,0.3,0.7,0.5c0.5,0.2,0.9,0.5,1.3,0.8c0.2,0.1,0.4,0.3,0.6,0.4c0.3,0.2,0.6,0.5,0.8,0.8c0.4,0.5,0.8,1.1,1.3,1.6 c0.3,0.3,0.5,0.7,0.8,1c0.2,0.3,0.4,0.5,0.5,0.8c0.2,0.4,0.4,0.8,0.6,1.1c0.5,0.9,0.9,1.9,1.5,2.8c0.1,0.3,0.3,0.5,0.4,0.8 c0.3,0.6,0.7,1.1,1,1.7c0.3,0.4,0.6,0.8,0.9,1.2c0.5,0.5,0.9,1.1,1.5,1.5c0.1,0.1,0.2,0.2,0.3,0.3c0.1,0.1,0.2,0.2,0.4,0.3 c0.6,0.5,1.3,0.9,2,1.3c0.7,0.3,1.3,0.6,2,0.8c0.9,0.3,1.8,0.5,2.7,0.8c0.2,0,0.4,0.1,0.6,0.1c0.4,0.1,0.8,0.2,1.3,0.2 c0.1,0,0.3,0,0.4,0.1c0.3,0.1,0.6,0.1,1,0.2c0.5,0.1,1,0.2,1.5,0.2c0.1,0,0.1,0,0.2,0c0.3,0.1,0.5,0.1,0.8,0.1c0.3,0,0.7,0,1,0.1 c0.1,0,0.2,0,0.2,0c0.4,0,0.8,0,1.2,0c0.1,0,0.2,0,0.3,0c0.2,0,0.5,0,0.7,0c0.8,0,1.6,0,2.4-0.1c0.4-0.1,0.8-0.1,1.1-0.2 c0.3,0,0.5-0.1,0.8-0.2c0.5-0.1,1.1-0.2,1.6-0.4c1.1-0.4,2.1-0.8,3.1-1.2c0.1,0,0.1-0.1,0.2-0.1c1.1-0.5,2.1-1,3-1.6 c0.4-0.2,0.7-0.5,1.1-0.7c0.3-0.2,0.6-0.4,0.9-0.7c0.3-0.2,0.6-0.5,0.9-0.7c0.3-0.2,0.5-0.4,0.7-0.6c0.1-0.2,0.3-0.3,0.4-0.5 c0.6-0.5,1.2-1,1.8-1.5c0.1-0.1,0.2-0.2,0.3-0.3c0.2-0.2,0.3-0.4,0.5-0.6c0.4-0.4,0.8-0.9,1.1-1.4c0.2-0.3,0.4-0.6,0.6-0.8 c0.3-0.4,0.5-0.7,0.7-1.1c0.4-0.9,0.9-1.8,1.3-2.8c0.2-0.4,0.4-0.8,0.5-1.2c0.2-0.5,0.3-0.9,0.4-1.4c0.1-0.5,0.2-1,0.3-1.5 c0.1-0.3,0.1-0.6,0.1-0.9c0-0.1,0-0.1,0-0.2c0.1-0.3,0.1-0.7,0.1-1c0-0.3,0.1-0.7,0.1-1c0-0.3,0-0.7,0-1c0-0.7,0-1.3-0.1-2 c-0.1-0.5-0.2-1-0.3-1.4c0-0.1-0.1-0.2-0.1-0.3c-0.1-0.4-0.2-0.7-0.3-1.1c-0.3-1-0.7-1.9-1.2-2.8c-0.6-1.1-1.3-2.1-2.1-3.1 c-0.3-0.3-0.5-0.6-0.8-0.9c-0.4-0.5-0.8-1-1.3-1.5c-0.1-0.2-0.3-0.3-0.4-0.5c-0.3-0.3-0.6-0.6-0.9-0.9c-0.6-0.6-1.3-1.1-2-1.5 c-0.5-0.3-1-0.6-1.5-0.8c-0.1-0.1-0.3-0.1-0.4-0.2c-0.3-0.1-0.5-0.2-0.8-0.3c-0.5-0.2-1-0.4-1.6-0.6c-0.5-0.1-0.9-0.3-1.4-0.4 c-0.6-0.2-1.1-0.3-1.7-0.5c-0.1,0-0.3-0.1-0.5-0.1c-0.2,0-0.5-0.1-0.7-0.1c-0.2,0-0.5-0.1-0.7-0.1c-0.4,0-0.8-0.1-1.2-0.2 c-0.8-0.2-1.5-0.3-2.3-0.5c-0.5-0.1-1-0.2-1.4-0.3c-0.5-0.1-1-0.3-1.5-0.4c-0.8-0.2-1.6-0.4-2.4-0.7c-0.7-0.3-1.5-0.6-2.2-0.9 c-0.2-0.1-0.3-0.2-0.5-0.3c-0.7-0.3-1.3-0.7-1.9-1c-0.8-0.5-1.6-1-2.4-1.6c-0.6-0.4-1.1-0.9-1.7-1.4c-0.7-0.6-1.3-1.2-1.9-2 c-0.4-0.5-0.7-0.9-1-1.4c-0.3-0.4-0.5-0.8-0.7-1.2c-0.4-0.6-0.6-1.3-0.9-1.9c-0.1-0.2-0.1-0.4-0.2-0.6c-0.1-0.4-0.2-0.7-0.3-1.1 c-0.1-0.5-0.2-0.9-0.4-1.4c-0.2-0.6-0.2-1.2-0.3-1.8c0-1-0.1-2,0.1-3c0-0.1,0-0.2,0-0.3c0-0.1,0-0.2,0-0.3c0.1-0.6,0.2-1.1,0.3-1.6 c0-0.2,0.1-0.5,0.2-0.7c0.3-0.9,0.7-1.8,1.3-2.6c0.1-0.1,0.2-0.3,0.3-0.4c0.1-0.2,0.3-0.5,0.4-0.7c0.5-0.9,1.2-1.6,1.9-2.3 c0.4-0.5,0.9-0.9,1.4-1.3c0.3-0.2,0.5-0.4,0.8-0.7c0.8-0.7,1.7-1.3,2.6-2c0.5-0.3,0.9-0.6,1.4-0.9c0.1-0.1,0.3-0.2,0.4-0.2 c0.5-0.3,1-0.6,1.5-0.8c0.3-0.1,0.6-0.3,0.8-0.4c0.5-0.3,1-0.5,1.5-0.8c0.3-0.2,0.7-0.3,1.1-0.5c0.5-0.2,1-0.4,1.5-0.6 c0.3-0.1,0.6-0.2,1-0.2c0.1,0,0.2,0,0.3-0.1c0.2,0,0.4-0.1,0.6,0c0.1,0,0.2,0.1,0.2,0.2c0,0.1,0,0.2,0,0.2c0,0-0.1,0.1-0.2,0.1 c-0.1,0.1-0.3,0.1-0.4,0.1c-0.8,0.3-1.5,0.6-2.2,1c-0.4,0.2-0.8,0.4-1.2,0.6c-0.3,0.1-0.6,0.3-0.9,0.5c-0.1,0.1-0.2,0.1-0.3,0.2 c-0.2,0.1-0.3,0.1-0.5,0.2c-0.3,0.2-0.6,0.3-0.9,0.4c0,0,0,0-0.1,0c-0.1,0-0.1,0.1-0.2,0.2c-0.1,0.3-0.1,0.6-0.2,0.9 c0,0.2,0,0.3,0,0.5c0,0.2,0,0.3,0.1,0.5c0.1,0.4,0.2,0.7,0.4,1.1c0.2,0.5,0.5,1,0.9,1.4c0.4,0.5,0.9,0.9,1.5,1.1 c0.3,0.1,0.7,0.2,1,0.3c0.1,0,0.2,0,0.2,0c0,0,0,0,0,0c-0.6-0.3-1.1-0.7-1.6-1.1c-0.1-0.1-0.3-0.2-0.4-0.4 c-0.4-0.4-0.7-0.8-0.9-1.3c-0.2-0.4-0.4-0.7-0.5-1.1c0-0.1,0-0.2,0-0.3c0-0.1,0-0.1,0.1-0.1c0,0,0.1,0,0.1,0c0,0,0.1,0.1,0.1,0.2 c0.2,0.6,0.5,1.2,0.9,1.7c0.6,0.9,1.4,1.5,2.2,2c0.3,0.2,0.7,0.3,1.1,0.4c0.3,0.1,0.5,0.1,0.8,0.1c0,0,0.1,0,0.1,0c0,0,0,0,0,0 c0,0,0-0.1,0-0.1c-0.2-0.1-0.3-0.1-0.5-0.2c-0.4-0.1-0.8-0.3-1.1-0.5c-0.5-0.3-0.9-0.7-1.4-1.1c-0.1-0.1-0.2-0.2-0.2-0.3 c-0.4-0.5-0.8-1.1-1.1-1.7c-0.2-0.4-0.3-0.8-0.3-1.2c0-0.1,0-0.1,0-0.2c0,0,0,0,0,0c0,0,0.1,0,0.1,0c0.1,0.1,0.1,0.2,0.1,0.3 c0.1,0.3,0.2,0.6,0.4,0.9c0.2,0.3,0.4,0.7,0.6,1c0.4,0.6,0.8,1.1,1.4,1.4c0.4,0.3,0.8,0.6,1.3,0.7c0.6,0.2,1.2,0.3,1.8,0.3 c0,0,0,0,0,0c0,0,0,0,0-0.1c0,0-0.1-0.1-0.1-0.1c-0.4-0.1-0.8-0.3-1.1-0.5c-0.8-0.6-1.6-1.1-2.2-1.9c-0.3-0.4-0.6-0.9-0.9-1.4 c-0.2-0.4-0.2-0.7-0.2-1.1c0-0.1,0-0.1,0-0.2c0-0.1,0.1-0.1,0.2-0.1c0.1,0,0.1,0.1,0.2,0.1c0,0.3,0.1,0.6,0.2,0.8 c0.2,0.5,0.4,1,0.8,1.4c0,0,0.1,0,0.1,0c0,0,0,0.1,0.1,0.1c0,0,0,0,0,0c0,0,0,0-0.1,0c0-0.1,0-0.2,0-0.2c0-0.2,0-0.3,0-0.5 c0-0.7,0.3-1.3,0.9-1.8c0.3-0.2,0.6-0.3,0.9-0.5c0.3-0.1,0.7-0.1,1-0.1c0.2,0,0.3,0.1,0.4,0.1c0.2,0.1,0.3,0.3,0.4,0.5 c0.1,0.2,0.1,0.4,0.1,0.6c0,0.3,0.1,0.6,0.1,0.9c0,0.2,0.1,0.3,0.2,0.5c0.1,0.1,0.2,0.2,0.3,0.3c0.4,0.2,0.9,0.2,1.4,0.1 c0.2-0.1,0.5-0.2,0.7-0.2c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c-0.2-0.1-0.4-0.1-0.6-0.2c-0.4-0.1-0.8-0.5-1-0.8 c-0.1-0.2-0.3-0.4-0.3-0.6c0-0.1,0-0.2,0.1-0.2c0.1,0,0.1,0,0.1,0.1c0,0.1,0.1,0.1,0.1,0.2c0.2,0.3,0.4,0.6,0.7,0.7 c0.2,0.1,0.4,0.2,0.6,0.3c0.6,0.2,1.2,0.5,1.8,0.8c0.5,0.2,0.9,0.6,1.3,0.9c0.3,0.3,0.5,0.6,0.7,0.9c0,0,0.1,0.1,0.1,0 c0.1-0.4,0-0.7-0.2-1c-0.3-0.4-0.6-0.8-1-1c-0.4-0.2-0.7-0.4-1.1-0.7c-0.2-0.1-0.3-0.2-0.5-0.2c-0.2,0-0.4-0.1-0.5-0.2 c-0.5-0.3-0.9-0.7-1.2-1.2c-0.1-0.1-0.1-0.2-0.1-0.3c0,0,0,0,0,0c0,0,0.1,0,0.1,0c0.2,0.2,0.5,0.5,0.7,0.7c0.3,0.2,0.6,0.4,0.9,0.5 c0.2,0.1,0.3,0,0.4-0.1c0,0,0.1-0.1,0.1-0.1c0.3-0.2,0.5-0.4,0.9-0.5c0.4-0.2,0.9-0.2,1.4-0.2c0.5,0.1,1,0.3,1.5,0.6 c0.4,0.3,0.7,0.6,1.1,0.9c0.3,0.3,0.6,0.6,0.9,1c0.4,0.7,0.8,1.4,1.1,2.2c0.2,0.7,0.6,1.2,1.1,1.8c0.2,0.2,0.5,0.4,0.8,0.5 c0.1,0,0.2,0,0.2,0c0,0,0,0,0,0c0,0-0.1-0.1-0.1-0.1c-0.5-0.4-0.9-0.9-1.2-1.4c-0.2-0.3-0.2-0.7-0.3-1.1c0,0,0-0.1,0-0.1 c0,0,0,0,0,0s0,0,0.1,0c0.2,0.2,0.2,0.5,0.3,0.7c0.1,0.3,0.3,0.6,0.6,0.9c0.2,0.2,0.3,0.3,0.5,0.5c0.3,0.2,0.6,0.4,0.9,0.5 c0,0,0,0,0.1,0c0,0,0,0,0,0c-0.1-0.1-0.2-0.2-0.3-0.2c-0.2-0.2-0.4-0.3-0.5-0.5c-0.2-0.3-0.4-0.5-0.6-0.8c-0.3-0.4-0.4-0.9-0.5-1.3 c0-0.1,0-0.1,0-0.2c0-0.1,0.1-0.1,0.1-0.1c0,0,0.1,0,0.1,0.1c0,0.1,0.1,0.2,0.1,0.3c0.1,0.6,0.4,1,0.7,1.4c0,0,0.1,0,0.1,0 c0-0.1,0-0.2,0-0.2c0-0.2,0-0.4,0-0.6c0-0.4,0.2-0.6,0.6-0.8c0.2-0.1,0.4-0.2,0.6-0.2c0.2,0,0.4,0,0.6,0c0.2,0,0.4,0.1,0.6,0.1 c0,0,0,0,0.1,0c0,0,0-0.1,0-0.1c-0.2-0.2-0.4-0.4-0.6-0.5c-0.2-0.1-0.3-0.3-0.5-0.4c0,0,0-0.1,0-0.1c0,0,0,0,0,0c0.1,0,0.1,0,0.2,0 c0.2,0.1,0.4,0.2,0.6,0.3c0.2,0.2,0.5,0.4,0.7,0.6c0.3,0.3,0.7,0.6,1,1c0.2,0.2,0.4,0.5,0.6,0.7c0.2,0.3,0.4,0.6,0.6,0.9 c0.1-0.1,0.1-0.1,0.1-0.2c-0.1-0.2-0.1-0.4-0.3-0.6c-0.4-0.6-0.8-1.2-1.3-1.8c-0.5-0.6-1.1-1.2-1.7-1.6c-0.4-0.3-0.8-0.5-1.1-0.8 c-0.1-0.1-0.2-0.1-0.3-0.2c0,0,0-0.1-0.1-0.1c0,0,0-0.1,0.1-0.1c0.1,0,0.1,0,0.2,0c0.3,0.1,0.5,0.2,0.7,0.4 c0.4,0.2,0.7,0.5,1.1,0.7c0.4,0.3,0.8,0.6,1.1,0.9c0.2,0.2,0.4,0.4,0.7,0.7c0,0,0.1,0.1,0.1,0.1c0,0,0,0.1,0.1,0c0,0,0,0-0.1,0 c0-0.1,0-0.2,0-0.2c-0.1-0.1-0.1-0.3-0.2-0.4c-0.3-0.4-0.6-0.7-0.9-1c-0.5-0.5-1.1-0.9-1.6-1.4c-0.4-0.3-0.8-0.5-1.2-0.8 c-0.4-0.3-0.9-0.6-1.4-0.9c-0.1-0.1-0.2-0.1-0.3-0.2c0,0,0,0,0-0.1c0,0,0-0.1,0.1-0.1c0.1,0,0.1,0,0.2,0c0.3,0.1,0.6,0.2,0.8,0.3 c0.8,0.4,1.6,0.9,2.3,1.4c0.1,0.1,0.3,0.2,0.4,0.3c0,0,0,0,0,0c0,0,0-0.1,0-0.1c-0.3-0.4-0.7-0.7-1-1.1c-0.6-0.6-1.3-1-2-1.4 c-0.2-0.1-0.5-0.2-0.7-0.2c-0.2,0-0.4-0.1-0.6-0.1c-0.1,0-0.2-0.1-0.3-0.1c-0.2-0.1-0.2-0.3-0.2-0.5c0-0.1,0-0.1,0.1-0.2 c0.2-0.3,0.5-0.6,0.8-0.8c0,0,0-0.1,0-0.1c0,0,0,0,0,0c-0.4,0-0.9,0-1.3,0.1c-0.2,0.1-0.4,0.1-0.6,0.1c-0.1,0-0.2-0.1-0.2-0.2 c0,0,0,0,0-0.1c0,0,0,0,0,0c0.2-0.1,0.4-0.2,0.6-0.2c0.4-0.1,0.7-0.2,1.1-0.2c0.3,0,0.6,0,0.9,0c0.1,0,0.2,0,0.3,0 c0-0.1-0.1-0.1-0.2-0.1c-0.1,0-0.1-0.1-0.1-0.1c0,0,0.1,0,0.1-0.1c0,0-0.1,0-0.1-0.1c0,0,0,0,0-0.1c-0.4-0.3-0.9-0.4-1.4-0.4 c-0.1,0-0.3,0-0.4,0c-0.8,0-1.5,0.2-2.2,0.6c-0.1,0.1-0.2,0.1-0.4,0.2c-0.1,0.1-0.2,0-0.3,0c-0.2-0.1-0.3-0.2-0.4-0.3 c-0.2,0-0.3-0.1-0.5-0.2c-0.2-0.1-0.4-0.1-0.6-0.2c-0.6-0.2-1.2-0.4-1.9-0.6c-0.3-0.1-0.6-0.1-1-0.2c-0.3,0-0.6,0-0.9-0.1 c-0.2,0-0.5,0-0.8,0c-0.3,0-0.5-0.1-0.8-0.1c-0.7-0.1-1.4,0-2.1,0.1c-0.6,0.1-1.2,0.2-1.8,0.3c-0.5,0.1-0.9,0.2-1.4,0.3 c-0.6,0.2-1.2,0.4-1.9,0.6c-0.8,0.3-1.6,0.6-2.4,1.1c-0.8,0.4-1.6,0.9-2.4,1.3c-0.8,0.5-1.6,1-2.3,1.5c-0.6,0.5-1.2,0.9-1.8,1.4 c-0.7,0.5-1.3,1.1-1.9,1.7c-0.8,0.8-1.5,1.6-2.2,2.4c-0.6,0.8-1.2,1.6-1.6,2.5c-0.2,0.5-0.5,1.1-0.7,1.6c-0.3,0.8-0.6,1.6-0.8,2.4 c-0.1,0.4-0.2,0.8-0.3,1.2c-0.1,0.7-0.3,1.4-0.3,2.1c0,0.1,0,0.1,0,0.2c-0.1,0.3-0.1,0.7-0.1,1c0,0.9,0,1.7,0,2.5 c0,0.1,0,0.2,0,0.3c0.1,0.4,0.1,0.9,0.2,1.3c0,0.5,0.2,1,0.2,1.5c0.1,0.6,0.2,1.1,0.4,1.6c0.2,0.6,0.4,1.2,0.7,1.8 c0.2,0.6,0.5,1.2,0.8,1.9c0.4,0.8,0.8,1.6,1.3,2.3c0.6,1,1.3,1.9,2.1,2.8c0.3,0.3,0.6,0.6,0.9,0.9c0.4,0.4,0.9,0.8,1.3,1.1 c0.5,0.4,1,0.8,1.5,1.1c0.7,0.4,1.4,0.9,2.1,1.2c1.1,0.6,2.2,1.1,3.3,1.6c1.1,0.4,2.2,0.9,3.3,1.3c0.7,0.3,1.4,0.5,2.1,0.7 c0.4,0.1,0.7,0.2,1.1,0.3c0.6,0.2,1.3,0.3,1.9,0.5c0.4,0.1,0.8,0.2,1.2,0.3c0.3,0,0.5,0.1,0.8,0.2c0.9,0.2,1.7,0.5,2.6,0.7 c0.6,0.2,1.1,0.4,1.6,0.6c0.6,0.2,1.1,0.5,1.6,0.9c0.6,0.4,1.1,0.7,1.6,1.1c0.6,0.4,1.1,0.8,1.5,1.3c0.3,0.3,0.6,0.6,0.8,0.9 c0.4,0.4,0.8,0.9,1.1,1.3c0.4,0.6,0.8,1.1,1.1,1.7c0.3,0.5,0.6,0.9,0.8,1.4c0.5,1.2,1,2.5,1.3,3.8c0.1,0.5,0.2,1,0.3,1.5 c0.1,0.7,0,1.3,0,2c0,0.4-0.1,0.9-0.2,1.3c-0.2,0.8-0.4,1.5-0.6,2.2c-0.2,0.6-0.4,1.2-0.7,1.7c-0.4,0.9-0.8,1.8-1.3,2.7 c-0.2,0.3-0.3,0.6-0.5,0.9c-0.4,0.8-0.9,1.5-1.5,2.1c-0.1,0.1-0.3,0.3-0.4,0.4c-0.5,0.6-1.1,1.1-1.7,1.5c-0.4,0.3-0.8,0.5-1.1,0.8 c-0.3,0.2-0.6,0.4-0.9,0.6c-0.3,0.2-0.6,0.3-0.9,0.4c-0.7,0.3-1.4,0.5-2.1,0.7c-0.8,0.3-1.5,0.5-2.3,0.7c-0.4,0.1-0.9,0.2-1.4,0.3 c-0.4,0.1-0.8,0.2-1.3,0.2c-0.2,0-0.4,0-0.6,0c-0.3,0-0.5,0-0.8,0c-0.4,0-0.7,0-1.1,0c-0.3,0-0.7,0-1,0c-0.2,0-0.4,0-0.5,0 c-0.2,0-0.4-0.1-0.6-0.1c-0.1,0-0.2,0-0.3,0c-0.1,0-0.2,0-0.3-0.1c0,0,0,0-0.1,0c-0.2,0.2-0.4,0.2-0.7,0.2c-0.4,0-0.8-0.1-1.3-0.2 c-0.3,0-0.6-0.1-0.9-0.2c-0.2,0-0.5-0.1-0.7-0.1c-0.6-0.1-1.1-0.2-1.6-0.4c-0.3-0.1-0.6-0.2-0.9-0.3c-0.8-0.3-1.5-0.7-2.3-1.2 c-0.6-0.4-1.2-0.8-1.8-1.2c-0.5-0.4-1-0.7-1.4-1.1c-0.9-0.9-1.8-1.8-2.7-2.8c-0.1-0.1-0.1-0.2-0.2-0.3c-0.4-0.6-0.8-1.2-1.2-1.8 c-0.3-0.5-0.6-1-0.8-1.4c-0.2-0.5-0.5-1-0.7-1.5c-0.3-0.7-0.6-1.3-0.8-2c-0.2-0.5-0.4-0.9-0.6-1.4c-0.2-0.4-0.3-0.8-0.5-1.2 c-0.4-1.1-0.7-2.3-1.1-3.4c-0.1-0.2-0.1-0.4-0.2-0.6c-0.1-0.3-0.1-0.5-0.2-0.8c-0.2-0.7-0.3-1.3-0.5-1.9c-0.2-0.7-0.5-1.4-0.8-2 c-0.3-0.6-0.7-1.2-1.2-1.7c-0.3-0.3-0.6-0.7-0.9-1c-0.2-0.2-0.5-0.4-0.7-0.7c-0.1-0.1-0.3-0.2-0.4-0.3c-0.4-0.3-0.8-0.5-1.2-0.7 c-0.7-0.4-1.4-0.7-2.1-1c-0.3-0.1-0.6-0.2-0.9-0.3c-0.2,0-0.4-0.1-0.6-0.3c-0.2-0.1-0.3-0.3-0.4-0.6c-0.1-0.3-0.1-0.7,0.1-1 c0.1-0.3,0.3-0.7,0.6-0.9c0,0,0-0.1,0-0.1c0,0,0,0,0,0c-0.3,0.1-0.7,0.1-1,0.1c-0.6,0-1.1-0.1-1.6-0.3c-0.4-0.1-0.7-0.3-1.1-0.4 c-0.2-0.1-0.4-0.2-0.6-0.4c-0.1-0.1-0.2-0.2-0.2-0.4c0-0.1,0-0.2,0-0.2c0-0.2,0.1-0.4,0.3-0.5c0.1-0.1,0.2-0.1,0.3-0.1 c0.1,0,0.2-0.1,0.4-0.2c0.3-0.2,0.6-0.5,0.7-0.8c0,0,0-0.1,0-0.1c0,0,0,0,0,0c-0.3,0.1-0.6,0.1-0.9,0.2c-0.1,0-0.2,0-0.3,0 c-0.5-0.1-0.9-0.2-1.4-0.4c-0.3-0.1-0.5-0.3-0.8-0.4c-0.4-0.2-0.6-0.5-0.8-0.8c-0.1-0.2-0.2-0.3-0.3-0.5c-0.1-0.1-0.1-0.2-0.1-0.3 c0-0.1,0-0.2,0-0.3c0-0.3,0.2-0.5,0.4-0.6c0.2-0.1,0.4-0.2,0.6-0.2c0.2-0.1,0.5-0.1,0.7-0.3c0.2-0.1,0.3-0.3,0.5-0.4 c0,0,0.1-0.1,0.1-0.1c0-0.1,0-0.2-0.1-0.2c-0.2,0-0.4,0-0.6,0c-0.2,0-0.4-0.1-0.6-0.1c-0.1-0.1-0.3-0.1-0.4-0.2 c-0.4-0.2-0.7-0.6-1.1-0.9c-0.3-0.3-0.5-0.6-0.7-0.9c-0.1-0.1-0.1-0.3-0.1-0.4c-0.2-0.5-0.3-1-0.4-1.6c0-0.3-0.1-0.6,0-0.9 c0-0.5,0.1-1.1,0.2-1.6c0-0.1,0-0.1,0-0.2c0.1-0.3,0.1-0.5,0.1-0.8c0.1-0.3,0.1-0.6,0.1-0.9c0.1-0.3,0.1-0.6,0.1-0.9c0,0,0,0,0-0.1 c0.1-0.2,0.1-0.4,0.1-0.6c0-0.3,0-0.6,0-0.9c0-0.3,0-0.7-0.1-1c0-0.2-0.1-0.4-0.2-0.5c-0.1-0.1-0.1-0.2-0.2-0.3 c0-0.1-0.1-0.1-0.2-0.1c-0.4,0.1-0.8,0.2-1.1,0.4c-0.5,0.3-1.1,0.5-1.6,0.6c-0.4,0.1-0.8,0-1.2-0.1c-0.1,0-0.1-0.1-0.1-0.1 c-0.1-0.1-0.1-0.2,0-0.3c0.1-0.1,0.1-0.1,0.2-0.2c0.2-0.1,0.4-0.3,0.5-0.4c0.1-0.1,0.2-0.2,0.3-0.3c0.4-0.4,0.6-0.8,0.8-1.3 c0.2-0.5,0.3-0.9,0.4-1.4c0-0.2,0.1-0.3,0-0.5c0,0,0,0-0.1-0.1c0,0,0,0,0,0c-0.2,0.3-0.3,0.7-0.5,1c-0.3,0.4-0.7,0.8-1.2,1 c-0.4,0.2-0.8,0.4-1.2,0.5c-0.5,0.1-1,0.2-1.5,0.2c-0.1,0-0.2,0-0.3,0c-0.2,0-0.3-0.1-0.4-0.1c-0.1-0.1-0.2-0.3-0.1-0.4 c0.1-0.2,0.3-0.4,0.4-0.5c0.3-0.2,0.5-0.5,0.6-0.8c0.3-0.6,0.6-1.2,0.8-1.9c0.1-0.5,0.1-0.9,0.1-1.4c-0.1-0.2-0.1-0.4-0.1-0.6 c0,0,0,0,0,0c0,0,0,0,0,0c-0.1,0.2-0.1,0.4-0.2,0.6c-0.1,0.3-0.2,0.5-0.4,0.7c-0.5,0.7-1.1,1.3-1.9,1.8c-0.1,0.1-0.3,0.1-0.4,0.2 c-0.6,0.3-1.6,0.4-2.2,0.4c-0.1,0-0.1,0-0.2,0c-0.1,0-0.3-0.1-0.3-0.2c-0.1-0.1-0.1-0.2-0.1-0.3c0.2-0.4,0.4-0.7,0.5-1.1 c0.1-0.2,0.2-0.4,0.3-0.6c0.2-0.3,0.2-0.7,0.3-1.1c0-0.1,0-0.2,0-0.3c0.1-0.5,0.1-0.9,0-1.4c0,0,0,0-0.1-0.1 c-0.1,0.2-0.1,0.3-0.2,0.4c-0.2,0.6-0.6,1.1-1.1,1.4c-0.4,0.3-0.9,0.6-1.3,0.8c-0.4,0.2-0.9,0.4-1.3,0.5c-0.1,0-0.2,0-0.3,0 c-0.1,0-0.2-0.1-0.2-0.2c0-0.1,0-0.2,0-0.2c0.1-0.3,0.2-0.5,0.3-0.8c0.1-0.3,0.2-0.6,0.2-1c0-0.2,0-0.4,0-0.6 c0-0.3-0.1-0.5-0.2-0.7c0,0-0.1,0-0.1-0.1c0,0-0.1,0-0.1,0.1c-0.1,0.7-0.4,1.2-0.9,1.6c-0.5,0.5-1.1,0.8-1.8,1c-0.1,0-0.2,0-0.3,0 c-0.4,0-0.8,0-1.2-0.1c-0.5-0.1-0.8-0.3-1.1-0.7c-0.1-0.2-0.1-0.4,0-0.6s0.3-0.3,0.5-0.4c0.4-0.4,0.7-0.8,0.8-1.4 c0-0.2,0.1-0.3,0-0.5c-0.1-0.3-0.1-0.6-0.3-0.9c-0.1-0.2-0.3-0.3-0.5-0.4c-0.1,0-0.3-0.1-0.4-0.1c-0.4,0-0.8,0.1-1.2,0.3 c-0.1,0.1-0.3,0.2-0.4,0.3c-0.6,0.6-1.1,1.3-1.5,2c-0.2,0.4-0.4,0.9-0.5,1.4c0,0.1,0,0.2,0,0.2c-0.1,0.4-0.1,0.8,0,1.3 c0,0,0,0.1,0,0.1c0,0.1-0.1,0.2-0.2,0.2c-0.1,0-0.1,0-0.2,0c-0.4-0.2-0.7-0.4-1-0.7c-0.7-0.6-1.1-1.3-1.4-2.1 c-0.1-0.2-0.1-0.5-0.1-0.7c0-0.3,0-0.7,0-1c0-0.5,0.1-1,0.3-1.5c0.1-0.2,0.1-0.4,0.2-0.5c0-0.1,0-0.1,0-0.2c0,0,0,0,0.1,0 c0,0,0,0,0,0c0,0-0.1,0-0.1,0.1c-0.1,0-0.2,0-0.2,0c-0.5,0.2-1,0.4-1.4,0.8c-0.3,0.3-0.6,0.6-0.9,0.9c-0.3,0.3-0.5,0.7-0.6,1.2 c-0.1,0.5-0.2,1-0.1,1.5c0,0,0,0,0,0.1c0,0.1,0,0.2-0.2,0.3c-0.1,0.1-0.2,0-0.3-0.1c-0.2-0.2-0.4-0.3-0.6-0.5 c-0.2-0.2-0.4-0.4-0.5-0.6c-0.2-0.3-0.4-0.7-0.6-1.1c-0.1-0.2-0.2-0.5-0.2-0.7c0-0.2-0.1-0.3-0.1-0.5c0-0.2,0-0.4,0.1-0.6 c0-0.1,0-0.2,0-0.3c0.1-0.6,0.2-1.1,0.4-1.6c0.2-0.4,0.4-0.8,0.7-1.1c0,0,0,0,0,0c0,0,0,0-0.1,0c-0.2,0-0.4,0.1-0.6,0.2 c-0.4,0.1-0.9,0.4-1.2,0.7c-0.6,0.4-1.3,1.4-1.5,2.2c0,0.1-0.1,0.2-0.1,0.3c-0.1,0.1-0.3,0.2-0.4,0c0,0-0.1-0.1-0.1-0.1 c-0.2-0.4-0.4-0.7-0.6-1.1c-0.1-0.2-0.1-0.5-0.2-0.7c-0.1-0.8,0.1-2,0.6-2.8c0.3-0.6,0.7-1.1,1.3-1.4c0.1-0.1,0.2-0.1,0.2-0.2 c0,0,0.1-0.1,0-0.1s-0.1-0.1-0.1-0.1c-0.5-0.1-0.9,0-1.4,0.1c-1.2,0.3-2.5,1.1-3.2,2.1c-0.3,0.4-0.6,0.9-0.7,1.5 c0,0.2-0.1,0.3-0.1,0.5c0,0,0,0.1,0,0.1c0,0-0.1,0.1-0.1,0.1c-0.1,0-0.2,0-0.3,0c-0.1,0-0.2,0-0.2-0.1c0-0.1-0.1-0.2-0.2-0.3 c-0.1-0.1-0.2-0.3-0.3-0.4c-0.1-0.2-0.1-0.4-0.3-0.5c-0.1-0.1-0.2-0.2-0.4-0.3c-0.1-0.1-0.2-0.2-0.3-0.2c-0.6-0.5-1.3-1-2.1-1.4 c-0.3-0.2-0.6-0.3-0.9-0.5c-0.7-0.3-1.3-0.5-2-0.7c-1.3-0.4-2.6-0.7-3.9-1c-0.3-0.1-0.7-0.2-1-0.2c-0.5-0.1-0.9-0.2-1.4-0.3 c-0.5-0.1-1-0.2-1.5-0.3c-0.4-0.1-0.9-0.2-1.3-0.3c-0.8-0.3-1.6-0.5-2.3-0.8c-0.1-0.1-0.3-0.1-0.4-0.2c-0.1,0-0.1-0.1-0.1-0.1 c0,0,0,0,0,0c0,0,0,0,0,0c0.1,0,0.1,0,0.2,0c0.3,0.1,0.7,0.2,1,0.3c0.6,0.2,1.2,0.3,1.9,0.4c0.2,0.1,0.5,0.1,0.7,0.1 c0.4,0.1,0.8,0.1,1.2,0.2c0.1,0,0.2,0,0.2,0c0,0,0.1,0,0.1-0.1c0,0,0,0,0,0c-0.1-0.1-0.2-0.1-0.3-0.2c-0.3-0.1-0.5-0.3-0.8-0.5 c-0.6-0.4-1.1-0.9-1.7-1.3c-0.6-0.5-1.1-1-1.7-1.5c-0.4-0.4-0.7-0.7-1.1-1.1c-0.3-0.3-0.7-0.7-1-1c-0.2-0.2-0.3-0.4-0.5-0.6 c-0.2-0.3-0.4-0.5-0.6-0.8c-0.4-0.4-0.7-0.8-1-1.2c-0.3-0.3-0.5-0.7-0.8-1c-0.7-0.7-1.4-1.4-2-2c-0.4-0.4-0.9-0.8-1.3-1.1 c-0.3-0.3-0.6-0.5-1-0.7c-0.9-0.6-1.9-1.2-2.9-1.6c-0.8-0.4-1.7-0.7-2.6-0.9c-0.5-0.1-1-0.2-1.5-0.3c-0.3,0-0.5-0.1-0.8-0.1 c-0.5,0-1,0-1.5,0c-0.3,0-0.4,0.1-0.5,0.3c0,0.1-0.1,0.2-0.1,0.3c0,0.3,0,0.6,0.1,0.9c0,0.2,0,0.3,0,0.5c0,0.3-0.3,0.4-0.5,0.2 c-0.1-0.1-0.3-0.2-0.3-0.4c0-0.1-0.1-0.2-0.1-0.3c0-0.1-0.1-0.1-0.2-0.1c-0.3,0-0.5,0-0.8,0.1c-0.6,0.2-1.1,0.4-1.6,0.7 c-0.4,0.2-0.7,0.5-1,0.8c-0.1,0.2-0.2,0.3-0.4,0.4c-0.3,0.3-0.5,0.7-0.6,1.1c0,0,0,0.1,0,0.2c0,0,0.1,0,0.1,0 c0.1,0,0.1-0.1,0.2-0.1c0.4-0.4,0.9-0.6,1.5-0.7c0.1,0,0.1,0,0.2-0.1c0-0.1,0-0.1,0-0.2c0-0.2-0.1-0.3,0-0.5c0-0.1,0-0.1,0.1-0.2 c0-0.1,0.1-0.1,0.1-0.1c0,0,0.1,0.1,0.1,0.1c0,0.1,0,0.2,0,0.3c0,0.1,0,0.2,0,0.3c0,0.1,0.1,0.1,0.2,0.1c0.2,0,0.4,0,0.6,0 c0.1,0,0.1-0.1,0.1-0.2c0-0.2,0-0.3,0-0.5c0-0.1,0-0.2,0.1-0.3c0,0,0,0,0-0.1c0,0,0.1,0,0.1-0.1c0,0,0.1,0,0.1,0.1 c0,0.3,0.1,0.6,0.1,0.9c0,0,0,0.1,0,0.1c0,0,0,0.1,0.1,0.1c0.1,0.1,0.3,0.1,0.5,0.1c0,0,0.1-0.1,0.1-0.1c0-0.1,0-0.2,0.1-0.3 c0,0,0.1-0.1,0.2-0.1c0,0,0.1,0.1,0.1,0.1c0,0.2,0,0.3,0,0.5c0,0.1,0,0.1,0.1,0.1c0.1,0,0.1,0.1,0.2,0.1c0.4,0.1,0.7,0.3,1,0.5 c0.1,0,0.1,0.1,0.2,0.1c0,0,0,0,0,0c0.2-0.4,0.5-0.8,0.7-1.2c0,0,0.1-0.1,0.1-0.1s0.2-0.1,0.2,0c0,0,0.1,0.1,0.1,0.1 c0,0.2,0,0.3,0,0.5c-0.1,0.2-0.1,0.3-0.1,0.5c0,0.1,0,0.3-0.1,0.4c0,0.3-0.1,0.6-0.1,0.9c0,0.4,0,0.9,0,1.3c0,0.3,0.1,0.5,0.1,0.8 c0,0.1,0,0.1-0.1,0.2c0,0-0.2,0-0.2,0c0,0-0.1,0-0.1-0.1c-0.1-0.1-0.3-0.2-0.3-0.4c-0.1-0.3-0.3-0.5-0.4-0.8 c-0.1-0.2-0.1-0.5-0.1-0.7c0,0-0.1-0.1-0.1-0.1c-0.1,0-0.2,0-0.3,0c-0.9,0.3-1.8,0.7-2.7,1.2c-0.6,0.4-1.1,0.9-1.5,1.6 c-0.3,0.5-0.4,0.9-0.6,1.4c0,0,0,0,0,0c0,0,0,0,0,0c0.1,0,0.1-0.1,0.2-0.1c0.4-0.3,0.8-0.5,1.3-0.7c0.1,0,0.1,0,0.1-0.1 c0,0,0-0.1,0-0.1c0-0.1-0.1-0.3-0.1-0.4c0-0.1,0-0.3,0-0.4c0-0.1,0.1-0.1,0.2,0c0,0,0.1,0.1,0.1,0.1c0.1,0.2,0.1,0.4,0.2,0.6 c0,0,0.1,0.1,0.1,0.1c0.1,0,0.2,0,0.3-0.1c0.1,0,0.1-0.1,0.1-0.2c-0.1-0.3-0.1-0.6-0.1-0.9c0,0,0-0.1,0-0.1c0,0,0.1-0.1,0.1-0.1 c0,0,0.1,0,0.1,0c0,0,0.1,0.1,0.1,0.1c0.1,0.3,0.2,0.6,0.2,0.9c0,0.1,0.1,0.2,0.2,0.2c0,0,0.1,0,0.1,0s0.1-0.1,0.1-0.1 c0-0.2,0-0.3,0-0.5c0-0.2,0-0.4,0-0.6c0-0.1,0.1-0.2,0.1-0.3c0.1-0.1,0.2-0.1,0.3,0c0.1,0.1,0.2,0.3,0.2,0.4c0,0.3,0.1,0.6,0.1,0.9 c0,0.1,0.1,0.2,0.2,0.2c0.1,0.1,0.3,0.1,0.4,0.1c0,0,0.1-0.1,0.1-0.1c0-0.1,0-0.2,0-0.2c-0.1-0.3-0.1-0.7-0.1-1c0,0,0,0,0-0.1 c0,0,0-0.1,0-0.1c0,0,0.1-0.1,0.1-0.1c0.1,0,0.1,0,0.2,0.1c0.2,0.3,0.3,0.6,0.3,1c0,0.3,0,0.5,0,0.8c0,0,0,0.1,0,0.1 c0.2,0.1,0.5,0.3,0.7,0.4c0.1,0.1,0.2,0.2,0.3,0.3c0,0,0,0.1,0,0.1c0,0.1,0,0.3-0.1,0.4c-0.1,0.1-0.2,0.1-0.3,0.2 c-0.1,0-0.1,0-0.2,0.1c-0.3,0.1-0.6,0.2-0.9,0.3c-0.4,0.2-0.7,0.4-1.1,0.6c-0.3,0.2-0.7,0.4-0.9,0.7c-0.3,0.3-0.5,0.5-0.7,0.8 c-0.4,0.5-0.7,1.1-0.9,1.7c0,0.1,0,0.1,0,0.2c0,0,0,0.1,0,0.1c0,0,0.1,0,0.1,0c0.2-0.1,0.4-0.3,0.6-0.4c0.1-0.1,0.2-0.2,0.4-0.3 c0-0.1,0-0.1,0-0.2c0-0.1,0-0.1,0-0.2c0-0.1,0-0.2,0-0.2c0-0.1,0.1-0.2,0.2-0.2c0.1,0,0.2,0,0.3,0.1c0,0.1,0.1,0.2,0.1,0.3 c0,0,0.1,0.1,0.2,0c0.1-0.1,0.2-0.1,0.1-0.2c0-0.1,0-0.2,0-0.2c0,0,0-0.1,0-0.1c0,0,0,0,0-0.1c0-0.1,0-0.1,0.1-0.1 c0.1,0,0.1,0,0.2,0.1c0.1,0.1,0.1,0.3,0.2,0.4c0,0,0.1,0.1,0.1,0c0.1,0,0.1-0.1,0.1-0.2c-0.1-0.3-0.1-0.6-0.1-0.9 c0-0.1,0.1-0.1,0.1-0.2c0,0,0.1,0,0.1,0c0.1,0.1,0.2,0.2,0.2,0.3c0.1,0.2,0.1,0.4,0.1,0.6c0,0,0,0.1,0,0.1c0,0,0.1,0.1,0.1,0.1 c0.1,0,0.2,0,0.2,0c0,0,0.1-0.1,0.1-0.1c0-0.3,0-0.6,0-0.9c0-0.1,0-0.1,0-0.2c0,0,0.1-0.1,0.1,0c0.1,0.1,0.2,0.2,0.2,0.4 c0,0.3,0.1,0.5,0.1,0.8c0,0.1,0.1,0.1,0.1,0.2c0.1,0,0.3,0.1,0.4,0.1c0,0,0.1,0,0.1,0c0,0,0-0.1,0.1-0.1c0.1-0.5,0.4-0.9,0.8-1.2 c0,0,0.1,0,0.1,0c0.1,0,0.2,0,0.2,0.1c0,0.1,0.1,0.1,0.1,0.2c-0.1,0.4-0.2,0.9-0.3,1.3c-0.1,0.2-0.1,0.4-0.2,0.6 c-0.1,0.2,0,0.5-0.1,0.7c0,0.1,0,0.2,0,0.3c0.1,0.2,0.2,0.4,0.4,0.4c0.2,0,0.3,0.1,0.5,0.1s0.4,0,0.5,0c0.4,0.1,0.7,0.2,1.1,0.4 c0.5,0.2,0.9,0.6,1.3,0.9c0.5,0.4,0.9,1,1.3,1.4c0,0,0.1,0.1,0.1,0.1c0.1,0.1,0.2,0.2,0.3,0.4c0.2,0.3,0.5,0.6,0.7,0.9 c0.2,0.3,0.4,0.5,0.7,0.7c0.3,0.3,0.7,0.6,1.1,0.8c0,0,0,0,0.1,0c0,0,0.1,0,0.1,0c0,0,0,0,0,0c0,0,0,0,0,0 c-0.2-0.2-0.4-0.3-0.6-0.5c-0.6-0.6-1-1.3-1.3-2.1c0,0,0-0.1,0-0.1c0,0,0.1,0,0.1,0c0,0,0.1,0.1,0.1,0.1c0.2,0.2,0.3,0.4,0.5,0.6 c0.3,0.4,0.6,0.7,0.9,1.1c0.4,0.4,0.9,0.7,1.5,0.9c0.1,0,0.2,0,0.3-0.1c0.1,0,0.1-0.1,0-0.1c-0.4-0.2-0.8-0.5-1.1-0.8 c-0.4-0.4-0.7-0.7-1-1.2c-0.3-0.5-0.6-0.9-0.8-1.4c0-0.1,0-0.1,0-0.2c0,0,0.1-0.1,0.1-0.1c0,0,0.1,0,0.1,0.1 c0.2,0.1,0.3,0.3,0.4,0.5c0.4,0.6,0.8,1.1,1.3,1.6c0.1,0.1,0.2,0.2,0.3,0.3c0.4,0.4,0.8,0.7,1.3,0.9c0,0,0,0,0.1,0 c0.1,0,0.3-0.2,0.3-0.3c0,0,0,0,0,0c-0.1,0-0.1-0.1-0.2-0.1c-0.2-0.1-0.3-0.1-0.5-0.2c-0.6-0.3-1.1-0.8-1.4-1.3 c0-0.1-0.1-0.1-0.1-0.2c0-0.1,0-0.2,0-0.2s0.1-0.1,0.2-0.1c0.1,0,0.2,0,0.2,0.1c0.2,0.2,0.4,0.4,0.5,0.5c0.5,0.4,1,0.8,1.5,1 c0,0,0,0,0.1,0c0,0,0.1,0,0.1,0c0.1-0.1,0.1-0.3,0.1-0.4c0-0.1,0-0.2-0.1-0.2c-0.3-0.2-0.6-0.3-0.9-0.5c-0.4-0.3-0.7-0.6-0.9-1.1 c-0.1-0.2-0.1-0.4-0.1-0.7c0-0.1,0.2-0.2,0.3-0.2c0.1,0,0.1,0,0.2,0.1c0.2,0.2,0.3,0.3,0.5,0.5c0.2,0.2,0.4,0.4,0.6,0.5 c0.2,0.1,0.3,0.2,0.5,0.3c0.2,0.1,0.5,0.2,0.7,0.3c0.6,0.2,1.1,0.4,1.7,0.5c0.1,0,0.1,0,0.2,0.1c0.8,0.2,1.6,0.6,2.3,1.1 c0.6,0.4,1.2,0.8,1.7,1.2c0.8,0.7,1.5,1.4,2,2.3c0.2,0.3,0.4,0.5,0.6,0.7c0.1,0.2,0.3,0.4,0.4,0.6c0,0.1,0,0.1,0.1,0.2 s-0.1,0.1-0.1,0.2c-0.1,0-0.3,0-0.4-0.1c-0.1-0.1-0.3-0.3-0.4-0.4c-0.3-0.3-0.6-0.6-0.8-0.9c-0.2-0.2-0.3-0.3-0.5-0.5 c-0.2-0.2-0.3-0.4-0.5-0.6c-0.3-0.3-0.6-0.6-0.9-0.9c-0.3-0.3-0.5-0.5-0.9-0.7c-0.2-0.1-0.4-0.3-0.6-0.4c-0.4-0.2-0.7-0.4-1.1-0.6 c0,0-0.1,0-0.1,0c0,0,0,0,0,0c0.1,0.2,0.3,0.3,0.4,0.5c0.5,0.5,0.9,1.1,1.3,1.7c0.3,0.4,0.5,0.9,0.8,1.3c0.2,0.4,0.5,0.8,0.7,1.1 c0.5,0.8,0.9,1.5,1.4,2.3c0.3,0.6,0.7,1.1,1.1,1.6c0.4,0.5,0.8,1,1.2,1.6c0.2,0.3,0.4,0.6,0.7,0.9c0,0,0,0,0,0c0,0,0-0.1,0-0.1 c0,0,0-0.1,0-0.1c-0.2-0.7-0.4-1.3-0.5-2c0-0.1,0-0.1,0-0.2c-0.1-0.3-0.1-0.5-0.2-0.8c0-0.1,0-0.1,0-0.2c0,0,0-0.1,0.1-0.1 c0,0,0,0,0.1,0c0,0,0.1,0.1,0.1,0.1c0.1,0.2,0.2,0.4,0.3,0.6c0.1,0.4,0.3,0.7,0.4,1.1c0.2,0.5,0.3,1.1,0.5,1.6 c0.2,0.5,0.4,0.9,0.6,1.4c0,0,0.1,0,0.1,0.1c0,0,0,0,0,0.1c0,0,0,0,0,0c0,0,0,0-0.1,0c0-0.2,0-0.3,0-0.5c0-0.1-0.1-0.2-0.1-0.3 c0-0.3-0.1-0.7-0.1-1c0-0.3-0.1-0.6-0.1-0.9c0-0.3-0.1-0.6-0.1-0.9c-0.1-0.4-0.1-0.8-0.2-1.2c0-0.2-0.1-0.3,0-0.5l0,0 c0,0,0.1,0,0.1,0.1c0.1,0.1,0.2,0.3,0.2,0.4c0.1,0.4,0.3,0.7,0.4,1.1c0.1,0.3,0.1,0.5,0.1,0.8c0,0.4,0.1,0.7,0.1,1.1 c0.1,0.5,0.2,0.9,0.3,1.3c0,0,0.1,0,0.1,0c0-0.1,0.1-0.2,0.1-0.3c0-0.2,0-0.4,0.1-0.6c0-0.1,0-0.2,0-0.3c-0.1-0.4-0.2-0.9-0.2-1.3 c0-0.1,0-0.2,0-0.3c-0.1-0.3-0.1-0.6-0.1-0.9c0-0.2,0-0.4-0.1-0.6c0-0.1-0.1-0.3-0.1-0.4c0,0,0-0.1,0-0.1c0,0,0.1,0,0.1,0 c0.2,0.2,0.3,0.6,0.4,0.9c0.1,0.3,0.1,0.6,0.1,0.9c0,0.1,0,0.3,0,0.4c0.1,0.2,0.1,0.4,0.1,0.6c0,0.1,0,0.2,0,0.3 c0,0.1,0.1,0.1,0.1,0.1c0.1-0.1,0.1-0.1,0.2-0.2c0.1-0.1,0.3-0.2,0.5-0.1c0.1,0,0.2,0.1,0.3,0.1c0,0,0.1,0.1,0.1,0.1 c0.1,0.2,0.3,0.5,0.4,0.7c0.1,0.2,0.2,0.5,0.3,0.7c0.1,0.3,0.3,0.6,0.5,0.8c0,0,0,0,0,0c0,0,0-0.1,0-0.1c-0.1-0.2-0.1-0.5-0.2-0.7 c-0.2-0.7-0.3-1.5-0.5-2.2c0-0.1,0-0.3,0-0.4c0,0,0,0,0,0c0,0,0.1,0,0.1,0c0,0,0.1,0.1,0.1,0.1c0.1,0.4,0.3,0.8,0.4,1.3 c0.3,1.1,0.7,2.2,1.3,3.3c0.2,0.4,0.4,0.7,0.7,1c0,0,0,0,0,0c0,0,0-0.1,0-0.1c-0.2-0.4-0.3-0.9-0.4-1.3c-0.1-0.4-0.2-0.7-0.2-1.1 c-0.1-0.4-0.2-0.7-0.2-1.1c0-0.1,0-0.1,0-0.2c-0.1-0.4-0.2-0.7-0.2-1.1c0-0.1,0-0.1,0-0.2c0,0,0.1,0,0.1-0.1c0,0,0,0,0.1,0 c0,0,0.1,0.1,0.1,0.1c0,0.2,0,0.3,0.1,0.5c0.1,0.5,0.2,1.1,0.3,1.6c0.1,0.3,0.1,0.6,0.2,0.8c0.1,0.4,0.3,0.9,0.5,1.3 c0,0.1,0.1,0.1,0.1,0.1c0,0,0,0.1,0,0.1c0,0,0,0,0,0c0,0,0,0-0.1,0c0-0.2,0-0.5,0-0.7c0-0.1-0.1-0.3-0.1-0.4c0-0.8,0-1.5,0-2.3 c0-0.1,0-0.2,0-0.3c0,0,0.1-0.1,0.1-0.1c0.1,0,0.2,0.1,0.2,0.1c0,0.1,0,0.2,0,0.2c0,0.1,0,0.2,0,0.3c0,0.2,0.1,0.4,0.1,0.6 c0,0.2,0.1,0.5,0.1,0.7c0,0.4,0.1,0.7,0.1,1.1c0,0.2,0.1,0.4,0.1,0.6c0,0.1,0,0.1,0.1,0c0-0.1,0-0.2,0-0.3c0-0.1,0.1-0.3,0.1-0.4 c0-0.2,0.2-0.4,0.3-0.5c0.2-0.1,0.4-0.1,0.6,0c0,0,0.1,0.1,0.1,0.1c0.1,0.1,0.1,0.2,0.2,0.3c0.2,0.3,0.4,0.6,0.6,0.9 c0.2,0.3,0.4,0.5,0.6,0.7c0,0,0.1,0.1,0.1,0.1C558,551.6,558,551.7,558,551.7c0.1,0,0.1,0,0.1,0c0,0,0,0,0,0 C558,551.7,558,551.7,558,551.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M578,619.4C578,619.4,578.1,619.5,578,619.4c0.1,0.1,0.1,0.1,0.2,0.1C578.2,619.4,578.1,619.4,578,619.4 C578.1,619.4,578,619.4,578,619.4C578,619.4,578,619.3,578,619.4c-0.3-0.3-0.5-0.5-0.7-0.6c-0.2-0.2-0.4-0.4-0.5-0.6 c-0.1-0.2-0.2-0.4-0.2-0.6c0,0,0-0.1,0-0.1c0-0.1,0-0.3,0.2-0.3c0.2-0.1,0.4-0.1,0.6-0.1c0.4,0.1,0.8,0.1,1.2,0.1 c0.2,0,0.3-0.1,0.5-0.2c0,0,0,0,0,0c0,0,0-0.1,0-0.1c-0.2-0.1-0.3-0.2-0.5-0.3c-0.3-0.1-0.6-0.3-0.8-0.5c-0.1-0.1-0.2-0.1-0.2-0.2 c-0.2-0.2-0.3-0.4-0.5-0.7c-0.1-0.1,0-0.2,0-0.3c0.1-0.1,0.1-0.2,0.3-0.3c0.5-0.2,1-0.5,1.5-0.7c0.1,0,0.1-0.1,0-0.1 c-0.1-0.1-0.2-0.2-0.3-0.3c-0.2-0.2-0.3-0.5-0.4-0.8c0-0.2,0-0.3,0-0.5c0.1-0.2,0.2-0.4,0.3-0.5c0.2-0.2,0.5-0.5,0.8-0.6 c0.1,0,0.1-0.1,0.1-0.1c0,0,0,0,0-0.1c-0.5-0.2-0.9-0.3-1.4-0.4c-0.3-0.1-0.5-0.1-0.8-0.1c-0.6-0.1-1.2-0.1-1.8,0 c-0.1,0-0.2,0-0.3,0c-0.3,0.1-0.7,0.2-1,0.3c-0.2,0.1-0.5,0.2-0.8,0.3c-0.4,0.2-0.9,0.4-1.2,0.7c-0.1,0.1-0.2,0.1-0.3,0.2 c-0.1,0-0.2,0-0.2-0.1c0-0.2,0-0.3,0.1-0.5c0.3-0.3,0.6-0.7,1-0.9c0.4-0.3,0.7-0.5,1.2-0.7c0.5-0.2,1-0.4,1.5-0.4 c0.1,0,0.2,0,0.2,0c0.2,0,0.3,0,0.5-0.1c0.4,0,0.9,0,1.3,0.1c0.6,0,1.1,0.2,1.7,0.3c0.8,0.2,1.5,0.4,2.3,0.6 c0.5,0.1,0.9,0.2,1.4,0.3c0.2,0.1,0.5,0.1,0.7,0.1c0.6,0,1.3,0.1,1.9-0.1c0.1,0,0.2,0,0.3,0c0.3,0,0.7,0,1-0.1 c0.6-0.1,1.2-0.3,1.7-0.6c0.2-0.1,0.3-0.3,0.3-0.5c0,0,0,0,0,0c0,0,0,0,0,0c-0.1,0.1-0.3,0.1-0.4,0.2c-0.6,0.2-1.1,0.4-1.7,0.4 c-0.1,0-0.2,0-0.2,0c-0.5,0.1-1.1,0.1-1.6,0c-0.1,0-0.2,0-0.3,0c-0.3,0-0.6-0.1-0.9-0.2c-0.3-0.1-0.7-0.2-1-0.3 c-0.2-0.1-0.4-0.2-0.5-0.2c-0.1,0-0.1-0.1-0.1-0.1c0,0,0,0,0,0c0,0,0-0.1,0.1,0c0.6,0.2,1.1,0.3,1.7,0.4c0.3,0.1,0.5,0.1,0.8,0.1 c0.4,0,0.8,0,1.2,0c0.4,0,0.7-0.1,1.1-0.1c0,0,0.1,0,0.1,0c0.3-0.1,0.7-0.2,1-0.3c0.4-0.1,0.7-0.3,1-0.6c0.3-0.2,0.6-0.5,0.8-0.7 c0.1-0.1,0.1-0.2,0.1-0.3c0-0.1,0-0.2,0-0.2c0,0-0.1-0.1-0.1-0.1c-0.2,0.1-0.4,0.2-0.6,0.4c-0.2,0.2-0.5,0.3-0.7,0.4 c-0.1,0-0.2,0.1-0.3,0.1c-0.7,0.3-1.5,0.5-2.2,0.5c-0.2,0-0.5,0-0.7,0c-0.1,0-0.3,0-0.4,0c-0.1,0-0.2,0-0.3,0 c-0.4,0-0.8-0.1-1.1-0.2c-0.5-0.1-1-0.3-1.5-0.4c-0.6-0.1-1.2-0.3-1.7-0.4c-0.4-0.1-0.8-0.2-1.3-0.2c-0.1,0-0.2,0-0.2,0 c-0.2-0.1-0.5-0.1-0.8-0.1c-0.5,0-1,0-1.5,0.1c-0.2,0-0.5,0-0.8,0c-0.3,0-0.5,0.1-0.8,0.1c-0.2,0-0.4,0.1-0.6,0.1 c-0.6,0.1-1.1,0.3-1.6,0.7c-0.1,0.1-0.2,0.1-0.2,0.2c-0.5,0.3-0.5,0.3-0.8,0.8c-0.1,0.1-0.2,0.2-0.2,0.3c0,0-0.1,0.1-0.1,0.1 s-0.1,0-0.1,0s0-0.1,0-0.2c0.2-0.2,0.4-0.4,0.5-0.7c0.1-0.2,0.3-0.4,0.4-0.6c0.1-0.1,0.2-0.2,0.4-0.4c0.2-0.2,0.4-0.3,0.6-0.5 c0.4-0.2,0.8-0.4,1.3-0.5c0.2,0,0.3-0.1,0.5-0.1c0.4-0.1,0.8-0.2,1.2-0.2c0.1,0,0.3,0,0.4-0.1c0.1,0,0.2,0,0.3,0c0.5,0,0.9,0,1.4,0 c0.1,0,0.3,0,0.4,0c0.2,0,0.3,0.1,0.5,0.1c0.1,0,0.3,0,0.4,0.1c0.5,0.1,0.9,0.2,1.4,0.3c0.7,0.1,1.4,0.3,2,0.5 c0.4,0.1,0.9,0.2,1.3,0.3c0.3,0.1,0.6,0.1,0.9,0.1c0.4,0,0.8,0,1.2,0c0.2,0,0.4,0,0.6-0.1c0.6-0.1,1.1-0.3,1.7-0.5 c0.1,0,0.2-0.1,0.3-0.2c0.2-0.1,0.4-0.3,0.6-0.4c0.2-0.1,0.3-0.3,0.4-0.4c0.1-0.1,0.1-0.1,0.1-0.2c0-0.1,0-0.3,0-0.4 c-0.1-0.3-0.1-0.7-0.2-1c0-0.5-0.2-1-0.2-1.5c-0.2-1.1-0.5-2.1-0.9-3.1c-0.4-1-0.8-1.9-1.3-2.9c-0.1-0.3-0.3-0.6-0.5-0.8 c-0.3-0.4-0.7-0.9-1-1.3c-0.2-0.3-0.5-0.6-0.7-0.8c-0.4-0.4-0.8-0.8-1.1-1.1c-0.1-0.1-0.1-0.1-0.2-0.2c-0.1-0.1-0.3-0.2-0.5-0.3 c-0.5-0.2-1-0.3-1.5-0.5c-0.6-0.2-1.2-0.4-1.8-0.5c-0.8-0.2-1.6-0.5-2.4-0.7c-0.6-0.2-1.2-0.3-1.9-0.4c-0.5-0.1-1-0.2-1.5-0.3 c-0.1,0-0.1-0.1-0.2-0.1c-0.4,0-0.8-0.1-1.3-0.1c-0.2,0-0.3,0-0.5-0.1c0,0,0-0.1-0.1-0.1c0.1-0.1,0.3-0.1,0.4-0.1 c0.3,0,0.6,0,0.9,0c0.2,0,0.4,0,0.6,0.1c0.1,0,0.3,0,0.4,0c0.5,0.1,1,0.2,1.4,0.2c0.1,0,0.1,0,0.2,0c0.3,0.1,0.6,0.1,1,0.2 c0.4,0,0.7,0.1,1.1,0.2c0.5,0.1,1,0.3,1.5,0.4c0.8,0.2,1.6,0.4,2.6,0.7c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0c-0.2-0.2-0.4-0.4-0.6-0.6 c-0.1-0.1-0.2-0.2-0.3-0.3c-0.1-0.1-0.3-0.2-0.4-0.3c-0.4-0.1-0.8-0.3-1.1-0.4c-0.9-0.3-1.9-0.5-2.9-0.7c-0.2-0.1-0.5-0.1-0.7-0.1 c-0.4-0.1-0.8-0.1-1.3-0.1c0,0-0.1,0-0.1,0c-0.2-0.1-0.4-0.1-0.6-0.1c-0.1,0-0.2,0-0.3,0c-0.4-0.1-0.7-0.1-1.1-0.1 c-0.4,0-0.9,0-1.3,0c-0.7,0-1.3,0-2,0.1c-0.4,0-0.7,0.1-1.1,0.1c-0.5,0.1-1,0.2-1.5,0.3c-0.7,0.2-1.4,0.6-2.1,0.9c0,0,0,0,0,0 c0,0-0.1,0.1-0.1,0.1c0,0,0,0.1,0.1,0.1c0.1,0.1,0.3,0.1,0.4,0.2c0.2,0.1,0.3,0.2,0.4,0.3c0.1,0.1,0.1,0.3,0,0.4 c0,0.1-0.1,0.2-0.2,0.2c-0.1,0.1-0.2,0.1-0.3,0.1c-0.3,0-0.6,0.1-0.9,0.3c-0.1,0.1-0.3,0.1-0.4,0.2c-0.5,0.3-0.9,0.6-1.4,1 c-0.1,0.1-0.2,0.2-0.3,0.3c-0.3,0.4-0.6,0.8-0.8,1.2c-0.1,0.2-0.3,0.5-0.4,0.7c0,0,0,0.1,0,0.2c0,0,0,0,0,0c0.3-0.1,0.7-0.1,1-0.1 c0.1,0,0.2,0,0.3,0c0.4,0,0.8,0.1,1.2,0.3c0.1,0,0.2,0.1,0.3,0.2c0.1,0.2,0.1,0.4-0.1,0.5c0,0-0.1,0.1-0.1,0.1 c-0.2,0.1-0.3,0.2-0.4,0.4c-0.1,0.2-0.3,0.5-0.4,0.7c-0.2,0.4-0.4,0.9-0.4,1.4c0,0.2-0.1,0.5-0.1,0.7c0,0.3,0,0.5,0,0.8 c0,0.1,0,0.2,0,0.3c0,0.4-0.1,0.9,0,1.3c0,0.3,0.1,0.5,0.1,0.8c0,0.6,0.1,1.1,0.1,1.7c0,0.1,0,0.1,0,0.2c0.1,0.2,0.1,0.4,0.1,0.6 c0,0.2,0.1,0.4,0.1,0.6c0,0.3,0.1,0.7,0.2,1c0.1,0.6,0.3,1.1,0.5,1.6c0.3,1,0.6,1.9,1,2.8c0.1,0.4,0.3,0.8,0.5,1.1 c0.2,0.5,0.4,0.9,0.6,1.4c0.4,1,0.8,2.1,1.1,3.2c0.2,0.6,0.3,1.4,0.3,2c0,0.2,0,0.4,0,0.6c0,0.4,0,0.7-0.1,1.1 c-0.1,0.7-0.4,1.3-0.8,1.8c-0.1,0.1-0.2,0.2-0.3,0.3c0,0-0.1,0.1-0.2,0.1c-0.1,0-0.2,0-0.2-0.2c0-0.1,0-0.2,0-0.2 c0.1-0.2,0.1-0.3,0.2-0.5c0.1-0.3,0.2-0.7,0.3-1.1c0.1-0.3,0.1-0.7,0.1-1c0,0,0,0,0,0c0,0-0.1,0-0.1,0c-0.1,0.1-0.3,0.3-0.4,0.4 c-0.3,0.3-0.7,0.6-1.1,0.8c-0.2,0.1-0.5,0.2-0.7,0.4c-0.7,0.4-1.4,0.6-2.1,0.8c-0.1,0-0.3,0.1-0.5,0.1c-0.4,0.1-0.8,0.2-1.2,0.1 c-0.1,0-0.1,0-0.2,0c-0.4,0.1-0.8,0.1-1.2,0.1c-0.4,0-0.9-0.1-1.3-0.1c-0.1,0-0.2-0.1-0.3-0.1c-0.4-0.1-0.8-0.2-1.2-0.3 c-0.8-0.2-1.6-0.5-2.3-1c-0.6-0.4-1.2-0.8-1.7-1.3c-0.4-0.4-0.9-0.7-1.3-1.1c-0.8-0.6-1.6-1.1-2.5-1.5c-0.7-0.4-1.4-0.6-2.2-0.8 c-0.4-0.1-0.7-0.1-1.1-0.2c-0.7,0-1.5-0.1-2.2,0.1c-0.1,0-0.2,0-0.3,0c-0.1,0-0.2,0-0.3,0c-0.5,0.1-1.1,0.2-1.6,0.3 c-0.3,0.1-0.6,0.2-0.9,0.1c0,0,0,0-0.1,0c0,0-0.1,0.1-0.1,0.1c0,0.3-0.1,0.5,0,0.8c0.1,0.2,0.1,0.4,0.1,0.6c0,0.1,0,0.2,0,0.3 c0.1,0.5,0.1,0.9,0,1.4c0,0,0,0.1-0.1,0.1c0,0-0.1,0-0.1-0.1c0,0,0-0.1,0-0.1c0-0.2-0.1-0.3-0.1-0.5c0-0.1,0-0.2,0-0.3 c-0.1-0.3-0.2-0.5-0.2-0.8c0,0,0-0.1-0.1-0.1c-0.2-0.1-0.5-0.2-0.7-0.3c-0.4-0.2-0.8-0.3-1.2-0.2c-0.3,0-0.5,0-0.8,0 c-0.1,0-0.2,0-0.2,0c-0.4,0.1-0.8,0.2-1.2,0.3c-0.5,0.2-0.9,0.5-1.3,0.9c-0.1,0.1-0.1,0.1-0.2,0.2c-0.2,0.2-0.3,0.4-0.5,0.6 c0,0,0,0,0.1,0c0.1,0,0.2,0,0.3,0c0.2-0.1,0.5-0.1,0.7-0.1c0,0,0,0,0.1,0c0,0,0.1-0.1,0.1-0.1c0-0.1,0-0.2,0-0.3s0-0.2,0-0.3 c0,0,0.1-0.1,0.1-0.1c0,0,0.1,0,0.1,0c0.1,0,0.1,0.1,0.1,0.2c0,0.1,0,0.2,0,0.3c0,0,0.1,0.1,0.1,0.1c0,0,0.1,0,0.1,0 c0.2,0,0.2-0.1,0.2-0.2c0-0.2,0-0.4,0-0.6c0-0.1,0-0.1,0-0.2c0,0,0-0.1,0.1-0.1c0,0,0.1,0,0.1,0c0.1,0.1,0.1,0.3,0.1,0.4 c0,0.2,0,0.3,0,0.5c0,0,0,0.1,0.1,0.1c0.1,0.1,0.2,0.1,0.3,0c0,0,0.1-0.1,0.1-0.1c0-0.3,0-0.5,0-0.8c0-0.1,0-0.2,0.1-0.2 c0,0,0.1-0.1,0.1-0.1c0,0,0.1,0,0.1,0.1c0,0,0,0,0,0.1c0.1,0.2,0.1,0.5,0.1,0.7c0,0.1,0,0.2,0,0.3c0,0.1,0,0.1,0.1,0.1 c0.1,0,0.2,0.1,0.3,0.1c0,0,0,0,0.1,0c0,0,0.1,0,0.1-0.1c0-0.3,0-0.6,0-0.9c0-0.1,0-0.1,0.1-0.2c0,0,0.1,0,0.1-0.1c0,0,0,0,0,0 c0.1,0.1,0.1,0.2,0.1,0.4c0,0.3,0,0.5,0,0.8c0,0,0,0.1,0.1,0.1c0.1,0.1,0.2,0.1,0.4,0.2c0,0,0.1,0,0.1-0.1c0-0.3,0-0.5,0-0.8 c0-0.2,0-0.3,0.1-0.4c0,0,0.1-0.1,0.1-0.1c0,0,0.1,0,0.2,0.1c0,0,0.1,0.1,0.1,0.1c0.1,0.3,0.2,0.6,0.1,0.9c0,0.1,0,0.1,0,0.2 c0,0.2,0,0.5,0.2,0.6c0.1,0,0.1,0.1,0.1,0.2c0,0.1,0,0.1,0,0.2c0,0.1,0,0.1-0.1,0.2c0,0.2-0.2,0.3-0.3,0.3 c-0.1,0.1-0.3,0.1-0.4,0.1c-0.3,0.1-0.5,0.1-0.8,0.2c-0.8,0.3-1.4,0.7-2,1.3c-0.2,0.2-0.4,0.5-0.6,0.7c-0.2,0.2-0.3,0.4-0.4,0.7 c0,0,0,0.1,0,0.1c0,0,0,0,0.1,0c0.3-0.1,0.6-0.2,0.9-0.3c0,0,0.1-0.1,0.1-0.1c0-0.1,0-0.1,0-0.2c0-0.1,0-0.2,0-0.2 c0-0.1,0.1-0.2,0.1-0.2c0.1,0,0.2,0,0.2,0.1c0,0,0,0.1,0.1,0.1c0,0.1,0,0.2,0.1,0.3c0,0,0.1,0.1,0.1,0s0.1-0.1,0.1-0.1 c0-0.2-0.1-0.3-0.1-0.5c0-0.1,0-0.2,0.1-0.2c0-0.1,0.2-0.1,0.2,0c0.1,0.1,0.1,0.2,0.2,0.4c0,0.1,0,0.2,0,0.3c0,0,0.1,0.1,0.1,0.1 c0.1,0,0.1,0,0.2,0c0.1,0,0.1-0.1,0.1-0.2c-0.1-0.2-0.1-0.5-0.1-0.8c0-0.1,0-0.1,0-0.2c0-0.1,0.1-0.1,0.1,0 c0.1,0.1,0.2,0.2,0.2,0.3c0,0.2,0,0.4,0.1,0.6c0,0.1,0.1,0.2,0.2,0.1c0.1,0,0.2-0.1,0.2-0.1c-0.1-0.4,0-0.7,0.1-1 c0,0,0.1-0.1,0.1-0.1c0,0,0.1,0,0.1,0c0.1,0.2,0.2,0.4,0.2,0.7c0,0.1,0,0.2,0,0.3c0,0.1,0.1,0.2,0.2,0.2c0.1,0,0.1-0.1,0.1-0.1 c0-0.2,0-0.4,0-0.6c0-0.2,0.1-0.3,0.1-0.4c0-0.1,0.2-0.1,0.3,0c0.1,0.1,0.1,0.1,0.1,0.2c0.1,0.3,0.2,0.7,0.1,1c0,0.1,0,0.2,0.1,0.2 c0.1,0,0.3,0.1,0.4,0.1c0,0,0.1,0,0.1-0.1c0-0.3,0-0.5,0-0.8c0-0.2,0-0.3,0-0.5c0-0.1,0.1-0.1,0.2-0.2c0.1,0,0.2,0.1,0.2,0.1 c0,0,0,0.1,0,0.1c0,0.5,0.1,1,0.3,1.5c0.1,0.4,0.2,0.8,0.4,1.2c0.1,0.2,0.2,0.5,0.3,0.7c0,0.1,0,0.2,0,0.2c0,0.1-0.1,0.1-0.1,0.1 c-0.1,0-0.2-0.1-0.3-0.2c-0.2-0.2-0.5-0.4-0.6-0.7c0,0-0.1-0.1-0.1-0.1c-0.5,0.1-1,0.3-1.5,0.5c-0.6,0.3-1.2,0.6-1.7,1.1 c-0.4,0.4-0.7,0.9-1,1.5c0,0.1-0.1,0.2-0.1,0.3c0,0,0,0.1,0,0.1c0,0,0.1,0.1,0.1,0.1c0.2-0.1,0.4-0.2,0.7-0.3 c0.5-0.3,0.4-0.2,0.4-0.7c0-0.1,0-0.2,0-0.3c0,0,0-0.1,0-0.1c0,0,0.1-0.1,0.1,0c0,0,0.1,0.1,0.1,0.1c0.1,0.2,0.1,0.4,0.1,0.6 c0,0,0,0.1,0.1,0c0.1,0,0.1,0,0.2-0.1c0,0,0.1-0.1,0.1-0.1c0-0.1,0-0.2-0.1-0.2c-0.1-0.2-0.1-0.5,0-0.7c0-0.1,0.2-0.2,0.3-0.1 c0.1,0,0.1,0.1,0.1,0.2c0,0.2,0.1,0.4,0.1,0.6c0,0.1,0,0.1,0.1,0.2c0.1,0,0.3,0,0.4-0.2c0-0.1,0-0.1,0-0.2c-0.1-0.3-0.1-0.6,0-0.9 c0-0.1,0.1-0.1,0.2-0.1c0,0,0.1,0,0.1,0.1c0.1,0.1,0.2,0.3,0.2,0.5c0,0.2,0,0.3,0,0.5c0,0,0,0.1,0.1,0.1c0.1,0,0.3,0,0.3-0.1 c0,0,0-0.1,0-0.1c-0.1-0.3-0.1-0.6-0.1-0.9c0-0.1,0-0.1,0.1-0.2c0,0,0.1,0,0.1,0c0.1,0.1,0.2,0.2,0.2,0.4c0.1,0.2,0.1,0.4,0.1,0.7 c0,0.1,0.1,0.1,0.1,0.2c0.1,0,0.2,0,0.3,0c0.3,0,0.5,0.2,0.7,0.5c0,0.1,0.1,0.1,0.1,0.2c0.1,0.1,0.1,0.2,0.2,0.3 c0.1,0,0.1,0.1,0.2,0.1c0.1,0,0.3-0.1,0.4-0.1c0.2-0.1,0.4-0.2,0.7-0.2c0.3-0.1,0.6-0.1,0.9,0c0.3,0.1,0.6,0.2,0.8,0.4 c0.6,0.4,1.2,1,1.6,1.5c0.2,0.3,0.4,0.5,0.7,0.8c0.3,0.3,0.6,0.7,0.9,1c0.6,0.6,1.4,1.1,2.1,1.5c0.1,0,0.1,0.1,0.2,0.1 c0.1,0,0.2,0,0.2,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0-0.1,0c0-0.1,0-0.1-0.1-0.1c-0.3-0.2-0.6-0.5-0.9-0.7c-0.3-0.3-0.6-0.6-0.9-0.9 c-0.4-0.5-0.8-1-1.2-1.5c-0.5-0.6-1-1.1-1.5-1.7c-0.3-0.3-0.6-0.6-1-0.8c-0.1-0.1-0.2-0.1-0.3-0.2c-0.4-0.1-0.9-0.3-1.3-0.1 c0,0,0,0-0.1,0c-0.1,0-0.1,0-0.1-0.1s0-0.1,0-0.2c0-0.1,0.1-0.1,0.1-0.2c0.2-0.1,0.3-0.1,0.5-0.1c0.6,0,1.2,0.1,1.6,0.5 c0.4,0.3,0.8,0.6,1.2,0.9c0.1,0.1,0.3,0.2,0.4,0.4c0.6,0.6,1.2,1.2,1.7,1.9c0.3,0.4,0.5,0.7,0.8,1c0.3,0.3,0.6,0.6,0.9,0.8 c0.5,0.5,1.2,0.8,1.9,1.1c0.2,0.1,0.4,0.1,0.7,0c0.1,0,0.2,0,0.3-0.1c0,0,0,0,0,0c0,0,0,0,0-0.1c0,0-0.1-0.1-0.1-0.1 c-0.4-0.1-0.7-0.2-1-0.4c-0.6-0.3-1.2-0.8-1.6-1.3c-0.4-0.4-0.7-0.9-1-1.3c-0.3-0.4-0.5-0.7-0.9-1c0,0,0,0,0,0c0,0,0-0.1,0-0.1 c0,0,0.1-0.1,0.1,0c0.1,0.1,0.2,0.2,0.3,0.2c0.4,0.3,0.8,0.6,1.2,1c0.2,0.2,0.4,0.4,0.6,0.6c0.2,0.2,0.5,0.5,0.7,0.7 c0.4,0.4,0.8,0.7,1.4,0.9c0.3,0.1,0.5,0.2,0.8,0.2c0.1,0,0.2,0,0.3,0c0.2,0,0.3,0.1,0.5,0.1c0.1,0,0.1,0,0.2,0 c0.1,0,0.1-0.1,0.2-0.1c0,0,0-0.1,0-0.1c0,0,0,0,0,0c-0.1,0-0.2,0-0.2,0c-0.4,0-0.7-0.1-1-0.3c-0.2-0.1-0.4-0.2-0.6-0.3 c-0.4-0.3-0.8-0.6-1.2-0.9c-0.4-0.4-0.7-0.8-1-1.3c0,0,0-0.1,0-0.1s0-0.1,0-0.1c0,0,0,0,0,0c0.1,0,0.2,0.1,0.3,0.2 c0.5,0.5,1.1,0.9,1.7,1.2c0.2,0.2,0.5,0.3,0.7,0.4c0.5,0.3,1.1,0.4,1.7,0.5c0.1,0,0.1,0,0.2-0.1c0.1-0.1,0.1-0.2,0.2-0.3 c0,0-0.1,0-0.1,0c-0.3,0-0.6-0.1-0.8-0.2c-0.5-0.2-1-0.5-1.4-0.9c-0.1-0.1-0.2-0.3-0.3-0.4c0-0.1,0-0.1,0-0.2 c0-0.1,0.1-0.1,0.2-0.1c0,0,0,0,0.1,0c0.5,0.3,1,0.5,1.5,0.7c0.4,0.2,0.9,0.3,1.3,0.4c0.1,0,0.2,0,0.3-0.2c0-0.1,0-0.1,0-0.1 c-0.2-0.1-0.5-0.2-0.7-0.3c-0.3-0.2-0.6-0.4-0.8-0.7c-0.1-0.1-0.1-0.2-0.1-0.3c0-0.1,0.1-0.2,0.2-0.1c0.2,0.1,0.4,0.2,0.6,0.2 c0.4,0.1,0.7,0.3,1.1,0.4c0.2,0,0.4,0.2,0.7,0.1c0.2,0,0.4-0.1,0.5-0.2c0,0,0.1,0,0.2-0.1c0-0.1-0.1-0.1-0.1-0.1 c-0.2-0.1-0.5-0.2-0.7-0.4c-0.1,0-0.2-0.1-0.2-0.2c-0.1-0.1-0.1-0.1-0.1-0.2c0,0,0-0.1,0.1-0.1c0.5,0,0.9,0.1,1.4,0.2 c0.2,0,0.4,0,0.6,0.1c0.5,0.1,1,0.3,1.4,0.5c0.3,0.1,0.7,0.3,1,0.3c0.6,0.1,1.1,0.3,1.6,0.6c0.4,0.2,0.8,0.4,1.3,0.6 c0.4,0.2,0.9,0.4,1.3,0.6c0.3,0.2,0.7,0.3,1,0.4c0.3,0.1,0.6,0.2,1,0.2c0.4,0.1,0.8,0.2,1.2,0.2c0.6,0,1.2,0,1.8,0 c0.4,0,0.7-0.1,1.1-0.3c0.2-0.1,0.3-0.2,0.5-0.2c0.1-0.1,0.2-0.1,0.3-0.2c0.2-0.1,0.3-0.3,0.5-0.4c0.1-0.1,0.3-0.2,0.4-0.4 c0.1-0.1,0.1-0.2,0.2-0.3c0.2-0.2,0.3-0.4,0.4-0.7c0.2-0.4,0.3-0.8,0.4-1.3c0.1-0.4,0.2-0.8,0.2-1.3c0.1-0.2,0-0.4,0.1-0.6 c0-0.1,0-0.3,0-0.4c0.1-0.2,0.1-0.4,0.1-0.6c0-0.2,0.1-0.4,0.1-0.6c0-0.1,0.1-0.1,0.1-0.2c0.1-0.1,0.3-0.1,0.4,0.1 c0.2,0.4,0.3,0.8,0.3,1.3c0,0.2,0,0.4,0.1,0.6c0,0.1,0,0.2,0,0.3c0,0.4,0,0.9,0,1.3c0,0.2,0,0.3-0.1,0.5c0,0.1,0,0.2,0.1,0.2 c0.2,0.2,0.5,0.3,0.8,0.4c0.2,0,0.3,0.1,0.5,0.1c0.5,0.2,0.9,0.1,1.3-0.1c0,0,0.1-0.1,0.1-0.1c-0.1,0-0.1,0-0.1,0 c-0.4,0-0.7-0.1-1.1-0.3c-0.2-0.1-0.5-0.3-0.7-0.5c0,0,0-0.1-0.1-0.1c0,0,0-0.2,0-0.2s0.1-0.1,0.1-0.1c0.2,0,0.4,0.1,0.6,0.1 c0.2,0.1,0.4,0.1,0.6,0.2c0.2,0.1,0.3,0.1,0.5,0c0.2,0,0.3,0,0.5-0.1c0.1,0,0.3,0,0.4-0.1c0.2,0,0.2-0.1,0.3-0.2 c0-0.1,0.1-0.1,0.1-0.2c0,0,0-0.1-0.1-0.1c-0.4,0-0.8,0-1.2,0c-0.5-0.1-0.9-0.2-1.3-0.5c0,0,0-0.1,0-0.2c0-0.1,0.1-0.1,0.1-0.1 c0.2,0,0.5,0.1,0.7,0.1c0.6,0.1,1.3,0.1,1.9-0.1c0.1,0,0.1-0.1,0.2-0.2s0-0.2-0.1-0.2c-0.2,0-0.4,0-0.6,0.1c-0.1,0-0.2,0-0.3,0 c-0.2,0-0.5-0.1-0.7-0.1c-0.2,0-0.3-0.1-0.5-0.2c-0.1,0-0.1-0.1-0.1-0.1c-0.1-0.1-0.1-0.3,0-0.3c0.1-0.1,0.3-0.1,0.4,0 c0.3,0.1,0.7,0.1,1,0c0.2,0,0.5-0.1,0.7-0.1c0.1,0,0.2-0.1,0.2-0.2c0-0.1,0-0.3,0-0.4c0,0,0-0.1-0.1-0.1c-0.2,0-0.3,0.1-0.5,0.1 c-0.3,0-0.7,0-1,0c-0.3,0-0.6-0.1-0.8-0.3c0,0-0.1-0.1-0.1-0.1c0-0.1,0-0.2,0-0.2c0,0,0.1-0.1,0.2-0.1c0.2,0,0.3,0,0.5,0 c0.2,0,0.4,0.1,0.6,0c0.3,0,0.6-0.1,0.9-0.1c0.1,0,0.2-0.1,0.2-0.2c0-0.2,0-0.4-0.2-0.5c0,0,0,0-0.1,0c-0.1,0-0.2,0.1-0.3,0.1 c-0.5,0.1-1,0.1-1.5,0c-0.1,0-0.2,0-0.2-0.1c-0.1,0-0.1-0.1-0.2-0.1c-0.1-0.1-0.1-0.3,0.1-0.4c0.2-0.1,0.4-0.1,0.6-0.1 c0.3,0,0.7,0,1,0c0.1,0,0.1,0,0.2-0.1c0,0,0.1-0.1,0.1-0.1c0-0.1-0.1-0.3-0.1-0.4c0,0-0.1-0.1-0.1-0.1c-0.2,0.1-0.3,0.1-0.5,0.1 c-0.4,0.1-0.8,0-1.3-0.1c-0.1,0-0.2-0.2-0.2-0.3c0-0.1,0.1-0.2,0.2-0.2c0,0,0,0,0.1,0c0.3,0,0.6-0.1,0.9-0.1c0.1,0,0.3,0,0.4,0 c0,0,0.1,0,0.1,0c0,0,0.1-0.1,0.1-0.1c-0.2-0.5-0.4-1-0.6-1.5c-0.1-0.2-0.2-0.4-0.2-0.6c0-0.2,0-0.4,0.2-0.6 c0.2-0.3,0.5-0.4,0.9-0.4C577.6,619.4,577.8,619.4,578,619.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M544.1,577.9c0.2-0.1,0.3-0.2,0.4-0.3c0.1-0.1,0-0.2-0.1-0.2c-0.4-0.2-0.8-0.4-1-0.8c-0.1-0.1-0.1-0.3-0.1-0.4 c0-0.1,0.1-0.1,0.2-0.1c0.5,0.3,1,0.5,1.5,0.7c0,0,0.1,0,0.2,0c0.1-0.1,0.2-0.2,0.2-0.3c0,0,0-0.1,0.1-0.1c0.1-0.2,0.1-0.2-0.1-0.3 c-0.1,0-0.1,0-0.2,0c-0.1,0-0.2-0.1-0.3-0.1c-0.2-0.1-0.4-0.3-0.5-0.5c0-0.1,0.1-0.3,0.2-0.3c0,0,0.1,0,0.1,0 c0.3,0.1,0.6,0.2,0.9,0.3c0.1,0,0.2,0.1,0.3,0.1c0.1,0,0.2,0,0.2-0.1c0.1-0.2,0.2-0.4,0.3-0.6c0,0,0-0.1,0-0.1c0,0-0.1-0.1-0.2-0.1 c-0.3,0-0.5-0.2-0.7-0.5c-0.1-0.1-0.1-0.2-0.1-0.3c0-0.2,0.2-0.3,0.3-0.3s0.3,0.1,0.4,0.1c0.2,0.1,0.4,0.1,0.5,0.2c0,0,0.1,0,0.2,0 c0.2-0.3,0.4-0.5,0.6-0.8c0.4-0.6,0.8-1.1,1.3-1.5c0.3-0.3,0.6-0.5,0.9-0.7c0.4-0.2,0.8-0.5,1.3-0.7c1-0.5,2-1,3-1.3 c0.6-0.2,1.1-0.3,1.7-0.3c0.4,0,0.9,0,1.3,0c0.1,0,0.1-0.1,0.1-0.1c-0.1-0.3-0.2-0.7-0.3-1c0,0,0-0.1,0-0.1c0,0-0.1-0.1-0.1-0.1 c-0.1,0-0.2,0-0.3,0c-0.5,0.1-0.9,0.1-1.4,0.2c-0.3,0-0.6,0.1-0.9,0.2c-0.3,0.1-0.6,0.1-0.9,0.3c-0.1,0-0.2,0.1-0.3,0.1 c-0.1,0-0.1,0-0.2,0c0,0,0-0.1,0-0.1c0.3-0.2,0.7-0.4,1-0.5c0.2,0,0.3-0.1,0.5-0.2c0.6-0.2,1.2-0.3,1.9-0.3c0.1,0,0.2,0,0.2,0 c0,0,0.1,0,0.1,0s0.1-0.1,0.1-0.1c0-0.2-0.1-0.4-0.1-0.7c0-0.2-0.1-0.2-0.3-0.2c-0.4,0.1-0.9,0.2-1.3,0.3c-0.6,0.1-1.3,0.2-1.8,0.5 c-0.3,0.1-0.6,0.2-0.8,0.2c0,0-0.1,0-0.1,0c0,0-0.1-0.1-0.1-0.1c0-0.1,0.1-0.2,0.2-0.2c0.7-0.3,1.3-0.6,2-0.8 c0.5-0.1,1.1-0.3,1.6-0.4c0.1,0,0.2-0.1,0.3-0.1c0,0,0.1-0.1,0.1-0.1c0-0.3,0-0.7-0.1-1c0-0.2,0-0.3,0-0.5c0-0.1,0-0.2,0-0.2 c0-0.1,0-0.3,0-0.4c0,0,0-0.1-0.1-0.1c0,0,0,0-0.1,0c-0.3,0.4-0.6,0.8-0.9,1.2c-0.1,0.1-0.1,0.2-0.2,0.3c-0.1,0.1-0.3,0.1-0.4,0 c0,0-0.1,0-0.1-0.1c-0.2-0.2-0.2-0.2-0.5-0.1c-0.1,0-0.2,0-0.2,0.1c-0.6,0.1-1.1,0.3-1.6,0.5c-0.1,0-0.1,0-0.2,0.1c0,0-0.1,0-0.1,0 c0,0-0.1-0.1,0-0.1c0-0.1,0-0.1,0.1-0.1c0.2-0.1,0.3-0.2,0.5-0.3c0.5-0.2,1-0.4,1.5-0.5c0.2,0,0.3-0.1,0.2-0.3 c-0.1-0.1-0.2-0.3-0.3-0.4c-0.1,0-0.1,0-0.1,0c-0.4,0.1-0.7,0.2-1.1,0.3c-0.2,0.1-0.4,0.1-0.7,0.2c-0.1,0-0.1,0-0.2,0 c0-0.1,0-0.1,0-0.2c0.1-0.1,0.2-0.2,0.3-0.3c0.2-0.1,0.4-0.2,0.6-0.3c0.2,0,0.4-0.1,0.6-0.1c0.1,0,0.1-0.1,0.1-0.2 c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.5-0.2-0.3-0.5-0.3c-0.2,0-0.3,0.1-0.5,0.2c-0.1,0-0.3,0.1-0.4,0.1c-0.1,0-0.1,0-0.2-0.1 c0-0.1,0-0.2,0-0.2c0,0,0-0.1,0.1-0.1c0.1-0.1,0.2-0.1,0.2-0.2c0.1-0.1,0.3-0.1,0.4-0.1c0.2,0,0.3-0.1,0.5-0.1c0,0,0.1-0.1,0.1-0.1 c-0.1-0.1-0.1-0.3-0.2-0.4c0-0.1-0.1-0.1-0.2-0.1c-0.2,0.1-0.3,0.1-0.5,0.2c-0.1,0-0.2,0-0.2,0c-0.1,0-0.1,0-0.1-0.1 c0,0,0-0.1,0-0.2c0-0.1,0.1-0.1,0.2-0.2c0.2-0.1,0.4-0.2,0.6-0.3c0.1,0,0.1-0.1,0.1-0.1c-0.1-0.4-0.2-0.9-0.2-1.3c0,0,0-0.1,0-0.1 c0,0-0.1-0.1-0.1,0c-0.1,0.1-0.3,0.2-0.4,0.4c-0.3,0.4-0.7,0.8-1,1.1c-0.3,0.3-0.6,0.6-0.9,0.9c-0.3,0.3-0.6,0.6-0.9,0.8 c-0.3,0.2-0.5,0.4-0.8,0.6c-0.2,0.2-0.4,0.3-0.6,0.5c-0.7,0.5-1.4,1-2.1,1.5c-0.8,0.5-1.7,1-2.6,1.5c-0.4,0.2-0.8,0.4-1.3,0.5 c-0.1,0-0.3,0.1-0.4,0c-0.1,0-0.1,0-0.2-0.1c0,0,0-0.1,0-0.1c0,0,0.1-0.1,0.1-0.1c0.2-0.2,0.5-0.3,0.7-0.5c0,0,0.1,0,0.1-0.1 c0,0,0-0.1,0-0.1c-0.3-0.2-0.6-0.4-0.8-0.6c-0.4-0.5-0.9-1.1-1.2-1.7c-0.3-0.6-0.6-1.1-0.9-1.7c-0.3-0.6-0.6-1.1-1-1.6 c-0.3-0.4-0.6-0.7-0.9-1c-0.4-0.3-0.8-0.5-1.2-0.7c-0.2-0.1-0.4-0.1-0.6-0.1c-0.6,0-1.2,0-1.8,0.1c-0.1,0-0.1,0-0.2,0 c-0.4,0-0.7,0.1-1.1,0.2c0,0-0.1,0-0.1,0c0,0,0,0.1-0.1,0.1c0.1,0.1,0.1,0.3,0.2,0.4c0.1,0.2,0.2,0.4,0.3,0.6 c0.1,0.2,0.1,0.5,0.1,0.7c0,0.2-0.1,0.3-0.3,0.2c-0.1-0.1-0.2-0.1-0.3-0.2c-0.2-0.3-0.5-0.5-0.6-0.8c-0.1-0.1-0.2-0.2-0.2-0.3 c-0.2-0.3-0.5-0.6-0.8-0.8c-0.1-0.1-0.2-0.1-0.4-0.1c-0.1,0-0.2,0-0.3,0c-0.1,0-0.2,0.1-0.3,0.1c-0.2,0.1-0.3,0.3-0.4,0.5 c0,0,0,0.1,0,0.2c0,0.1,0.1,0.2,0.2,0.4c0,0.1,0,0.2,0,0.3c0,0.1-0.1,0.1-0.2,0.1c-0.1,0-0.2-0.1-0.3-0.1c-0.5-0.3-1-0.5-1.5-0.6 c-0.5-0.2-1.1-0.3-1.6-0.3c-0.4,0-0.8,0-1.2,0.1c-0.1,0-0.2,0-0.3,0c-0.1,0-0.2,0-0.3,0c-1.1,0.2-2,0.7-2.9,1.3 c-0.1,0.1-0.2,0.1-0.2,0.2c0,0,0.1,0,0.1,0c0.1,0,0.3,0,0.4,0c0.3,0,0.7,0,1,0.1c0.1,0,0.1,0,0.2,0c0,0,0.1-0.1,0.1-0.1 c0-0.2,0-0.3,0-0.5c0-0.1,0-0.2,0-0.3c0-0.1,0.1-0.1,0.1-0.1c0.1,0,0.2,0,0.2,0.1c0,0.1,0,0.1,0,0.2c0,0.2,0,0.4,0,0.6 c0,0.1,0,0.2,0,0.2c0,0,0,0.1,0.1,0.1c0.2,0,0.3,0.1,0.4,0.1c0,0,0.1,0,0.1-0.1c0,0,0-0.1,0-0.2c0-0.2,0-0.4,0-0.6 c0-0.1,0-0.2,0-0.3c0,0,0-0.1,0.1-0.1c0,0,0,0,0,0c0,0,0.1,0,0.1,0c0.1,0.1,0.1,0.3,0.1,0.4c0,0.3,0,0.6,0,0.9c0,0.1,0,0.1,0.1,0.1 c0.1,0,0.2,0.1,0.3,0.1c0.2,0,0.2,0,0.2-0.2c0-0.1,0-0.2,0-0.2c0-0.4,0-0.8,0.1-1.2c0,0,0-0.1,0-0.1c0,0,0.1-0.1,0.1-0.1 s0.1,0,0.1,0c0.1,0.1,0.2,0.3,0.2,0.5c0,0.5,0.2,0.9,0.1,1.4c0,0,0,0.1,0.1,0.1c0.1,0.1,0.2,0.1,0.4,0.1c0.1,0,0.2,0,0.2-0.1 c0-0.4,0.1-0.8,0.1-1.2c0-0.1,0-0.2,0-0.2c0-0.1,0-0.1,0.1-0.2c0-0.1,0.1-0.1,0.1-0.1c0,0,0.1,0,0.1,0.1c0.1,0.2,0.1,0.3,0.2,0.5 c0,0.3,0,0.6,0.1,0.9c0,0.1,0,0.2,0,0.3c0,0.1,0,0.2,0,0.2c0,0,0,0.1,0,0.1c0.1,0.1,0.2,0.1,0.4,0.2c0,0,0.1,0,0.1-0.1 c0-0.4,0.1-0.8,0.1-1.2c0-0.1,0-0.2,0.1-0.3c0-0.1,0.2-0.1,0.2,0c0,0,0.1,0.1,0.1,0.1c0.1,0.6,0.2,1.1,0.1,1.7c0,0.1,0,0.1,0.1,0.2 c0.1,0.1,0.2,0.1,0.3,0.2c0,0,0.1,0,0.1-0.1c0.1-0.1,0.1-0.2,0.2-0.4c0.1-0.1,0.2-0.2,0.3-0.2c0.1,0,0.1,0,0.2,0 c0.1,0.1,0.2,0.2,0.2,0.3c0,0.1,0,0.2,0,0.3c0,0.2,0,0.4,0.1,0.6c0,0,0,0.1,0,0.1c0.1,0.7,0.4,1.3,0.6,2c0.1,0.4,0.3,0.7,0.7,1 c0.3,0.2,0.5,0.4,0.7,0.7c0,0,0.1,0.1,0.1,0.1c0,0,0,0.1-0.1,0.1c-0.1,0-0.2,0-0.3,0c-0.2,0-0.4-0.1-0.6-0.2s-0.4-0.2-0.6-0.3 c-0.1-0.1-0.3-0.1-0.4-0.1c-0.4,0-0.7,0-1.1,0.1c-0.5,0-0.9,0.2-1.4,0.3c-0.6,0.2-1.2,0.5-1.8,0.7c-0.6,0.2-1.1,0.6-1.5,0.9 c-0.3,0.2-0.5,0.4-0.7,0.7c0,0,0,0,0,0.1c0,0,0.1,0.1,0.1,0.1c0.3-0.1,0.7,0,1-0.2c0.1,0,0.3,0,0.4,0c0.1,0,0.2,0,0.3,0 c0,0,0.1,0,0.1,0c0,0,0.1-0.1,0.1-0.1c0-0.1,0-0.2,0-0.3c0-0.1,0-0.2,0-0.3c0,0,0.1-0.1,0.1-0.1c0,0,0.1,0,0.1,0.1 c0,0.1,0,0.1,0,0.2c0,0.2,0,0.3,0,0.5c0,0,0.1,0.1,0.1,0.1c0.1,0,0.2,0,0.3,0c0,0,0.1-0.1,0.1-0.1c0-0.1,0-0.2,0-0.2 c-0.1-0.2-0.1-0.4-0.1-0.6c0-0.1,0-0.1,0.1-0.2c0,0,0.1,0,0.1,0c0.1,0.1,0.2,0.2,0.2,0.4c0,0.2,0,0.4,0,0.6c0,0,0.1,0.1,0.1,0.1 c0.2,0,0.3,0,0.5,0c0,0,0.1-0.1,0.1-0.1c0-0.1,0-0.2,0-0.3c0-0.2,0-0.4,0-0.6c0-0.1,0.1-0.2,0.1-0.3c0,0,0.1-0.1,0.1,0c0,0,0,0,0,0 c0,0,0.1,0.1,0.1,0.1c0.1,0.4,0.2,0.8,0.1,1.1c0,0,0,0.1,0,0.1c0,0,0,0,0,0c0.2,0,0.3,0.1,0.5,0.1c0,0,0,0,0.1,0 c0,0,0.1-0.1,0.1-0.1c-0.1-0.4,0-0.8,0.1-1.2c0,0,0.1-0.1,0.1-0.1c0,0,0.1,0,0.1,0c0.1,0.1,0.1,0.2,0.1,0.3c0,0.4,0.1,0.8,0.1,1.1 c0,0,0.1,0.1,0.1,0.1c0.2,0,0.4,0.1,0.6,0.1c0,0,0,0,0.1,0c0,0,0.1,0,0.1-0.1c-0.1-0.5,0-1,0.1-1.5c0-0.1,0-0.1,0.1-0.2 c0-0.1,0.2-0.1,0.3,0c0,0,0.1,0.1,0.1,0.1c0.1,0.2,0.1,0.4,0.2,0.6c0,0.3,0,0.7,0,1c0,0.3,0,0.3,0.2,0.4c0.2,0.1,0.5,0.2,0.7,0.3 c0.1,0.1,0.3,0,0.3-0.2c0-0.1,0-0.2,0-0.3c0-0.1-0.1-0.3-0.1-0.4c0-0.1,0-0.1,0.1-0.2c0.1-0.1,0.2-0.1,0.3,0 c0.3,0.1,0.5,0.3,0.6,0.6c0.1,0.2,0.1,0.4,0.1,0.7c0,0.3,0,0.5,0,0.8c0,0.2,0,0.5,0,0.7c0,0.2,0.1,0.5,0.1,0.7 c0.1,0.3,0.2,0.5,0.5,0.6c0.1,0.1,0.2,0.1,0.2,0.2c0,0,0.1,0.1,0.1,0.2c0,0.1-0.1,0.1-0.1,0.2c-0.1,0-0.2,0-0.3,0 c-0.1,0-0.2-0.1-0.3-0.1c-0.6-0.2-1-0.6-1.2-1.2c-0.1-0.2-0.1-0.4-0.1-0.6c0-0.1-0.1-0.1-0.1-0.2c-0.4-0.2-0.9-0.4-1.3-0.5 c-0.1,0-0.1,0-0.2,0c0,0-0.1,0-0.1,0c-0.1,0.1-0.2,0.2-0.3,0.3c0,0.1,0,0.1,0,0.2c0.1,0.4,0.2,0.7,0.3,1.1c0,0.1,0.1,0.2,0.1,0.3 c0.1,0.2,0.3,0.4,0.5,0.6c0.2,0.2,0.4,0.5,0.6,0.7c0.3,0.4,0.7,0.7,1,1.1c0.3,0.3,0.5,0.7,0.7,1c0.1,0.2,0.2,0.5,0.3,0.8 c0.1,0.4,0.2,0.7,0.3,1c0.2,0.5,0.5,0.9,1,1.3c0,0,0,0,0,0c0,0,0,0,0,0c0-0.1,0-0.1-0.1-0.2c-0.1-0.3-0.3-0.7-0.4-1 c-0.1-0.4-0.3-0.9-0.4-1.3c0-0.1,0-0.1-0.1-0.2c-0.2-0.4-0.3-0.8-0.6-1.1c-0.2-0.4-0.5-0.7-0.8-0.9c-0.2-0.2-0.4-0.3-0.6-0.5 c-0.2-0.2-0.5-0.4-0.6-0.7c-0.1-0.1-0.1-0.2-0.2-0.2c-0.2-0.4-0.3-0.8-0.4-1.1c0-0.1,0-0.2,0.1-0.3c0-0.1,0.1-0.1,0.1-0.1 c0,0,0.1,0,0.1,0.1c0.1,0.1,0.1,0.2,0.1,0.3c0.1,0.4,0.3,0.7,0.6,1c0.1,0.1,0.1,0.1,0.2,0.2c0.3,0.3,0.6,0.6,0.9,0.9 c0.4,0.3,0.7,0.6,0.9,1c0.3,0.5,0.5,1.1,0.7,1.6c0.1,0.5,0.3,1,0.5,1.5c0.2,0.6,0.5,1.1,0.8,1.5c0,0,0.1,0.1,0.1,0.1 c0.1,0.1,0.1,0.1,0.1,0c0,0,0-0.1,0-0.1c-0.2-0.5-0.4-1-0.6-1.5c-0.2-0.6-0.3-1.1-0.5-1.7c-0.2-0.7-0.4-1.3-0.7-1.9 c0-0.1-0.1-0.2-0.1-0.3c0,0,0,0,0-0.1c0,0,0-0.1,0.1-0.1c0.2,0,0.3,0.1,0.4,0.3c0,0.1,0.1,0.2,0.2,0.2c0.3,0.5,0.5,0.9,0.7,1.4 c0.2,0.5,0.3,1,0.5,1.5c0.1,0.4,0.3,0.9,0.5,1.3c0.1,0.3,0.3,0.6,0.4,0.9c0.1,0.1,0.2,0.3,0.3,0.4c0.1,0.1,0.2,0.1,0.3,0.1 c0,0,0.1,0,0.1,0c0,0,0,0,0-0.1c-0.1-0.2-0.2-0.4-0.3-0.7c-0.5-1.1-0.8-2.2-1.1-3.3c-0.1-0.3-0.2-0.6-0.3-0.9 c-0.2-0.4-0.3-0.8-0.5-1.2c0,0,0,0,0,0c0,0,0,0,0,0c0.3,0.2,0.5,0.4,0.7,0.7c0.2,0.5,0.4,0.9,0.6,1.4c0.2,0.7,0.5,1.5,0.8,2.2 c0.3,0.8,0.8,1.5,1.3,2.1c0,0.1,0.1,0.1,0.2,0.2c0,0,0.1,0,0.1,0c0.1,0,0.2,0,0.3,0c-0.2-0.4-0.5-0.8-0.7-1.2 c-0.2-0.4-0.4-0.7-0.5-1.1c-0.2-0.5-0.3-0.9-0.4-1.4c0-0.2,0-0.3,0.1-0.4c0,0,0.1-0.1,0.1-0.1c0,0,0.1,0,0.1,0 c0.3,0.5,0.5,1,0.7,1.5c0.1,0.3,0.2,0.6,0.4,0.8c0.3,0.4,0.5,0.8,0.8,1.1c0.2,0.2,0.4,0.4,0.6,0.6c0,0,0,0,0.1,0c0.1,0,0.2,0,0.3,0 c0,0,0-0.1,0-0.1c0-0.1-0.1-0.1-0.1-0.1c-0.2-0.2-0.5-0.5-0.6-0.7c-0.2-0.4-0.5-0.8-0.6-1.2c-0.1-0.2-0.1-0.4-0.2-0.6 c0,0,0-0.1,0-0.1c0,0,0,0,0-0.1c0,0,0-0.1,0.1-0.1c0,0,0.1,0,0.2,0c0.1,0.1,0.2,0.3,0.3,0.4c0.2,0.5,0.5,0.9,0.9,1.4 c0.1,0.2,0.3,0.3,0.4,0.4c0.2,0.1,0.4,0.3,0.5,0.4c0,0,0.1,0,0.1,0.1c0.1,0,0.2,0,0.3,0c0,0,0-0.1,0-0.1c0,0-0.1-0.1-0.1-0.1 c-0.3-0.2-0.5-0.5-0.7-0.7c-0.3-0.4-0.5-0.8-0.6-1.2c0-0.1,0-0.2,0-0.3c0,0,0-0.1,0-0.1c0,0,0,0,0,0c0,0,0.1,0,0.1,0 c0.2,0.2,0.3,0.4,0.5,0.6c0.3,0.3,0.5,0.6,0.8,0.8c0.3,0.3,0.6,0.5,0.9,0.8c0,0,0.1,0,0.1,0c0.1,0,0.2,0,0.3-0.2 c-0.1-0.1-0.1-0.1-0.2-0.2c-0.1-0.1-0.2-0.2-0.3-0.3c-0.2-0.2-0.4-0.5-0.6-0.7c-0.1-0.1-0.1-0.2-0.2-0.3c0-0.1,0-0.1,0-0.2 c0-0.1,0-0.1,0.1-0.2c0,0,0.1,0,0.1,0c0.3,0.2,0.5,0.4,0.7,0.6c0.4,0.4,0.8,0.6,1.3,0.8c0.2-0.1,0.4-0.2,0.6-0.4c0,0,0-0.1,0-0.1 c-0.5-0.1-0.9-0.5-1.3-0.9c-0.1-0.2-0.2-0.3-0.1-0.5c0-0.1,0.1-0.1,0.1-0.1c0.1,0.1,0.2,0.2,0.3,0.3 C543,577.5,543.5,577.8,544.1,577.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M567.7,514.5c0.1,0.1,0.2,0.1,0.3,0.1c0.3,0,0.5,0.1,0.7,0.2c0.8,0.2,1.5,0.4,2.2,0.8c0.5,0.2,0.9,0.5,1.3,0.7 c0.3,0.2,0.7,0.3,1,0.4c0.1,0,0.1,0,0.2,0c0.2,0,0.4,0,0.6,0c0.1,0,0.2,0,0.2-0.1c0.2-0.1,0.5-0.2,0.6-0.4c0.3-0.3,0.5-0.6,0.7-0.9 c0.2-0.3,0.3-0.6,0.4-1c0-0.1,0-0.2-0.1-0.2c0,0-0.1-0.1-0.1-0.1c-0.2-0.1-0.5-0.2-0.7-0.3c-0.4-0.2-0.8-0.2-1.2-0.3 c-0.5-0.1-1-0.1-1.4-0.2c0,0,0,0-0.1,0c-0.4,0-0.7,0-1.1,0c-0.1,0-0.2,0-0.3,0c-0.6,0.1-1.1,0.2-1.7,0.4c-0.5,0.2-1,0.4-1.5,0.7 C567.8,514.4,567.8,514.5,567.7,514.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M529.3,554.9c0.1-0.1,0.3-0.3,0.4-0.4c0.2-0.2,0.4-0.3,0.6-0.4c0.1,0,0.1,0,0.2,0s0.1,0,0.1,0.1 c0,0,0,0.1,0,0.2c-0.1,0.1-0.1,0.2-0.2,0.2c-0.3,0.2-0.5,0.5-0.8,0.6c0,0-0.1,0.1-0.1,0.1c0,0.2,0,0.3,0.1,0.4c0,0,0.1,0,0.1,0 c0.4-0.2,0.8-0.4,1.3-0.5c0,0,0.1,0,0.1,0.1c0,0,0,0,0,0.1c0,0.1-0.1,0.2-0.2,0.3c-0.3,0.2-0.6,0.4-0.9,0.6 c-0.2,0.1-0.2,0.2-0.2,0.4c0,0.1,0,0.2,0.1,0.3c0,0.1,0.1,0.1,0.1,0.1c0.1,0,0.2,0,0.3,0.1c0.3,0.1,0.6,0.2,0.9,0.4 c0.1,0.1,0.2,0.1,0.3,0.2c0.1,0,0.2,0,0.2,0c0.4-0.3,0.8-0.5,1.2-0.7c0.2-0.1,0.4-0.1,0.6-0.2c0.1,0,0.2-0.1,0.1-0.2 c-0.1-0.4-0.3-0.8-0.5-1.2c-0.3-0.5-0.6-1.1-0.9-1.6c-0.2-0.3-0.3-0.5-0.6-0.7c-0.3-0.3-0.6-0.5-0.9-0.7c-0.4-0.3-0.9-0.4-1.4-0.5 c-0.5-0.1-1-0.2-1.5-0.1c-0.2,0-0.4,0-0.6,0.1c-0.1,0-0.1,0-0.1,0.1c0,0,0,0.1,0.1,0.1c0.4,0.3,0.8,0.7,1.1,1.1 c0,0,0.1,0.1,0.1,0.1c0,0,0.1,0,0.2,0c0.1-0.1,0.1-0.2,0.2-0.2c0.1-0.1,0.1-0.2,0.2-0.2c0.1-0.1,0.1-0.1,0.2-0.2 c0.1,0,0.2-0.1,0.3,0c0,0,0.1,0.1,0,0.1c0,0,0,0.1,0,0.1c-0.1,0.2-0.2,0.3-0.4,0.5c-0.1,0.1-0.2,0.2-0.4,0.3c0,0,0,0.1,0,0.1 c0,0.1,0.1,0.2,0.1,0.2c0,0,0.1,0,0.2,0c0.1-0.1,0.2-0.3,0.4-0.4c0.2-0.1,0.3-0.3,0.5-0.4c0.1,0,0.1,0,0.2,0c0,0,0.1,0,0.1,0.1 c0,0,0,0.1,0,0.1c0,0.1-0.1,0.1-0.1,0.1c-0.2,0.2-0.5,0.5-0.7,0.7c-0.1,0-0.1,0.1-0.2,0.2c0,0-0.1,0.1,0,0.2 C529.1,554.6,529.2,554.8,529.3,554.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M579.1,502.1c-0.3-0.2-0.6-0.5-0.7-0.9c-0.2-0.4-0.2-0.8-0.2-1.2c0-0.1,0-0.1,0-0.2c0,0,0-0.1,0-0.1 c0,0,0,0,0-0.1c0,0-0.1-0.1-0.1-0.1c0,0-0.1,0-0.1,0.1c-0.1,0.4,0,0.8,0,1.1c0.1,0.3,0.1,0.7,0.3,1c0.1,0.1,0.2,0.2,0.3,0.2 c0.1,0,0.2,0.1,0.3,0.1c0.2,0.1,0.4,0,0.6-0.1c0.1,0,0.2-0.1,0.3-0.1c0.6-0.4,1.2-0.7,1.7-1.2c0,0,0.1-0.1,0.1-0.1 c0.3-0.2,0.5-0.5,0.8-0.7c0.2-0.3,0.5-0.5,0.7-0.7c0.3-0.3,0.6-0.5,0.8-0.8c0,0,0,0,0-0.1c0,0,0,0,0,0c-0.2-0.1-0.4,0-0.6,0 c-0.5,0-0.9,0.1-1.4,0.2c-0.8,0.2-1.5,0.5-2.2,0.8c0,0-0.1,0.1-0.1,0.1c0,0.2,0.1,0.4,0.1,0.6c0,0.2-0.1,0.5,0,0.7 c0,0.1,0,0.2,0,0.2c-0.1,0.2-0.1,0.4-0.1,0.6c0,0.1-0.1,0.3-0.1,0.4C579.4,502,579.3,502.1,579.1,502.1z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M525.1,669.8c-0.8,0.1-0.4-1.1,0.2-1.5c1.6-1.2,3.6-0.3,5.1,0.5c0.9,0.5,2.1,1.3,2.4,1.5c0.3,0.2,0-0.2-0.6-0.6 c-4.7-3.4-4.8-4-6.6-4.4c-0.7-0.2-1.8-0.1-3.3,1.2c-0.2,0.1-0.2-0.4-0.1-0.8c0.5-1.6,1.3-2.1,2.7-2.5c0.2-0.1,0.1-0.2-0.1-0.4 c-0.5-0.5-2.5-3.3-2.7-3.4c-0.1,0-1.3,0.3-1-0.3c1-1.5,1.4-0.9,1.8,0.1c0.1,0.3,0.4,0.7,0.9,1.3c2.3,2.7,4.8,4.3,7.6,6.3 c2.5,1.8,4.5,3.5,6.9,5.4c5.8,4.7,6.9,1.1,6.9,1.2c-0.7,0.9-1.7,1.3-3.1,0.9c-1.8-0.5-4.6-3.2-6.2-4.4c-2.5-2-4.9-3.7-7.5-5.6 c-2.3-1.7-4.1-3.5-5.6-5.9c-1.4-2.2-1.3-3.2,0.4-4.7c0.7-0.5-0.3,0.2-0.8-0.8c-0.1-0.3-0.4-0.7-0.4-0.8c0.1-0.1,3,0.2,3.3,0.4 c0.7,0.3,1.5,0.8,1.7,1c0.2,0.2-0.1,0.1-0.5,0c-0.6-0.2-2.5-0.4-3,0c-0.1,0.1,0.5,0,1.1-0.1c2.6,0,4.3,2.2,6,3.8 c2.6,2.3,5.8,5.3,7.8,6.9c1.5,1.2,2.8,2.3,3.2,2.5c0.4,0.2,0-0.3-0.8-0.9c-1.8-1.6-6-5-9.5-8.3c-2-1.8-4.2-4-4.8-4.9 c-0.5-0.8-1.4-2.7-1.4-3.6c0-0.2,0.1-0.8,0.3-0.9c0.1-0.1,0.2,0.2,0.4,0.8c1.7,3.4,5.1,6.4,7.7,9.2c1.9,2,4.6,4.5,7,6.8 c1.4,1.4,2.3,2,3.2,3.2c0.2,0.4,0.6,0.8,0.9,1.4c0.7,1.5,1.2,3.4,1,2.4c-0.2-0.5-0.5-1.7-0.8-2.5c-1.9-4.6-14.4-12.1-13.9-16.3 c0.2-2.5,4-1.6,3.6-1c0,0-2.7-0.5-2.1,1.8c0.6,2.2,7,6.7,8.9,8.5c4.7,4.3,5.6,9.2,5.9,9.6c0.1,0.1,1.1,0,1.6,0.8 c0.2,0.3-0.8,2.9-0.5,2.4c0.3-0.4,0.8-2.4,1.9-1.5c0.4,0.3,0.5,0.8,0.4,1.4c-0.1,0.6-0.4,1.3-0.8,1.6c-0.3,0.3-1.6,0.6-2.5,0.4 c-1.2-0.2-1.9-1-2.1-1.2c-0.2-0.2,0.8-2,0.9-2.7c0-0.6-0.8,2.1-2.1,2.9c-1.6,0.9-3.3,0.4-5-0.1c-1.6-0.5-2.9-1.4-3.9-1.9 c-3-1.7-3.5-3.1-8-4.8C527,668.9,526.1,669.7,525.1,669.8L525.1,669.8z M543.6,671.2c-0.2,0.2-0.2,0.6,0.1,0.8 c0.2,0.2,0.6,0.2,0.8-0.1l0.3-0.4c0.2-0.3,0.2-0.6-0.1-0.9c-0.2-0.2-0.6-0.1-0.9,0.1L543.6,671.2L543.6,671.2z M542.4,672.9 c-0.2,0.2-0.2,0.6,0.1,0.9c0.2,0.2,0.6,0.1,0.9-0.1l0.3-0.4c0.2-0.2,0.2-0.6-0.1-0.8l0,0c-0.2-0.2-0.6-0.1-0.8,0.1L542.4,672.9 L542.4,672.9z M541.1,671.9c-0.2,0.2-0.2,0.6,0.1,0.8c0.2,0.2,0.6,0.2,0.8-0.1l0.3-0.4c0.2-0.3,0.2-0.6-0.1-0.9 c-0.2-0.2-0.6-0.1-0.8,0.1L541.1,671.9L541.1,671.9z M539.7,670.9c-0.2,0.2-0.2,0.6,0.1,0.9c0.2,0.2,0.6,0.1,0.8-0.1l0.3-0.4 c0.2-0.2,0.2-0.6-0.1-0.8c-0.2-0.2-0.6-0.2-0.9,0L539.7,670.9L539.7,670.9z M538.4,670.9c0.3,0.2,0.6,0.1,0.9-0.1l0.3-0.4 c0.2-0.2,0.1-0.6-0.1-0.9c-0.3-0.2-0.6-0.1-0.9,0.1l-0.3,0.4C538.2,670.2,538.2,670.6,538.4,670.9z M537,669.7 c0.2,0.2,0.6,0.1,0.8-0.1l0.3-0.4c0.2-0.2,0.2-0.6-0.1-0.9c-0.2-0.2-0.6-0.1-0.8,0.1l-0.3,0.4C536.7,669.1,536.7,669.5,537,669.7z  M535.7,668.6c0.2,0.2,0.6,0.2,0.8-0.1l0.3-0.4c0.2-0.3,0.2-0.6-0.1-0.9c-0.2-0.2-0.6-0.2-0.8,0.1l-0.3,0.4 C535.4,668.1,535.5,668.4,535.7,668.6z M534.2,666.7c-0.2,0.2-0.2,0.6,0.1,0.9c0.2,0.2,0.6,0.1,0.8-0.1l0.3-0.4 c0.2-0.2,0.2-0.6-0.1-0.9c-0.2-0.2-0.6-0.1-0.9,0.1L534.2,666.7L534.2,666.7z M532.8,665.5c-0.2,0.3-0.1,0.6,0.1,0.9 c0.3,0.2,0.6,0.1,0.9-0.1l0.3-0.4c0.2-0.2,0.1-0.6-0.1-0.8c-0.3-0.2-0.6-0.2-0.9,0.1L532.8,665.5L532.8,665.5z M531.4,664.5 c-0.2,0.3-0.2,0.6,0.1,0.9c0.2,0.2,0.6,0.1,0.9-0.1l0.3-0.4c0.2-0.2,0.1-0.6-0.1-0.8c-0.3-0.2-0.6-0.2-0.9,0.1L531.4,664.5 L531.4,664.5z M530,663.4c-0.2,0.3-0.2,0.6,0.1,0.9c0.2,0.2,0.6,0.1,0.8-0.1l0.3-0.4c0.2-0.2,0.2-0.6-0.1-0.8 c-0.2-0.2-0.6-0.2-0.8,0.1L530,663.4L530,663.4z M528.7,662.2c-0.2,0.3-0.1,0.6,0.1,0.9c0.3,0.2,0.6,0.1,0.9-0.1l0.3-0.4 c0.2-0.2,0.1-0.6-0.1-0.8c-0.3-0.2-0.6-0.2-0.9,0.1L528.7,662.2L528.7,662.2z M527.5,661.8c0.3,0.2,0.6,0.1,0.9-0.1l0.3-0.4 c0.2-0.2,0.1-0.6-0.1-0.9c-0.3-0.2-0.6-0.1-0.9,0.1l-0.3,0.4C527.1,661.1,527.2,661.5,527.5,661.8z M525.9,659.8 c-0.2,0.2-0.1,0.6,0.1,0.8c0.3,0.2,0.6,0.2,0.9-0.1l0.3-0.4c0.2-0.3,0.2-0.6-0.1-0.9c-0.2-0.2-0.6-0.1-0.9,0.1L525.9,659.8 L525.9,659.8z M524.6,658.4c-0.2,0.2-0.1,0.6,0.1,0.8c0.3,0.2,0.6,0.2,0.9-0.1l0.3-0.4c0.2-0.3,0.1-0.6-0.1-0.9 c-0.3-0.2-0.6-0.1-0.9,0.1L524.6,658.4L524.6,658.4z M523.5,657.3c-0.2,0.2-0.1,0.6,0.1,0.8c0.3,0.2,0.6,0.2,0.9-0.1l0.3-0.4 c0.2-0.3,0.1-0.6-0.1-0.9c-0.3-0.2-0.6-0.1-0.9,0.1L523.5,657.3L523.5,657.3z M522.9,655.4c-0.2,0.2-0.2,0.6,0.1,0.8 c0.2,0.2,0.6,0.2,0.8-0.1l0.3-0.4c0.2-0.3,0.2-0.6-0.1-0.9c-0.2-0.2-0.6-0.1-0.9,0.1L522.9,655.4L522.9,655.4z M524.9,655 c-0.2,0.2-0.2,0.6,0.1,0.8c0.2,0.2,0.6,0.2,0.8-0.1l0.3-0.4c0.2-0.3,0.2-0.6-0.1-0.9c-0.2-0.2-0.6-0.1-0.8,0.1L524.9,655L524.9,655z  M526.7,656.1c-0.2,0.3-0.2,0.6,0.1,0.9c0.2,0.2,0.6,0.1,0.8-0.1l0.3-0.4c0.2-0.2,0.2-0.6-0.1-0.8c-0.2-0.2-0.6-0.2-0.9,0.1 L526.7,656.1L526.7,656.1z M528.1,658.2c0.3,0.2,0.6,0.2,0.9-0.1l0.3-0.4c0.2-0.3,0.1-0.6-0.1-0.9c-0.3-0.2-0.6-0.2-0.9,0.1 l-0.3,0.4C527.8,657.6,527.8,657.9,528.1,658.2z M542.3,669.9c-0.2,0.3-0.2,0.6,0.1,0.9c0.2,0.2,0.6,0.1,0.8-0.1l0.3-0.4 c0.2-0.2,0.2-0.6-0.1-0.8c-0.2-0.2-0.6-0.2-0.8,0.1L542.3,669.9L542.3,669.9z M541.2,668.7c-0.2,0.3-0.1,0.6,0.1,0.9 c0.3,0.2,0.6,0.1,0.9-0.1l0.3-0.4c0.2-0.2,0.1-0.6-0.1-0.8c-0.3-0.2-0.6-0.2-0.9,0.1L541.2,668.7L541.2,668.7z M539.8,667.8 c-0.2,0.2-0.2,0.6,0.1,0.8c0.2,0.2,0.6,0.2,0.8-0.1l0.3-0.4c0.2-0.3,0.2-0.6-0.1-0.9c-0.2-0.2-0.6-0.1-0.8,0.1L539.8,667.8 L539.8,667.8z M538.5,666.5c-0.2,0.3-0.1,0.6,0.1,0.9c0.3,0.2,0.6,0.1,0.9-0.1l0.3-0.4c0.2-0.2,0.1-0.6-0.1-0.8 c-0.3-0.2-0.6-0.2-0.9,0.1L538.5,666.5L538.5,666.5z M537.3,666.1c0.3,0.2,0.6,0.2,0.9-0.1l0.3-0.4c0.2-0.3,0.2-0.6-0.1-0.9 c-0.2-0.2-0.6-0.2-0.9,0.1l-0.3,0.4C537,665.5,537.1,665.9,537.3,666.1z M535.7,664.2c-0.2,0.2-0.1,0.6,0.1,0.8 c0.3,0.2,0.6,0.2,0.9-0.1l0.3-0.4c0.2-0.3,0.1-0.6-0.1-0.9c-0.3-0.2-0.6-0.1-0.9,0.1L535.7,664.2L535.7,664.2z M534.5,663 c-0.2,0.2-0.2,0.6,0.1,0.8c0.2,0.2,0.6,0.2,0.9-0.1l0.3-0.4c0.2-0.3,0.2-0.6-0.1-0.9c-0.2-0.2-0.6-0.1-0.8,0.1L534.5,663L534.5,663z  M533.1,661.8c-0.2,0.2-0.2,0.6,0.1,0.8c0.2,0.2,0.6,0.2,0.8-0.1l0.3-0.4c0.2-0.3,0.2-0.6-0.1-0.9c-0.2-0.2-0.6-0.1-0.8,0.1 L533.1,661.8L533.1,661.8z M531.9,661.6c0.2,0.2,0.6,0.1,0.8-0.1l0.3-0.4c0.2-0.3,0.2-0.6-0.1-0.9c-0.2-0.2-0.6-0.2-0.8,0.1 l-0.3,0.4C531.6,661.1,531.6,661.4,531.9,661.6z M530.5,659.6c-0.2,0.2-0.1,0.6,0.1,0.8c0.3,0.2,0.6,0.2,0.9-0.1l0.3-0.4 c0.2-0.3,0.1-0.6-0.1-0.9c-0.3-0.2-0.6-0.1-0.9,0.1L530.5,659.6L530.5,659.6z M529.2,658.5c-0.2,0.2-0.2,0.6,0.1,0.8l0,0 c0.2,0.2,0.6,0.2,0.8-0.1l0.3-0.4c0.2-0.3,0.2-0.6-0.1-0.9c-0.2-0.2-0.6-0.1-0.9,0.1L529.2,658.5L529.2,658.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M653.2,668.1c-1,0-1.9-0.8-2.6-0.5c-4.5,1.8-5,3.2-7.9,5c-0.9,0.5-2.3,1.5-3.8,2c-1.6,0.5-3.4,1.1-5,0.2 c-1.3-0.8-2.1-3.5-2.1-2.9c0,0.6,1.1,2.4,0.9,2.6c-0.2,0.2-0.9,1-2.1,1.2c-0.9,0.2-2.2-0.1-2.5-0.4c-0.4-0.3-0.7-1-0.8-1.6 c-0.1-0.5,0-1,0.4-1.4c1-0.9,1.6,1,1.9,1.5c0.3,0.5-0.7-2.1-0.5-2.4c0.4-0.8,1.5-0.7,1.5-0.8c0.3-0.3,1.1-5.2,5.7-9.7 c1.9-1.8,8.3-6.4,8.8-8.6c0.6-2.3-2.1-1.8-2.1-1.8c-0.3-0.5,3.4-1.6,3.7,0.9c0.5,4.2-11.8,12-13.6,16.6c-0.3,0.8-0.6,2-0.8,2.5 c-0.2,1,0.3-0.9,0.9-2.4c0.3-0.6,0.6-1.1,0.9-1.5c0.9-1.2,1.8-1.8,3.1-3.3c2.3-2.4,5-4.9,6.9-6.9c2.5-2.8,5.9-5.9,7.5-9.3 c0.3-0.6,0.3-0.9,0.4-0.8c0.2,0.1,0.3,0.7,0.3,0.9c0,0.9-0.8,2.8-1.3,3.6c-0.6,0.9-2.7,3.1-4.7,5c-3.5,3.4-7.7,6.9-9.4,8.5 c-0.7,0.6-1.2,1.2-0.8,0.9c0.4-0.2,1.7-1.3,3.2-2.6c2-1.7,5.2-4.7,7.7-7.1c1.7-1.6,3.4-3.9,6-3.9c0.6,0,1.2,0.1,1.1,0.1 c-0.5-0.4-2.3-0.2-2.9,0.1c-0.4,0.1-0.7,0.3-0.5,0.1s1-0.7,1.7-1c0.3-0.1,3.2-0.6,3.3-0.4c0.1,0.1-0.2,0.5-0.3,0.8 c-0.5,0.9-1.5,0.3-0.8,0.8c1.7,1.5,1.8,2.5,0.5,4.7c-1.4,2.4-3.2,4.3-5.5,6c-2.5,1.9-4.9,3.7-7.4,5.7c-1.5,1.3-4.4,4-6.1,4.5 c-1.4,0.5-2.4,0.1-3.1-0.8c-0.1-0.1,1.1,3.5,6.8-1.3c2.3-2,4.3-3.7,6.8-5.5c2.8-2.1,5.2-3.7,7.5-6.5c0.5-0.6,0.7-1,0.9-1.3 c0.4-1,0.8-1.6,1.8-0.2c0.3,0.5-0.8,0.3-0.9,0.3c-0.2,0-2.1,2.8-2.7,3.4c-0.2,0.3-0.3,0.3-0.1,0.4c1.5,0.3,2.2,0.8,2.8,2.4 c0.1,0.4,0.1,1-0.1,0.8c-1.5-1.2-2.6-1.3-3.3-1.1c-1.8,0.5-1.9,1-6.5,4.5c-0.5,0.4-0.9,0.8-0.6,0.6c0.3-0.2,1.5-1,2.4-1.5 c1.5-0.9,3.5-1.8,5.1-0.6C653.5,667,654,668.2,653.2,668.1L653.2,668.1z M634.7,669.9l-0.3-0.4c-0.2-0.2-0.6-0.3-0.9-0.1 c-0.3,0.2-0.3,0.6-0.1,0.9l0.3,0.4c0.2,0.3,0.6,0.3,0.8,0.1C634.9,670.5,635,670.1,634.7,669.9L634.7,669.9z M635.9,671.5l-0.3-0.4 c-0.2-0.2-0.6-0.3-0.8-0.1l0,0c-0.3,0.2-0.3,0.6-0.1,0.8l0.3,0.4c0.2,0.2,0.6,0.3,0.9,0.1C636.1,672.2,636.1,671.8,635.9,671.5 L635.9,671.5z M637.2,670.5l-0.3-0.4c-0.2-0.2-0.6-0.3-0.8-0.1c-0.3,0.2-0.3,0.6-0.1,0.9l0.3,0.4c0.2,0.3,0.6,0.3,0.8,0.1 C637.4,671.1,637.4,670.7,637.2,670.5L637.2,670.5z M638.6,669.5l-0.3-0.4c-0.2-0.2-0.6-0.3-0.9,0c-0.3,0.2-0.3,0.6-0.1,0.8l0.3,0.4 c0.2,0.2,0.6,0.3,0.8,0.1C638.8,670.2,638.9,669.8,638.6,669.5L638.6,669.5z M639.9,668.6l-0.3-0.4c-0.2-0.2-0.6-0.3-0.9-0.1 c-0.2,0.2-0.3,0.6-0.1,0.9l0.3,0.4c0.2,0.2,0.6,0.3,0.9,0.1C640.1,669.2,640.1,668.8,639.9,668.6z M641.3,667.4L641,667 c-0.2-0.2-0.6-0.3-0.8-0.1c-0.3,0.2-0.3,0.6-0.1,0.9l0.3,0.4c0.2,0.2,0.6,0.3,0.8,0.1C641.5,668,641.6,667.6,641.3,667.4z  M642.6,666.3l-0.3-0.4c-0.2-0.3-0.6-0.3-0.8-0.1c-0.3,0.2-0.3,0.6-0.1,0.9l0.3,0.4c0.2,0.3,0.6,0.3,0.8,0.1 C642.8,666.9,642.8,666.6,642.6,666.3z M644,665.2l-0.3-0.4c-0.2-0.2-0.6-0.3-0.9-0.1c-0.3,0.2-0.3,0.6-0.1,0.9l0.3,0.4 c0.2,0.2,0.6,0.3,0.8,0.1C644.2,665.8,644.2,665.4,644,665.2L644,665.2z M645.4,664l-0.3-0.4c-0.2-0.3-0.6-0.3-0.9-0.1 c-0.2,0.2-0.3,0.6-0.1,0.8l0.3,0.4c0.2,0.2,0.6,0.3,0.9,0.1C645.6,664.6,645.7,664.3,645.4,664L645.4,664z M646.8,662.9l-0.3-0.4 c-0.2-0.3-0.6-0.3-0.9-0.1c-0.2,0.2-0.3,0.6-0.1,0.8l0.3,0.4c0.2,0.2,0.6,0.3,0.9,0.1C647,663.5,647,663.2,646.8,662.9L646.8,662.9z  M648.2,661.8l-0.3-0.4c-0.2-0.3-0.6-0.3-0.8-0.1c-0.3,0.2-0.3,0.6-0.1,0.8l0.3,0.4c0.2,0.2,0.6,0.3,0.8,0.1 C648.4,662.4,648.4,662.1,648.2,661.8L648.2,661.8z M649.5,660.6l-0.3-0.4c-0.2-0.3-0.6-0.3-0.9-0.1c-0.2,0.2-0.3,0.6-0.1,0.8 l0.3,0.4c0.2,0.2,0.6,0.3,0.9,0.1C649.6,661.2,649.7,660.9,649.5,660.6L649.5,660.6z M650.8,659.3l-0.3-0.4 c-0.2-0.2-0.6-0.3-0.9-0.1c-0.2,0.2-0.3,0.6-0.1,0.9l0.3,0.4c0.2,0.2,0.6,0.3,0.9,0.1C651,659.9,651,659.5,650.8,659.3z  M652.2,658.1l-0.3-0.4c-0.2-0.2-0.6-0.3-0.9-0.1c-0.3,0.2-0.3,0.6-0.1,0.9l0.3,0.4c0.2,0.3,0.6,0.3,0.9,0.1 C652.4,658.8,652.4,658.4,652.2,658.1L652.2,658.1z M653.4,656.7l-0.3-0.4c-0.2-0.2-0.6-0.3-0.9-0.1c-0.2,0.2-0.3,0.6-0.1,0.9 l0.3,0.4c0.2,0.3,0.6,0.3,0.9,0.1C653.6,657.4,653.6,657,653.4,656.7L653.4,656.7z M654.6,655.6l-0.3-0.4c-0.2-0.2-0.6-0.3-0.9-0.1 c-0.2,0.2-0.3,0.6-0.1,0.9l0.3,0.4c0.2,0.3,0.6,0.3,0.9,0.1C654.7,656.2,654.7,655.8,654.6,655.6L654.6,655.6z M655.2,653.7 l-0.3-0.4c-0.2-0.2-0.6-0.3-0.9-0.1c-0.3,0.2-0.3,0.6-0.1,0.9l0.3,0.4c0.2,0.3,0.6,0.3,0.8,0.1C655.4,654.3,655.4,653.9,655.2,653.7 L655.2,653.7z M653.1,653.4l-0.3-0.4c-0.2-0.2-0.6-0.3-0.8-0.1c-0.3,0.2-0.3,0.6-0.1,0.9l0.3,0.4c0.2,0.3,0.6,0.3,0.8,0.1 C653.3,654,653.3,653.6,653.1,653.4L653.1,653.4z M651.4,654.4l-0.3-0.4c-0.2-0.3-0.6-0.3-0.9-0.1c-0.3,0.2-0.3,0.6-0.1,0.8l0.3,0.4 c0.2,0.2,0.6,0.3,0.8,0.1C651.6,655.1,651.6,654.7,651.4,654.4L651.4,654.4z M650.1,655.7l-0.3-0.4c-0.2-0.3-0.6-0.3-0.9-0.1 c-0.2,0.2-0.3,0.6-0.1,0.9l0.3,0.4c0.2,0.3,0.6,0.3,0.9,0.1C650.2,656.3,650.3,656,650.1,655.7z M636,668.6l-0.3-0.4 c-0.2-0.3-0.6-0.3-0.8-0.1c-0.3,0.2-0.3,0.6-0.1,0.8l0.3,0.4c0.2,0.2,0.6,0.3,0.8,0.1C636.2,669.2,636.2,668.9,636,668.6L636,668.6z  M637.1,667.3l-0.3-0.4c-0.2-0.3-0.6-0.3-0.9-0.1c-0.2,0.2-0.3,0.6-0.1,0.8l0.3,0.4c0.2,0.2,0.6,0.3,0.9,0.1 C637.3,668,637.3,667.6,637.1,667.3L637.1,667.3z M638.5,666.4l-0.3-0.4c-0.2-0.2-0.6-0.3-0.8-0.1c-0.3,0.2-0.3,0.6-0.1,0.9l0.3,0.4 c0.2,0.3,0.6,0.3,0.8,0.1C638.7,667,638.7,666.6,638.5,666.4L638.5,666.4z M639.7,665.1l-0.3-0.4c-0.2-0.3-0.6-0.3-0.9-0.1 c-0.2,0.2-0.3,0.6-0.1,0.8l0.3,0.4c0.2,0.2,0.6,0.3,0.9,0.1C639.9,665.8,639.9,665.4,639.7,665.1L639.7,665.1z M641,663.8l-0.3-0.4 c-0.2-0.3-0.6-0.3-0.9-0.1c-0.3,0.2-0.3,0.6-0.1,0.9l0.3,0.4c0.2,0.3,0.6,0.3,0.9,0.1C641.2,664.4,641.2,664.1,641,663.8z  M642.5,662.8l-0.3-0.4c-0.2-0.2-0.6-0.3-0.9-0.1c-0.2,0.2-0.3,0.6-0.1,0.9l0.3,0.4c0.2,0.3,0.6,0.3,0.9,0.1 C642.6,663.4,642.7,663,642.5,662.8L642.5,662.8z M643.7,661.5l-0.3-0.4c-0.2-0.2-0.6-0.3-0.8-0.1c-0.3,0.2-0.3,0.6-0.1,0.9l0.3,0.4 c0.2,0.3,0.6,0.3,0.9,0.1C643.9,662.1,643.9,661.7,643.7,661.5L643.7,661.5z M645,660.3l-0.3-0.4c-0.2-0.2-0.6-0.3-0.8-0.1 c-0.3,0.2-0.3,0.6-0.1,0.9l0.3,0.4c0.2,0.3,0.6,0.3,0.8,0.1C645.2,661,645.3,660.6,645,660.3L645,660.3z M646.3,659.2l-0.3-0.4 c-0.2-0.3-0.6-0.3-0.8-0.1c-0.3,0.2-0.3,0.6-0.1,0.9l0.3,0.4c0.2,0.2,0.6,0.3,0.8,0.1C646.5,659.9,646.6,659.5,646.3,659.2z  M647.5,658.1l-0.3-0.4c-0.2-0.2-0.6-0.3-0.9-0.1c-0.2,0.2-0.3,0.6-0.1,0.9l0.3,0.4c0.2,0.3,0.6,0.3,0.9,0.1 C647.7,658.7,647.7,658.3,647.5,658.1L647.5,658.1z M648.9,656.9l-0.3-0.4c-0.2-0.2-0.6-0.3-0.9-0.1c-0.3,0.2-0.3,0.6-0.1,0.9 l0.3,0.4c0.2,0.3,0.6,0.3,0.8,0.1l0,0C649.1,657.5,649.1,657.1,648.9,656.9L648.9,656.9z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M555.3,519.2C555.3,519.2,555.3,519.2,555.3,519.2L555.3,519.2C555.3,519.2,555.3,519.2,555.3,519.2 C555.3,519.2,555.3,519.2,555.3,519.2z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M555.4,519.4C555.5,519.4,555.4,519.3,555.4,519.4C555.5,519.3,555.4,519.3,555.4,519.4 C555.4,519.3,555.4,519.3,555.4,519.4C555.3,519.3,555.4,519.4,555.4,519.4C555.4,519.4,555.4,519.4,555.4,519.4z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M555.4,519.1L555.4,519.1C555.4,519.1,555.4,519.1,555.4,519.1C555.4,519.1,555.4,519.1,555.4,519.1 C555.4,519.1,555.4,519.1,555.4,519.1z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M555.5,519.8C555.5,519.8,555.5,519.8,555.5,519.8L555.5,519.8L555.5,519.8z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M555.6,519.5C555.6,519.5,555.5,519.5,555.6,519.5c0,0.1,0,0.1,0,0.1C555.6,519.6,555.6,519.5,555.6,519.5 C555.6,519.5,555.6,519.5,555.6,519.5C555.6,519.4,555.6,519.4,555.6,519.5z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M701.6,577.4c0,30.1-12,59-33.2,80.2c-21.3,21.3-50.1,33.2-80.2,33.2c-30.1,0-59-12-80.2-33.2 c-21.3-21.3-33.2-50.1-33.2-80.2c0-30.1,12-59,33.2-80.2c21.3-21.3,50.1-33.2,80.2-33.2c30.1,0,59,12,80.2,33.2 C689.7,518.4,701.6,547.3,701.6,577.4L701.6,577.4z M705.1,577.4c0-31-12.3-60.8-34.2-82.7c-21.9-21.9-51.7-34.2-82.7-34.2 c-31,0-60.7,12.3-82.7,34.2c-21.9,21.9-34.2,51.7-34.2,82.7c0,31,12.3,60.7,34.2,82.7c21.9,21.9,51.7,34.2,82.7,34.2 c31,0,60.7-12.3,82.7-34.2C692.7,638.1,705.1,608.4,705.1,577.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactQr);
export default __webpack_public_path__ + "static/media/contact_qr.6e622ca8db7310b4647c07a87d5b7d12.svg";
export { ForwardRef as ReactComponent };